/* tslint:disable */
/* eslint-disable */
/**
 * MIT Learn API
 * MIT public API
 *
 * The version of the OpenAPI document: 0.0.1 (v1)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from "./common"
import type { RequestArgs } from "./base"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base"

/**
 * * `resource_type` - resource_type * `certification` - certification * `certification_type` - certification_type * `offered_by` - offered_by * `platform` - platform * `topic` - topic * `department` - department * `level` - level * `course_feature` - course_feature * `professional` - professional * `free` - free * `delivery` - delivery * `resource_type_group` - resource_type_group * `resource_category` - resource_category
 */

export const AggregationsEnumDescriptions = {
  resource_type: "resource_type",
  certification: "certification",
  certification_type: "certification_type",
  offered_by: "offered_by",
  platform: "platform",
  topic: "topic",
  department: "department",
  level: "level",
  course_feature: "course_feature",
  professional: "professional",
  free: "free",
  delivery: "delivery",
  resource_type_group: "resource_type_group",
  resource_category: "resource_category",
} as const

export const AggregationsEnum = {
  /**
   * resource_type
   */
  ResourceType: "resource_type",
  /**
   * certification
   */
  Certification: "certification",
  /**
   * certification_type
   */
  CertificationType: "certification_type",
  /**
   * offered_by
   */
  OfferedBy: "offered_by",
  /**
   * platform
   */
  Platform: "platform",
  /**
   * topic
   */
  Topic: "topic",
  /**
   * department
   */
  Department: "department",
  /**
   * level
   */
  Level: "level",
  /**
   * course_feature
   */
  CourseFeature: "course_feature",
  /**
   * professional
   */
  Professional: "professional",
  /**
   * free
   */
  Free: "free",
  /**
   * delivery
   */
  Delivery: "delivery",
  /**
   * resource_type_group
   */
  ResourceTypeGroup: "resource_type_group",
  /**
   * resource_category
   */
  ResourceCategory: "resource_category",
} as const

export type AggregationsEnum =
  (typeof AggregationsEnum)[keyof typeof AggregationsEnum]

/**
 * * `dated` - Dated * `anytime` - Anytime
 */

export const AvailabilityEnumDescriptions = {
  dated: "Dated",
  anytime: "Anytime",
} as const

export const AvailabilityEnum = {
  /**
   * Dated
   */
  Dated: "dated",
  /**
   * Anytime
   */
  Anytime: "anytime",
} as const

export type AvailabilityEnum =
  (typeof AvailabilityEnum)[keyof typeof AvailabilityEnum]

/**
 * Serializer for caption URL entries
 */
export interface CaptionUrl {
  language: string
  language_name: string
  url: string
}
/**
 * Serializer for caption URL entries
 */
export interface CaptionUrlRequest {
  language: string
  language_name: string
  url: string
}
/**
 * * `micromasters` - MicroMasters Credential * `professional` - Professional Certificate * `completion` - Certificate of Completion * `none` - No Certificate
 */

export const CertificationTypeEnumDescriptions = {
  micromasters: "MicroMasters Credential",
  professional: "Professional Certificate",
  completion: "Certificate of Completion",
  none: "No Certificate",
} as const

export const CertificationTypeEnum = {
  /**
   * MicroMasters Credential
   */
  Micromasters: "micromasters",
  /**
   * Professional Certificate
   */
  Professional: "professional",
  /**
   * Certificate of Completion
   */
  Completion: "completion",
  /**
   * No Certificate
   */
  None: "none",
} as const

export type CertificationTypeEnum =
  (typeof CertificationTypeEnum)[keyof typeof CertificationTypeEnum]

/**
 * Serializer class for course run ContentFiles
 */
export interface ContentFile {
  id: number
  run_id?: number
  direct_learning_resource_id?: number | null
  run_title?: string
  run_slug?: string
  departments: Array<LearningResourceDepartment>
  semester?: string
  year?: number
  topics: Array<LearningResourceTopic>
  key?: string | null
  uid?: string | null
  title?: string | null
  description?: string | null
  require_summaries: boolean
  url?: string | null
  content_feature_type: Array<string>
  content_type?: ContentFileContentTypeEnum
  content?: string | null
  content_title?: string | null
  content_author?: string | null
  content_language?: string | null
  checksum?: string
  image_src?: ContentFileImageSrc | null
  resource_id: string
  resource_readable_id: string
  source_path?: string
  /**
   * Extract the course number(s) from the associated course
   */
  course_number: Array<string>
  file_type?: string | null
  file_extension?: string | null
  offered_by: LearningResourceOfferor
  platform: LearningResourcePlatform
  run_readable_id?: string
  edx_module_id?: string | null
  summary?: string
  flashcards?: any
  youtube_id?: string | null
}

/**
 * * `page` - page * `file` - file * `video` - video * `pdf` - pdf
 */

export const ContentFileContentTypeEnumDescriptions = {
  page: "page",
  file: "file",
  video: "video",
  pdf: "pdf",
} as const

export const ContentFileContentTypeEnum = {
  /**
   * page
   */
  Page: "page",
  /**
   * file
   */
  File: "file",
  /**
   * video
   */
  Video: "video",
  /**
   * pdf
   */
  Pdf: "pdf",
} as const

export type ContentFileContentTypeEnum =
  (typeof ContentFileContentTypeEnum)[keyof typeof ContentFileContentTypeEnum]

/**
 * @type ContentFileImageSrc
 */
export type ContentFileImageSrc = string

/**
 * SearchResponseSerializer with OpenAPI annotations for Content Files search
 */
export interface ContentFileSearchResponse {
  count: number
  next: string | null
  previous: string | null
  results: Array<ContentFile>
  metadata: ContentFileSearchResponseMetadata
}
export interface ContentFileSearchResponseMetadata {
  aggregations: {
    [
      key: string
    ]: Array<ContentFileSearchResponseMetadataAggregationsValueInner>
  }
  suggestions: Array<string>
}
export interface ContentFileSearchResponseMetadataAggregationsValueInner {
  key: string
  doc_count: number
}
/**
 * Serializer for ContentFile webhook requests.
 */
export interface ContentFileWebHookRequest {
  content_path?: string
  source: SourceEnum
  course_id?: string | null
  course_readable_id?: string | null
}

/**
 * Serializer for ContentFile webhook requests.
 */
export interface ContentFileWebHookRequestRequest {
  content_path?: string
  source: SourceEnum
  course_id?: string | null
  course_readable_id?: string | null
}

/**
 * Serializer for the Course model
 */
export interface Course {
  course_numbers: Array<CourseNumber> | null
}
/**
 * Serializer for CourseNumber
 */
export interface CourseNumber {
  value: string
  department: LearningResourceDepartment
  listing_type: string
}
/**
 * Serializer for CourseNumber
 */
export interface CourseNumberRequest {
  value: string
  department: LearningResourceDepartmentRequest
  listing_type: string
}
/**
 * Serializer for the Course model
 */
export interface CourseRequest {
  course_numbers: Array<CourseNumberRequest> | null
}
/**
 * Serializer for course resources
 */
export interface CourseResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: CourseResourceResourceTypeEnum
  course: Course
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: CourseResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const CourseResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type CourseResourceAvailabilityEnum =
  (typeof CourseResourceAvailabilityEnum)[keyof typeof CourseResourceAvailabilityEnum]

export interface CourseResourceCertificationType {
  code: CourseResourceCertificationTypeCodeEnum
  name: string
}

export const CourseResourceCertificationTypeCodeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const

export type CourseResourceCertificationTypeCodeEnum =
  (typeof CourseResourceCertificationTypeCodeEnum)[keyof typeof CourseResourceCertificationTypeCodeEnum]

export interface CourseResourceDeliveryInner {
  code: CourseResourceDeliveryInnerCodeEnum
  name: string
}

export const CourseResourceDeliveryInnerCodeEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const

export type CourseResourceDeliveryInnerCodeEnum =
  (typeof CourseResourceDeliveryInnerCodeEnum)[keyof typeof CourseResourceDeliveryInnerCodeEnum]

export interface CourseResourceFormatInner {
  code: CourseResourceFormatInnerCodeEnum
  name: string
}

export const CourseResourceFormatInnerCodeEnum = {
  Synchronous: "synchronous",
  Asynchronous: "asynchronous",
} as const

export type CourseResourceFormatInnerCodeEnum =
  (typeof CourseResourceFormatInnerCodeEnum)[keyof typeof CourseResourceFormatInnerCodeEnum]

export interface CourseResourcePaceInner {
  code: CourseResourcePaceInnerCodeEnum
  name: string
}

export const CourseResourcePaceInnerCodeEnum = {
  SelfPaced: "self_paced",
  InstructorPaced: "instructor_paced",
} as const

export type CourseResourcePaceInnerCodeEnum =
  (typeof CourseResourcePaceInnerCodeEnum)[keyof typeof CourseResourcePaceInnerCodeEnum]

/**
 * Serializer for course resources
 */
export interface CourseResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: CourseResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const CourseResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type CourseResourceRequestAvailabilityEnum =
  (typeof CourseResourceRequestAvailabilityEnum)[keyof typeof CourseResourceRequestAvailabilityEnum]

export const CourseResourceResourceTypeEnumDescriptions = {
  course: "",
} as const

export const CourseResourceResourceTypeEnum = {
  Course: "course",
} as const

export type CourseResourceResourceTypeEnum =
  (typeof CourseResourceResourceTypeEnum)[keyof typeof CourseResourceResourceTypeEnum]

/**
 * * `online` - Online * `hybrid` - Hybrid * `in_person` - In person * `offline` - Offline
 */

export const DeliveryEnumDescriptions = {
  online: "Online",
  hybrid: "Hybrid",
  in_person: "In person",
  offline: "Offline",
} as const

export const DeliveryEnum = {
  /**
   * Online
   */
  Online: "online",
  /**
   * Hybrid
   */
  Hybrid: "hybrid",
  /**
   * In person
   */
  InPerson: "in_person",
  /**
   * Offline
   */
  Offline: "offline",
} as const

export type DeliveryEnum = (typeof DeliveryEnum)[keyof typeof DeliveryEnum]

/**
 * * `1` - Civil and Environmental Engineering * `2` - Mechanical Engineering * `3` - Materials Science and Engineering * `4` - Architecture * `5` - Chemistry * `6` - Electrical Engineering and Computer Science * `7` - Biology * `8` - Physics * `9` - Brain and Cognitive Sciences * `10` - Chemical Engineering * `11` - Urban Studies and Planning * `12` - Earth, Atmospheric, and Planetary Sciences * `14` - Economics * `15` - Management * `16` - Aeronautics and Astronautics * `17` - Political Science * `18` - Mathematics * `20` - Biological Engineering * `21A` - Anthropology * `21G` - Global Languages * `21H` - History * `21L` - Literature * `21M` - Music * `21T` - Theater Arts * `22` - Nuclear Science and Engineering * `24` - Linguistics and Philosophy * `CC` - Concourse * `CMS-W` - Comparative Media Studies/Writing * `EC` - Edgerton Center * `ES` - Experimental Study Group * `ESD` - Engineering Systems Division * `HST` - Medical Engineering and Science * `IDS` - Data, Systems, and Society * `MAS` - Media Arts and Sciences * `PE` - Athletics, Physical Education and Recreation * `SP` - Special Programs * `STS` - Science, Technology, and Society * `WGS` - Women\'s and Gender Studies
 */

export const DepartmentEnumDescriptions = {
  "1": "Civil and Environmental Engineering",
  "2": "Mechanical Engineering",
  "3": "Materials Science and Engineering",
  "4": "Architecture",
  "5": "Chemistry",
  "6": "Electrical Engineering and Computer Science",
  "7": "Biology",
  "8": "Physics",
  "9": "Brain and Cognitive Sciences",
  "10": "Chemical Engineering",
  "11": "Urban Studies and Planning",
  "12": "Earth, Atmospheric, and Planetary Sciences",
  "14": "Economics",
  "15": "Management",
  "16": "Aeronautics and Astronautics",
  "17": "Political Science",
  "18": "Mathematics",
  "20": "Biological Engineering",
  "21A": "Anthropology",
  "21G": "Global Languages",
  "21H": "History",
  "21L": "Literature",
  "21M": "Music",
  "21T": "Theater Arts",
  "22": "Nuclear Science and Engineering",
  "24": "Linguistics and Philosophy",
  CC: "Concourse",
  "CMS-W": "Comparative Media Studies/Writing",
  EC: "Edgerton Center",
  ES: "Experimental Study Group",
  ESD: "Engineering Systems Division",
  HST: "Medical Engineering and Science",
  IDS: "Data, Systems, and Society",
  MAS: "Media Arts and Sciences",
  PE: "Athletics, Physical Education and Recreation",
  SP: "Special Programs",
  STS: "Science, Technology, and Society",
  WGS: "Women's and Gender Studies",
} as const

export const DepartmentEnum = {
  /**
   * Civil and Environmental Engineering
   */
  _1: "1",
  /**
   * Mechanical Engineering
   */
  _2: "2",
  /**
   * Materials Science and Engineering
   */
  _3: "3",
  /**
   * Architecture
   */
  _4: "4",
  /**
   * Chemistry
   */
  _5: "5",
  /**
   * Electrical Engineering and Computer Science
   */
  _6: "6",
  /**
   * Biology
   */
  _7: "7",
  /**
   * Physics
   */
  _8: "8",
  /**
   * Brain and Cognitive Sciences
   */
  _9: "9",
  /**
   * Chemical Engineering
   */
  _10: "10",
  /**
   * Urban Studies and Planning
   */
  _11: "11",
  /**
   * Earth, Atmospheric, and Planetary Sciences
   */
  _12: "12",
  /**
   * Economics
   */
  _14: "14",
  /**
   * Management
   */
  _15: "15",
  /**
   * Aeronautics and Astronautics
   */
  _16: "16",
  /**
   * Political Science
   */
  _17: "17",
  /**
   * Mathematics
   */
  _18: "18",
  /**
   * Biological Engineering
   */
  _20: "20",
  /**
   * Anthropology
   */
  _21A: "21A",
  /**
   * Global Languages
   */
  _21G: "21G",
  /**
   * History
   */
  _21H: "21H",
  /**
   * Literature
   */
  _21L: "21L",
  /**
   * Music
   */
  _21M: "21M",
  /**
   * Theater Arts
   */
  _21T: "21T",
  /**
   * Nuclear Science and Engineering
   */
  _22: "22",
  /**
   * Linguistics and Philosophy
   */
  _24: "24",
  /**
   * Concourse
   */
  Cc: "CC",
  /**
   * Comparative Media Studies/Writing
   */
  CmsW: "CMS-W",
  /**
   * Edgerton Center
   */
  Ec: "EC",
  /**
   * Experimental Study Group
   */
  Es: "ES",
  /**
   * Engineering Systems Division
   */
  Esd: "ESD",
  /**
   * Medical Engineering and Science
   */
  Hst: "HST",
  /**
   * Data, Systems, and Society
   */
  Ids: "IDS",
  /**
   * Media Arts and Sciences
   */
  Mas: "MAS",
  /**
   * Athletics, Physical Education and Recreation
   */
  Pe: "PE",
  /**
   * Special Programs
   */
  Sp: "SP",
  /**
   * Science, Technology, and Society
   */
  Sts: "STS",
  /**
   * Women&#39;s and Gender Studies
   */
  Wgs: "WGS",
} as const

export type DepartmentEnum =
  (typeof DepartmentEnum)[keyof typeof DepartmentEnum]

/**
 * Serializer for document resources
 */
export interface DocumentResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: DocumentResourceResourceTypeEnum
  content_files: Array<NestedContentFile> | null
  description: string | null
  readable_id: string
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: DocumentResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const DocumentResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type DocumentResourceAvailabilityEnum =
  (typeof DocumentResourceAvailabilityEnum)[keyof typeof DocumentResourceAvailabilityEnum]

/**
 * Serializer for document resources
 */
export interface DocumentResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: DocumentResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const DocumentResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type DocumentResourceRequestAvailabilityEnum =
  (typeof DocumentResourceRequestAvailabilityEnum)[keyof typeof DocumentResourceRequestAvailabilityEnum]

export const DocumentResourceResourceTypeEnumDescriptions = {
  document: "",
} as const

export const DocumentResourceResourceTypeEnum = {
  Document: "document",
} as const

export type DocumentResourceResourceTypeEnum =
  (typeof DocumentResourceResourceTypeEnum)[keyof typeof DocumentResourceResourceTypeEnum]

export interface HubspotCollectionResponseFormDefinitionBaseForwardPaging {
  paging?: HubspotCollectionResponseFormDefinitionBaseForwardPagingPaging
  results?: Array<HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItem>
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingPaging {
  next?: HubspotCollectionResponseFormDefinitionBaseForwardPagingPagingNext
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingPagingNext {
  link?: string | null
  after?: string | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItem {
  form_type?: string | null
  id?: string | null
  name?: string | null
  created_at?: string | null
  updated_at?: string | null
  archived?: boolean | null
  archived_at?: string | null
  field_groups?: Array<HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemFieldGroupItem>
  configuration?: HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfiguration
  display_options?: HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemDisplayOptions
  legal_consent_options?: HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemLegalConsentOptions
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfiguration {
  create_new_contact_for_new_email?: boolean | null
  editable?: boolean | null
  allow_link_to_reset_known_values?: boolean | null
  lifecycle_stages?: Array<HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfigurationLifecycleStageItem>
  post_submit_action?: HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfigurationPostSubmitAction
  language?: string | null
  pre_populate_known_values?: boolean | null
  cloneable?: boolean | null
  notify_contact_owner?: boolean | null
  recaptcha_enabled?: boolean | null
  archivable?: boolean | null
  notify_recipients?: Array<string | null>
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfigurationLifecycleStageItem {
  object_type_id?: string | null
  value?: string | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemConfigurationPostSubmitAction {
  type?: string | null
  value?: string | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemDisplayOptions {
  render_raw_html?: boolean | null
  css_class?: string | null
  theme?: string | null
  submit_button_text?: string | null
  style?: HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemDisplayOptionsStyle
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemDisplayOptionsStyle {
  label_text_size?: string | null
  legal_consent_text_color?: string | null
  font_family?: string | null
  legal_consent_text_size?: string | null
  background_width?: string | null
  help_text_size?: string | null
  submit_font_color?: string | null
  label_text_color?: string | null
  submit_alignment?: string | null
  submit_size?: string | null
  help_text_color?: string | null
  submit_color?: string | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemFieldGroupItem {
  group_type?: string | null
  rich_text_type?: string | null
  rich_text?: string | null
  fields?: Array<HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemFieldGroupItemFieldItemTruncated>
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemFieldGroupItemFieldItemTruncated {
  object_type_id?: string | null
  hidden?: boolean | null
  default_value?: string | null
  name?: string | null
  description?: string | null
  label?: string | null
  placeholder?: string | null
  field_type?: string | null
  required?: boolean | null
  use_country_code_select?: boolean | null
  allow_multiple_files?: boolean | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemLegalConsentOptions {
  type?: string | null
  subscription_type_ids?: Array<number | null>
  lawful_basis?: string | null
  privacy_text?: string | null
  communications_checkboxes?: Array<HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemLegalConsentOptionsCommunicationsCheckboxItem>
  communication_consent_text?: string | null
  consent_to_process_checkbox_label?: string | null
  consent_to_process_footer_text?: string | null
  consent_to_process_text?: string | null
}
export interface HubspotCollectionResponseFormDefinitionBaseForwardPagingResultItemLegalConsentOptionsCommunicationsCheckboxItem {
  subscription_type_id?: number | null
  label?: string | null
  required?: boolean | null
}
export interface HubspotFormDefinition {
  form_type?: string | null
  id?: string | null
  name?: string | null
  created_at?: string | null
  updated_at?: string | null
  archived?: boolean | null
  archived_at?: string | null
  field_groups?: Array<HubspotFormDefinitionFieldGroupItem>
  configuration?: HubspotFormDefinitionConfiguration
  display_options?: HubspotFormDefinitionDisplayOptions
  legal_consent_options?: HubspotFormDefinitionLegalConsentOptions
}
export interface HubspotFormDefinitionConfiguration {
  create_new_contact_for_new_email?: boolean | null
  editable?: boolean | null
  allow_link_to_reset_known_values?: boolean | null
  lifecycle_stages?: Array<HubspotFormDefinitionConfigurationLifecycleStageItem>
  post_submit_action?: HubspotFormDefinitionConfigurationPostSubmitAction
  language?: string | null
  pre_populate_known_values?: boolean | null
  cloneable?: boolean | null
  notify_contact_owner?: boolean | null
  recaptcha_enabled?: boolean | null
  archivable?: boolean | null
  notify_recipients?: Array<string | null>
}
export interface HubspotFormDefinitionConfigurationLifecycleStageItem {
  object_type_id?: string | null
  value?: string | null
}
export interface HubspotFormDefinitionConfigurationPostSubmitAction {
  type?: string | null
  value?: string | null
}
export interface HubspotFormDefinitionDisplayOptions {
  render_raw_html?: boolean | null
  css_class?: string | null
  theme?: string | null
  submit_button_text?: string | null
  style?: HubspotFormDefinitionDisplayOptionsStyle
}
export interface HubspotFormDefinitionDisplayOptionsStyle {
  label_text_size?: string | null
  legal_consent_text_color?: string | null
  font_family?: string | null
  legal_consent_text_size?: string | null
  background_width?: string | null
  help_text_size?: string | null
  submit_font_color?: string | null
  label_text_color?: string | null
  submit_alignment?: string | null
  submit_size?: string | null
  help_text_color?: string | null
  submit_color?: string | null
}
export interface HubspotFormDefinitionFieldGroupItem {
  group_type?: string | null
  rich_text_type?: string | null
  rich_text?: string | null
  fields?: Array<HubspotFormDefinitionFieldGroupItemFieldItem>
}
export interface HubspotFormDefinitionFieldGroupItemFieldItem {
  object_type_id?: string | null
  hidden?: boolean | null
  default_value?: string | null
  name?: string | null
  description?: string | null
  label?: string | null
  placeholder?: string | null
  field_type?: string | null
  required?: boolean | null
  validation?: HubspotFormDefinitionFieldGroupItemFieldItemValidation
  use_country_code_select?: boolean | null
  options?: Array<HubspotFormDefinitionFieldGroupItemFieldItemOptionItemTruncated>
  default_values?: Array<string | null>
  allow_multiple_files?: boolean | null
}
export interface HubspotFormDefinitionFieldGroupItemFieldItemOptionItemTruncated {
  display_order?: number | null
  description?: string | null
  label?: string | null
  value?: string | null
}
export interface HubspotFormDefinitionFieldGroupItemFieldItemValidation {
  min_allowed_digits?: number | null
  max_allowed_digits?: number | null
}
export interface HubspotFormDefinitionLegalConsentOptions {
  type?: string | null
  subscription_type_ids?: Array<number | null>
  lawful_basis?: string | null
  privacy_text?: string | null
  communications_checkboxes?: Array<HubspotFormDefinitionLegalConsentOptionsCommunicationsCheckboxItem>
  communication_consent_text?: string | null
  consent_to_process_checkbox_label?: string | null
  consent_to_process_footer_text?: string | null
  consent_to_process_text?: string | null
}
export interface HubspotFormDefinitionLegalConsentOptionsCommunicationsCheckboxItem {
  subscription_type_id?: number | null
  label?: string | null
  required?: boolean | null
}
/**
 * Serializer for individual form field values in submission.
 */
export interface HubspotFormFieldValueRequest {
  name: string
  value: any | null
}
/**
 * Serializer for HubSpot form submission requests.
 */
export interface HubspotFormSubmitRequestRequest {
  fields: Array<HubspotFormFieldValueRequest>
  page_uri?: string
  hutk?: string
  page_name?: string
  submitted_at?: number
  recaptcha_token?: string
  page_title?: string
  timestamp?: number
}
/**
 * Serializer for HubSpot form submission response.
 */
export interface HubspotFormSubmitResponse {
  status?: string
}
/**
 * Serializer for the LearningPath model
 */
export interface LearningPath {
  id: number
  /**
   * Number of published items in the list.
   */
  item_count: number
}
/**
 * Specialized serializer for a LearningPath relationship
 */
export interface LearningPathRelationship {
  id: number
  resource: LearningResource
  position?: number
  parent: number
  child: number
}
/**
 * Create serializer for nested learning path items.  The parent is derived from the nested route and must not be client-supplied.
 */
export interface LearningPathRelationshipCreate {
  id: number
  resource: LearningResource
  position?: number
  parent: number
  child: number
}
/**
 * Create serializer for nested learning path items.  The parent is derived from the nested route and must not be client-supplied.
 */
export interface LearningPathRelationshipCreateRequest {
  position?: number
  child: number
}
/**
 * CRUD serializer for LearningPath resources
 */
export interface LearningPathResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: LearningPathResourceResourceTypeEnum
  /**
   * The display category for this resource.
   */
  resource_category: string
  learning_path: LearningPath
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: LearningPathResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const LearningPathResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningPathResourceAvailabilityEnum =
  (typeof LearningPathResourceAvailabilityEnum)[keyof typeof LearningPathResourceAvailabilityEnum]

/**
 * CRUD serializer for LearningPath resources
 */
export interface LearningPathResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: LearningPathResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const LearningPathResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningPathResourceRequestAvailabilityEnum =
  (typeof LearningPathResourceRequestAvailabilityEnum)[keyof typeof LearningPathResourceRequestAvailabilityEnum]

export const LearningPathResourceResourceTypeEnumDescriptions = {
  learning_path: "",
} as const

export const LearningPathResourceResourceTypeEnum = {
  LearningPath: "learning_path",
} as const

export type LearningPathResourceResourceTypeEnum =
  (typeof LearningPathResourceResourceTypeEnum)[keyof typeof LearningPathResourceResourceTypeEnum]

/**
 * @type LearningResource
 */
export type LearningResource =
  | ({ resource_type: "course" } & CourseResource)
  | ({ resource_type: "document" } & DocumentResource)
  | ({ resource_type: "learning_path" } & LearningPathResource)
  | ({ resource_type: "podcast" } & PodcastResource)
  | ({ resource_type: "podcast_episode" } & PodcastEpisodeResource)
  | ({ resource_type: "program" } & ProgramResource)
  | ({ resource_type: "video" } & VideoResource)
  | ({ resource_type: "video_playlist" } & VideoPlaylistResource)

/**
 * Serializer for LearningResourceDepartment, minus school  The absence of the departments list is to avoid a circular serialization structure.
 */
export interface LearningResourceBaseDepartment {
  department_id: string
  name: string
  channel_url: string | null
}
/**
 * Base serializer for LearningResourceSchool model, minus departments list  The absence of the departments list is to avoid a circular serialization structure.
 */
export interface LearningResourceBaseSchool {
  id: number
  name: string
  url: string
}
/**
 * Base serializer for LearningResourceSchool model, minus departments list  The absence of the departments list is to avoid a circular serialization structure.
 */
export interface LearningResourceBaseSchoolRequest {
  name: string
  url: string
}
/**
 * Serializer for LearningResourceContentTag
 */
export interface LearningResourceContentTag {
  id: number
  name: string
}
/**
 * Full serializer for LearningResourceDepartment, including school
 */
export interface LearningResourceDepartment {
  department_id: string
  name: string
  channel_url: string | null
  school: LearningResourceBaseSchool | null
}
/**
 * Full serializer for LearningResourceDepartment, including school
 */
export interface LearningResourceDepartmentRequest {
  department_id: string
  name: string
}
/**
 * Serializer for the response of the display info endpoint
 */
export interface LearningResourceDisplayInfoResponse {
  /**
   * Title
   */
  title: string
  /**
   * Description
   */
  description: string
  /**
   * Full Description
   */
  full_description: string | null
  /**
   * Website
   */
  url: string
  /**
   * Free
   */
  free: boolean | null
  /**
   * Topics
   */
  topics: Array<string>
  /**
   * Price
   */
  price: string | null
  /**
   * Extra Price Information
   */
  extra_price_info: string | null
  /**
   * Certificate
   */
  certification: string | null
  /**
   * Instructors
   */
  instructors: Array<string> | null
  /**
   * Runs/Sessions
   */
  runs: Array<LearningResourceDisplayInfoResponseRunsInner> | null
  /**
   * Offered By
   */
  offered_by: string | null
  /**
   * Languages
   */
  languages: Array<string> | null
  /**
   * Levels
   */
  levels: Array<string> | null
  /**
   * Departments
   */
  departments: Array<string>
  /**
   * Platform
   */
  platform: string | null
  /**
   * Number of Courses
   */
  number_of_courses: number | null
  /**
   * Number of Programs
   */
  number_of_programs: number | null
  /**
   * Child courses and programs included in this learning resource
   */
  program_courses: Array<ResourceChildSummary> | null
  /**
   * Location
   */
  location: string | null
  /**
   * Starts
   */
  starts: Array<string> | null
  /**
   * Format
   */
  format_type: Array<string> | null
  /**
   * As Taught In
   */
  as_taught_in: Array<string> | null
  /**
   * Duration
   */
  duration: string | null
  id: number
}
export interface LearningResourceDisplayInfoResponseRunsInner {
  location?: string
  start_date?: string
  instructors?: Array<string>
  duration?: string
  price?: string
  format?: Array<string>
}
/**
 * Serializer for LearningResourceImage
 */
export interface LearningResourceImage {
  id: number
  url: string
  description?: string | null
  alt?: string | null
}
/**
 * Serializer for LearningResourceImage
 */
export interface LearningResourceImageRequest {
  url: string
  description?: string | null
  alt?: string | null
}
/**
 * Serializer for LearningResourceInstructor model
 */
export interface LearningResourceInstructor {
  id: number
  first_name?: string | null
  last_name?: string | null
  full_name?: string | null
}
/**
 * Serializer for LearningResourceInstructor model
 */
export interface LearningResourceInstructorRequest {
  first_name?: string | null
  last_name?: string | null
  full_name?: string | null
}
/**
 * Serializer for LearningResourceOfferor with basic details
 */
export interface LearningResourceOfferor {
  code: string
  name: string
  channel_url: string | null
  display_facet?: boolean
}
/**
 * Serializer for LearningResourceOfferor with all details
 */
export interface LearningResourceOfferorDetail {
  code: string
  channel_url: string | null
  name: string
  professional?: boolean
  offerings?: Array<string>
  audience?: Array<string>
  formats?: Array<string>
  fee?: Array<string>
  certifications?: Array<string>
  content_types?: Array<string>
  more_information?: LearningResourceOfferorDetailMoreInformation
  value_prop?: string
  display_facet?: boolean
}
/**
 * @type LearningResourceOfferorDetailMoreInformation
 */
export type LearningResourceOfferorDetailMoreInformation = string

/**
 * Serializer for LearningResourceOfferor with basic details
 */
export interface LearningResourceOfferorRequest {
  code: string
  name: string
  display_facet?: boolean
}
/**
 * Serializer for LearningResourcePlatform
 */
export interface LearningResourcePlatform {
  code: string
  name?: string
}
/**
 * Serializer for LearningResourcePlatform
 */
export interface LearningResourcePlatformRequest {
  code: string
  name?: string
}
/**
 * Serializer for LearningResourcePrice model
 */
export interface LearningResourcePrice {
  amount: string
  currency: string
}
/**
 * Serializer for LearningResourcePrice model
 */
export interface LearningResourcePriceRequest {
  amount: string
  currency: string
}
/**
 * CRUD serializer for LearningResourceRelationship
 */
export interface LearningResourceRelationship {
  id: number
  resource: LearningResource
  position?: number
  relation_type?: RelationTypeEnum
  parent: number
  child: number
}

/**
 * Serializer field for the LearningResourceRelationship model that uses the LearningResourceSerializer to serialize the child resources
 */
export interface LearningResourceRelationshipChildField {
  child: number
  position?: number
  relation_type?: RelationTypeEnum
  title: string
  readable_id: string
}

/**
 * @type LearningResourceRequest
 */
export type LearningResourceRequest =
  | ({ resource_type: "course" } & CourseResourceRequest)
  | ({ resource_type: "document" } & DocumentResourceRequest)
  | ({ resource_type: "learning_path" } & LearningPathResourceRequest)
  | ({ resource_type: "podcast" } & PodcastResourceRequest)
  | ({ resource_type: "podcast_episode" } & PodcastEpisodeResourceRequest)
  | ({ resource_type: "program" } & ProgramResourceRequest)
  | ({ resource_type: "video" } & VideoResourceRequest)
  | ({ resource_type: "video_playlist" } & VideoPlaylistResourceRequest)

/**
 * Serializer for the LearningResourceRun model
 */
export interface LearningResourceRun {
  id: number
  instructors: Array<LearningResourceInstructor> | null
  image: LearningResourceImage | null
  level: Array<LearningResourceRunLevelInner>
  delivery: Array<CourseResourceDeliveryInner>
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  resource_prices: Array<LearningResourcePrice>
  run_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  slug?: string | null
  semester?: string | null
  year?: number | null
  start_date?: string | null
  end_date?: string | null
  enrollment_start?: string | null
  enrollment_end?: string | null
  prices?: Array<string> | null
  checksum?: string | null
  availability?: LearningResourceRunAvailabilityEnum | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const LearningResourceRunAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningResourceRunAvailabilityEnum =
  (typeof LearningResourceRunAvailabilityEnum)[keyof typeof LearningResourceRunAvailabilityEnum]

export interface LearningResourceRunLevelInner {
  code: LearningResourceRunLevelInnerCodeEnum
  name: string
}

export const LearningResourceRunLevelInnerCodeEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const

export type LearningResourceRunLevelInnerCodeEnum =
  (typeof LearningResourceRunLevelInnerCodeEnum)[keyof typeof LearningResourceRunLevelInnerCodeEnum]

/**
 * Serializer for the LearningResourceRun model
 */
export interface LearningResourceRunRequest {
  level: Array<LearningResourceRunLevelInner>
  run_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  slug?: string | null
  semester?: string | null
  year?: number | null
  start_date?: string | null
  end_date?: string | null
  enrollment_start?: string | null
  enrollment_end?: string | null
  prices?: Array<string> | null
  checksum?: string | null
  availability?: LearningResourceRunRequestAvailabilityEnum | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const LearningResourceRunRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningResourceRunRequestAvailabilityEnum =
  (typeof LearningResourceRunRequestAvailabilityEnum)[keyof typeof LearningResourceRunRequestAvailabilityEnum]

/**
 * Serializer for LearningResourceSchool model, including list of departments
 */
export interface LearningResourceSchool {
  id: number
  name: string
  url: string
  departments: Array<LearningResourceBaseDepartment>
}
/**
 * Minimal serializer for LearningResource - returns only essential fields for sitemap generation and other use cases requiring minimal data transfer.
 */
export interface LearningResourceSummary {
  id: number
  last_modified?: string | null
  url?: string | null
  title: string
  resource_type: LearningResourceSummaryResourceTypeEnum
  /**
   * Ids of the parents that form part of this resource\'s URL: the parent podcasts of a podcast episode, the playlists of a video. Empty for every other resource type. Parents are not filtered by `published`, so an id here may belong to a resource this endpoint will not return.
   */
  canonical_parent_ids: Array<number>
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
}

/**
 * * `course` - Course * `program` - Program * `learning_path` - Learning Path * `podcast` - Podcast * `podcast_episode` - Podcast Episode * `video` - Video * `video_playlist` - Video Playlist * `document` - Document
 */

export const LearningResourceSummaryResourceTypeEnumDescriptions = {
  course: "Course",
  program: "Program",
  learning_path: "Learning Path",
  podcast: "Podcast",
  podcast_episode: "Podcast Episode",
  video: "Video",
  video_playlist: "Video Playlist",
  document: "Document",
} as const

export const LearningResourceSummaryResourceTypeEnum = {
  /**
   * Course
   */
  Course: "course",
  /**
   * Program
   */
  Program: "program",
  /**
   * Learning Path
   */
  LearningPath: "learning_path",
  /**
   * Podcast
   */
  Podcast: "podcast",
  /**
   * Podcast Episode
   */
  PodcastEpisode: "podcast_episode",
  /**
   * Video
   */
  Video: "video",
  /**
   * Video Playlist
   */
  VideoPlaylist: "video_playlist",
  /**
   * Document
   */
  Document: "document",
} as const

export type LearningResourceSummaryResourceTypeEnum =
  (typeof LearningResourceSummaryResourceTypeEnum)[keyof typeof LearningResourceSummaryResourceTypeEnum]

/**
 * An (etl_source, resource_type) pair a learning_resources webhook batch is authoritative for. Only types whose loader prunes by source can be synced: videos are never pruned.
 */
export interface LearningResourceSyncPairRequest {
  etl_source: string
  resource_type: LearningResourceSyncPairResourceTypeEnum
}

/**
 * * `course` - course * `program` - program * `document` - document
 */

export const LearningResourceSyncPairResourceTypeEnumDescriptions = {
  course: "course",
  program: "program",
  document: "document",
} as const

export const LearningResourceSyncPairResourceTypeEnum = {
  /**
   * course
   */
  Course: "course",
  /**
   * program
   */
  Program: "program",
  /**
   * document
   */
  Document: "document",
} as const

export type LearningResourceSyncPairResourceTypeEnum =
  (typeof LearningResourceSyncPairResourceTypeEnum)[keyof typeof LearningResourceSyncPairResourceTypeEnum]

/**
 * Serializer for LearningResourceTopic model
 */
export interface LearningResourceTopic {
  id: number
  name: string
  /**
   * The icon to display for the topic.
   */
  icon?: string
  parent?: number | null
  channel_url: string | null
}
/**
 * Serializer for the generic ``/api/v1/webhooks/learning_resources/`` endpoint.  Accepts a batch of pre-computed canonical LearningResource payloads pushed from the OL Data Platform (Dagster). Each resource must carry at minimum ``readable_id``, ``etl_source`` and ``resource_type`` so the handler can route it to the correct loader; all other keys are preserved and passed through to the loaders unchanged.  ``sync`` declares (etl_source, resource_type) pairs the batch is authoritative for. A declared pair with no resources in the batch is pruned, unpublishing everything MIT Learn holds for it, so a source that stops publishing a type can say so. A batch with neither resources nor ``sync`` is rejected: it names no pair, so the request would silently no-op.
 */
export interface LearningResourceWebhookRequestRequest {
  resources: Array<{ [key: string]: any }>
  sync?: Array<LearningResourceSyncPairRequest>
}
/**
 * Serializer for learning_resources webhook responses.  ``shadow`` is present when the batch was a shadow run: nothing was written, and each entry counts what loading it would have changed for one (etl_source, resource_type).
 */
export interface LearningResourceWebhookResponse {
  status: string
  message?: string
  error?: string
  shadow?: Array<ShadowRunResult>
}
/**
 * SearchResponseSerializer with OpenAPI annotations for Learning Resources search
 */
export interface LearningResourcesSearchResponse {
  count: number
  next: string | null
  previous: string | null
  results: Array<LearningResource>
  metadata: ContentFileSearchResponseMetadata
}
/**
 * * `undergraduate` - Undergraduate * `graduate` - Graduate * `high_school` - High School * `noncredit` - Non-Credit * `advanced` - Advanced * `intermediate` - Intermediate * `introductory` - Introductory
 */

export const LevelEnumDescriptions = {
  undergraduate: "Undergraduate",
  graduate: "Graduate",
  high_school: "High School",
  noncredit: "Non-Credit",
  advanced: "Advanced",
  intermediate: "Intermediate",
  introductory: "Introductory",
} as const

export const LevelEnum = {
  /**
   * Undergraduate
   */
  Undergraduate: "undergraduate",
  /**
   * Graduate
   */
  Graduate: "graduate",
  /**
   * High School
   */
  HighSchool: "high_school",
  /**
   * Non-Credit
   */
  Noncredit: "noncredit",
  /**
   * Advanced
   */
  Advanced: "advanced",
  /**
   * Intermediate
   */
  Intermediate: "intermediate",
  /**
   * Introductory
   */
  Introductory: "introductory",
} as const

export type LevelEnum = (typeof LevelEnum)[keyof typeof LevelEnum]

export interface MediaUpload201Response {
  url?: string
}
/**
 * Serializer containing only parent and child ids for a learning path relationship
 */
export interface MicroLearningPathRelationship {
  id: number
  /**
   * The id of the parent learning resource
   */
  parent: number
  child: number
}
/**
 * Serializer containing only parent and child ids for a user list relationship
 */
export interface MicroUserListRelationship {
  id: number
  /**
   * The id of the parent learning resource
   */
  parent: number
  child: number
}
/**
 * ContentFileSerializer without the large text fields (content, summary, flashcards), for nesting inside learning resource API responses. The search indexing path re-adds full content where needed.
 */
export interface NestedContentFile {
  id: number
  run_id?: number
  direct_learning_resource_id?: number | null
  run_title?: string
  run_slug?: string
  departments: Array<LearningResourceDepartment>
  semester?: string
  year?: number
  topics: Array<LearningResourceTopic>
  key?: string | null
  uid?: string | null
  title?: string | null
  description?: string | null
  require_summaries: boolean
  url?: string | null
  content_feature_type: Array<string>
  content_type?: ContentFileContentTypeEnum
  content_title?: string | null
  content_author?: string | null
  content_language?: string | null
  checksum?: string
  image_src?: ContentFileImageSrc | null
  resource_id: string
  resource_readable_id: string
  source_path?: string
  /**
   * Extract the course number(s) from the associated course
   */
  course_number: Array<string>
  file_type?: string | null
  file_extension?: string | null
  offered_by: LearningResourceOfferor
  platform: LearningResourcePlatform
  run_readable_id?: string
  edx_module_id?: string | null
  youtube_id?: string | null
}

export const NullEnumDescriptions = {} as const

export const NullEnum = {} as const

export type NullEnum = (typeof NullEnum)[keyof typeof NullEnum]

/**
 * Serializer for OVS video webhook requests.  Accepts either an OVS video upsert payload (full result dict from the OVS public videos API; `key` is required) or a delete payload (`video_id` plus `delete: true`).
 */
export interface OVSVideoWebhookRequestRequest {
  key?: string
  video_id?: string
  delete?: boolean
}
/**
 * * `mitx` - MITx * `ocw` - MIT OpenCourseWare * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education * `climate` - MIT Climate
 */

export const OfferedByEnumDescriptions = {
  mitx: "MITx",
  ocw: "MIT OpenCourseWare",
  bootcamps: "Bootcamps",
  xpro: "MIT xPRO",
  mitpe: "MIT Professional Education",
  see: "MIT Sloan Executive Education",
  climate: "MIT Climate",
} as const

export const OfferedByEnum = {
  /**
   * MITx
   */
  Mitx: "mitx",
  /**
   * MIT OpenCourseWare
   */
  Ocw: "ocw",
  /**
   * Bootcamps
   */
  Bootcamps: "bootcamps",
  /**
   * MIT xPRO
   */
  Xpro: "xpro",
  /**
   * MIT Professional Education
   */
  Mitpe: "mitpe",
  /**
   * MIT Sloan Executive Education
   */
  See: "see",
  /**
   * MIT Climate
   */
  Climate: "climate",
} as const

export type OfferedByEnum = (typeof OfferedByEnum)[keyof typeof OfferedByEnum]

export interface PaginatedContentFileList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ContentFile>
}
export interface PaginatedCourseResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<CourseResource>
}
export interface PaginatedLearningPathRelationshipList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningPathRelationship>
}
export interface PaginatedLearningPathResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningPathResource>
}
export interface PaginatedLearningResourceContentTagList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceContentTag>
}
export interface PaginatedLearningResourceDepartmentList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceDepartment>
}
export interface PaginatedLearningResourceDisplayInfoResponseList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceDisplayInfoResponse>
}
export interface PaginatedLearningResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResource>
}
export interface PaginatedLearningResourceOfferorDetailList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceOfferorDetail>
}
export interface PaginatedLearningResourcePlatformList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourcePlatform>
}
export interface PaginatedLearningResourceRelationshipList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceRelationship>
}
export interface PaginatedLearningResourceSchoolList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceSchool>
}
export interface PaginatedLearningResourceSummaryList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceSummary>
}
export interface PaginatedLearningResourceTopicList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResourceTopic>
}
export interface PaginatedPodcastEpisodeResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<PodcastEpisodeResource>
}
export interface PaginatedPodcastResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<PodcastResource>
}
export interface PaginatedProgramResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<ProgramResource>
}
export interface PaginatedUserListList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<UserList>
}
export interface PaginatedUserListRelationshipList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<UserListRelationship>
}
export interface PaginatedVideoPlaylistResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<VideoPlaylistResource>
}
export interface PaginatedVideoResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<VideoResource>
}
export interface PaginatedWebsiteContentList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<WebsiteContent>
}
/**
 * Create serializer for nested learning path items.  The parent is derived from the nested route and must not be client-supplied.
 */
export interface PatchedLearningPathRelationshipCreateRequest {
  position?: number
  child?: number
}
/**
 * CRUD serializer for LearningPath resources
 */
export interface PatchedLearningPathResourceRequest {
  topics?: Array<LearningResourceTopic>
  title?: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: PatchedLearningPathResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const PatchedLearningPathResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PatchedLearningPathResourceRequestAvailabilityEnum =
  (typeof PatchedLearningPathResourceRequestAvailabilityEnum)[keyof typeof PatchedLearningPathResourceRequestAvailabilityEnum]

/**
 * CRUD serializer for LearningResourceRelationship
 */
export interface PatchedLearningResourceRelationshipRequest {
  position?: number
  relation_type?: RelationTypeEnum
  parent?: number
  child?: number
}

/**
 * Serializer for UserListRelationship model
 */
export interface PatchedUserListRelationshipRequest {
  position?: number
  parent?: number
  child?: number
}
/**
 * Simplified serializer for UserList model.
 */
export interface PatchedUserListRequest {
  topics?: Array<LearningResourceTopic>
  title?: string
  description?: string
  privacy_level?: PrivacyLevelEnum
}

/**
 * Serializer for WebsiteContent model.
 */
export interface PatchedWebsiteContentRequest {
  title?: string
  author_name?: string
  content?: any
  content_type?: WebsiteContentContentTypeEnum
  is_published?: boolean
  slug?: PatchedWebsiteContentRequestSlug
  topics?: Array<number>
  seo_title_override?: string
  seo_description_override?: string
}

/**
 * @type PatchedWebsiteContentRequestSlug
 */
export type PatchedWebsiteContentRequestSlug = string

/**
 * Serializer for PercolateQuery objects
 */
export interface PercolateQuery {
  id: number
  source_description: string
  source_label: string
  original_query: any
  query: any
  source_type: SourceTypeEnum
  /**
   * Friendly display label for the query
   */
  display_label?: string
}

/**
 * PercolateQuerySubscriptionRequestSerializer with OpenAPI annotations for Percolate Subscription requests
 */
export interface PercolateQuerySubscriptionRequestRequest {
  /**
   * The search text
   */
  q?: string
  /**
   * The initial index from which to return the results
   */
  offset?: number
  /**
   * Number of results to return per page
   */
  limit?: number
  /**
   * The organization that offers the learning resource               * `mitx` - MITx * `ocw` - MIT OpenCourseWare * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education * `climate` - MIT Climate
   */
  offered_by?: Array<OfferedByEnum>
  /**
   * The platform on which the learning resource is offered               * `edx` - edX * `ocw` - MIT OpenCourseWare * `oll` - Open Learning Library * `mitxonline` - MITx Online * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `csail` - CSAIL * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education * `scc` - Schwarzman College of Computing * `ctl` - Center for Transportation & Logistics * `whu` - WHU * `susskind` - Susskind * `globalalumni` - Global Alumni * `simplilearn` - Simplilearn * `emeritus` - Emeritus * `podcast` - Podcast * `youtube` - YouTube * `canvas` - Canvas * `climate` - MIT Climate * `ovs` - ODL Video Service
   */
  platform?: Array<PlatformEnum>
  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  topic?: Array<string>
  /**
   * The ocw topic name.
   */
  ocw_topic?: Array<string>
  /**
   * If true return raw open search results with score explanations
   */
  dev_mode?: boolean | null
  /**
   * The id value for the learning resource
   */
  id?: Array<number>
  /**
   * If the parameter starts with \'-\' the sort is in descending order  * `featured` - Featured * `id` - Object ID ascending * `-id` - Object ID descending * `readable_id` - Readable ID ascending * `-readable_id` - Readable ID descending * `last_modified` - Last Modified Date ascending * `-last_modified` - Last Modified Date descending * `new` - Newest resources first * `start_date` - Start Date ascending * `-start_date` - Start Date descending * `mitcoursenumber` - MIT course number ascending * `-mitcoursenumber` - MIT course number descending * `views` - Popularity ascending * `-views` - Popularity descending * `upcoming` - Next start date ascending
   */
  sortby?: SortbyEnum
  /**
   * The type of learning resource               * `course` - course * `program` - program * `learning_path` - learning path * `podcast` - podcast * `podcast_episode` - podcast episode * `video` - video * `video_playlist` - video playlist * `document` - document
   */
  resource_type?: Array<PercolateQuerySubscriptionRequestResourceTypeEnum>
  free?: boolean | null
  professional?: boolean | null
  /**
   * Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
   */
  yearly_decay_percent?: number | null
  /**
   * True if the learning resource offers a certificate
   */
  certification?: boolean | null
  /**
   * The type of certificate               * `micromasters` - MicroMasters Credential * `professional` - Professional Certificate * `completion` - Certificate of Completion * `none` - No Certificate
   */
  certification_type?: Array<CertificationTypeEnum>
  /**
   * The department that offers the learning resource               * `1` - Civil and Environmental Engineering * `2` - Mechanical Engineering * `3` - Materials Science and Engineering * `4` - Architecture * `5` - Chemistry * `6` - Electrical Engineering and Computer Science * `7` - Biology * `8` - Physics * `9` - Brain and Cognitive Sciences * `10` - Chemical Engineering * `11` - Urban Studies and Planning * `12` - Earth, Atmospheric, and Planetary Sciences * `14` - Economics * `15` - Management * `16` - Aeronautics and Astronautics * `17` - Political Science * `18` - Mathematics * `20` - Biological Engineering * `21A` - Anthropology * `21G` - Global Languages * `21H` - History * `21L` - Literature * `21M` - Music * `21T` - Theater Arts * `22` - Nuclear Science and Engineering * `24` - Linguistics and Philosophy * `CC` - Concourse * `CMS-W` - Comparative Media Studies/Writing * `EC` - Edgerton Center * `ES` - Experimental Study Group * `ESD` - Engineering Systems Division * `HST` - Medical Engineering and Science * `IDS` - Data, Systems, and Society * `MAS` - Media Arts and Sciences * `PE` - Athletics, Physical Education and Recreation * `SP` - Special Programs * `STS` - Science, Technology, and Society * `WGS` - Women\'s and Gender Studies
   */
  department?: Array<DepartmentEnum>
  level?: Array<LevelEnum>
  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  course_feature?: Array<string>
  /**
   * Show resource counts by category
   */
  aggregations?: Array<AggregationsEnum>
  /**
   * The delivery options in which the learning resource is offered               * `online` - Online * `hybrid` - Hybrid * `in_person` - In person * `offline` - Offline
   */
  delivery?: Array<DeliveryEnum>
  resource_type_group?: Array<ResourceTypeGroupEnum>
  /**
   * The resource category for the resource
   */
  resource_category?: Array<string>
  /**
   * The open search search type for text queries               * `phrase` - phrase * `best_fields` - best_fields * `most_fields` - most_fields * `hybrid` - hybrid  * `phrase` - phrase * `best_fields` - best_fields * `most_fields` - most_fields * `hybrid` - hybrid
   */
  search_mode?: SearchModeEnum
  /**
   * Allowed distance for phrase search
   */
  slop?: number | null
  /**
   * Minimum score value a text query result needs to have to be displayed
   */
  min_score?: number | null
  /**
   * Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness = 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
   */
  max_incompleteness_penalty?: number | null
  /**
   * Score weight for content file data.  1 is the default. 0 means content files are ignored
   */
  content_file_score_weight?: number | null
  /**
   * Whether to include select OCW content files in search results.
   */
  show_ocw_files?: boolean | null
  /**
   * The subscription type  * `search_subscription_type` - search_subscription_type * `channel_subscription_type` - channel_subscription_type
   */
  source_type?: SourceTypeEnum
}

/**
 * * `course` - course * `program` - program * `learning_path` - learning path * `podcast` - podcast * `podcast_episode` - podcast episode * `video` - video * `video_playlist` - video playlist * `document` - document
 */

export const PercolateQuerySubscriptionRequestResourceTypeEnumDescriptions = {
  course: "course",
  program: "program",
  learning_path: "learning path",
  podcast: "podcast",
  podcast_episode: "podcast episode",
  video: "video",
  video_playlist: "video playlist",
  document: "document",
} as const

export const PercolateQuerySubscriptionRequestResourceTypeEnum = {
  /**
   * course
   */
  Course: "course",
  /**
   * program
   */
  Program: "program",
  /**
   * learning path
   */
  LearningPath: "learning_path",
  /**
   * podcast
   */
  Podcast: "podcast",
  /**
   * podcast episode
   */
  PodcastEpisode: "podcast_episode",
  /**
   * video
   */
  Video: "video",
  /**
   * video playlist
   */
  VideoPlaylist: "video_playlist",
  /**
   * document
   */
  Document: "document",
} as const

export type PercolateQuerySubscriptionRequestResourceTypeEnum =
  (typeof PercolateQuerySubscriptionRequestResourceTypeEnum)[keyof typeof PercolateQuerySubscriptionRequestResourceTypeEnum]

/**
 * * `edx` - edX * `ocw` - MIT OpenCourseWare * `oll` - Open Learning Library * `mitxonline` - MITx Online * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `csail` - CSAIL * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education * `scc` - Schwarzman College of Computing * `ctl` - Center for Transportation & Logistics * `whu` - WHU * `susskind` - Susskind * `globalalumni` - Global Alumni * `simplilearn` - Simplilearn * `emeritus` - Emeritus * `podcast` - Podcast * `youtube` - YouTube * `canvas` - Canvas * `climate` - MIT Climate * `ovs` - ODL Video Service
 */

export const PlatformEnumDescriptions = {
  edx: "edX",
  ocw: "MIT OpenCourseWare",
  oll: "Open Learning Library",
  mitxonline: "MITx Online",
  bootcamps: "Bootcamps",
  xpro: "MIT xPRO",
  csail: "CSAIL",
  mitpe: "MIT Professional Education",
  see: "MIT Sloan Executive Education",
  scc: "Schwarzman College of Computing",
  ctl: "Center for Transportation & Logistics",
  whu: "WHU",
  susskind: "Susskind",
  globalalumni: "Global Alumni",
  simplilearn: "Simplilearn",
  emeritus: "Emeritus",
  podcast: "Podcast",
  youtube: "YouTube",
  canvas: "Canvas",
  climate: "MIT Climate",
  ovs: "ODL Video Service",
} as const

export const PlatformEnum = {
  /**
   * edX
   */
  Edx: "edx",
  /**
   * MIT OpenCourseWare
   */
  Ocw: "ocw",
  /**
   * Open Learning Library
   */
  Oll: "oll",
  /**
   * MITx Online
   */
  Mitxonline: "mitxonline",
  /**
   * Bootcamps
   */
  Bootcamps: "bootcamps",
  /**
   * MIT xPRO
   */
  Xpro: "xpro",
  /**
   * CSAIL
   */
  Csail: "csail",
  /**
   * MIT Professional Education
   */
  Mitpe: "mitpe",
  /**
   * MIT Sloan Executive Education
   */
  See: "see",
  /**
   * Schwarzman College of Computing
   */
  Scc: "scc",
  /**
   * Center for Transportation &amp; Logistics
   */
  Ctl: "ctl",
  /**
   * WHU
   */
  Whu: "whu",
  /**
   * Susskind
   */
  Susskind: "susskind",
  /**
   * Global Alumni
   */
  Globalalumni: "globalalumni",
  /**
   * Simplilearn
   */
  Simplilearn: "simplilearn",
  /**
   * Emeritus
   */
  Emeritus: "emeritus",
  /**
   * Podcast
   */
  Podcast: "podcast",
  /**
   * YouTube
   */
  Youtube: "youtube",
  /**
   * Canvas
   */
  Canvas: "canvas",
  /**
   * MIT Climate
   */
  Climate: "climate",
  /**
   * ODL Video Service
   */
  Ovs: "ovs",
} as const

export type PlatformEnum = (typeof PlatformEnum)[keyof typeof PlatformEnum]

/**
 * Serializer for Podcasts
 */
export interface Podcast {
  id: number
  episode_count: number
  apple_podcasts_url?: string | null
  google_podcasts_url?: string | null
  rss_url?: string | null
}
/**
 * Serializer for PodcastEpisode
 */
export interface PodcastEpisode {
  id: number
  /**
   * Get the podcast id(s) the episode belongs to
   */
  podcasts: Array<number>
  parent_podcasts: Array<PodcastEpisodeParent>
  /**
   * Whether a transcript is available from the transcript endpoint.  The text itself is excluded from this serializer, so this is how a client knows whether to fetch it.
   */
  has_transcript: boolean
  audio_url: string
  episode_link?: string | null
  duration?: string | null
}
/**
 * Minimal parent-podcast summary embedded in an episode.
 */
export interface PodcastEpisodeParent {
  id: number
  title: string
  readable_id: string
  /**
   * Where this podcast lives within Learn
   */
  learn_url: string
}
/**
 * Serializer for PodcastEpisode
 */
export interface PodcastEpisodeRequest {
  audio_url: string
  episode_link?: string | null
  duration?: string | null
}
/**
 * Serializer for podcast episode resources
 */
export interface PodcastEpisodeResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: PodcastEpisodeResourceResourceTypeEnum
  podcast_episode: PodcastEpisode
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: PodcastEpisodeResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const PodcastEpisodeResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastEpisodeResourceAvailabilityEnum =
  (typeof PodcastEpisodeResourceAvailabilityEnum)[keyof typeof PodcastEpisodeResourceAvailabilityEnum]

/**
 * Serializer for podcast episode resources
 */
export interface PodcastEpisodeResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: PodcastEpisodeResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const PodcastEpisodeResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastEpisodeResourceRequestAvailabilityEnum =
  (typeof PodcastEpisodeResourceRequestAvailabilityEnum)[keyof typeof PodcastEpisodeResourceRequestAvailabilityEnum]

export const PodcastEpisodeResourceResourceTypeEnumDescriptions = {
  podcast_episode: "",
} as const

export const PodcastEpisodeResourceResourceTypeEnum = {
  PodcastEpisode: "podcast_episode",
} as const

export type PodcastEpisodeResourceResourceTypeEnum =
  (typeof PodcastEpisodeResourceResourceTypeEnum)[keyof typeof PodcastEpisodeResourceResourceTypeEnum]

/**
 * Serializer for a single podcast episode\'s transcript.  Kept out of PodcastEpisodeSerializer so the text is only ever sent when a client asks for this one episode\'s transcript.
 */
export interface PodcastEpisodeTranscript {
  id: number
  transcript?: string
}
/**
 * Serializer for Podcasts
 */
export interface PodcastRequest {
  episode_count: number
  apple_podcasts_url?: string | null
  google_podcasts_url?: string | null
  rss_url?: string | null
}
/**
 * Serializer for podcast resources
 */
export interface PodcastResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: PodcastResourceResourceTypeEnum
  podcast: Podcast
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: PodcastResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const PodcastResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastResourceAvailabilityEnum =
  (typeof PodcastResourceAvailabilityEnum)[keyof typeof PodcastResourceAvailabilityEnum]

/**
 * Serializer for podcast resources
 */
export interface PodcastResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: PodcastResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const PodcastResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastResourceRequestAvailabilityEnum =
  (typeof PodcastResourceRequestAvailabilityEnum)[keyof typeof PodcastResourceRequestAvailabilityEnum]

export const PodcastResourceResourceTypeEnumDescriptions = {
  podcast: "",
} as const

export const PodcastResourceResourceTypeEnum = {
  Podcast: "podcast",
} as const

export type PodcastResourceResourceTypeEnum =
  (typeof PodcastResourceResourceTypeEnum)[keyof typeof PodcastResourceResourceTypeEnum]

/**
 * * `private` - private * `unlisted` - unlisted
 */

export const PrivacyLevelEnumDescriptions = {
  private: "private",
  unlisted: "unlisted",
} as const

export const PrivacyLevelEnum = {
  /**
   * private
   */
  Private: "private",
  /**
   * unlisted
   */
  Unlisted: "unlisted",
} as const

export type PrivacyLevelEnum =
  (typeof PrivacyLevelEnum)[keyof typeof PrivacyLevelEnum]

/**
 * Serializer for the Program model
 */
export interface Program {
  course_count: number
  program_count: number
}
/**
 * Serializer for Program Letters
 */
export interface ProgramLetter {
  id: string
  template_fields: ProgramLetterTemplateField
  certificate: ProgramLetterCertificate
}
/**
 * The certificate fields the public program letter view needs.  ProgramLetterViewSet is unauthenticated -- anyone holding a letter\'s uuid can read it -- so this exposes only what the letter itself already states: who earned it and which program. The learner\'s email, postal address, date of birth, gender and platform usernames stay behind the authenticated certificate list, which uses ProgramCertificateSerializer.
 */
export interface ProgramLetterCertificate {
  user_full_name?: string
  program_title: string
}
/**
 * Seriializer for program letter template data which is configured in micromasters
 */
export interface ProgramLetterTemplateField {
  id: number
  meta: any
  title: string
  program_id: number
  program_letter_footer: any
  program_letter_footer_text: string
  program_letter_header_text: string
  program_letter_text: string
  program_letter_logo: any
  program_letter_signatories: Array<any>
}
/**
 * Serializer for program resources
 */
export interface ProgramResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: ProgramResourceResourceTypeEnum
  program: Program
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: ProgramResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const ProgramResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type ProgramResourceAvailabilityEnum =
  (typeof ProgramResourceAvailabilityEnum)[keyof typeof ProgramResourceAvailabilityEnum]

/**
 * Serializer for program resources
 */
export interface ProgramResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: ProgramResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const ProgramResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type ProgramResourceRequestAvailabilityEnum =
  (typeof ProgramResourceRequestAvailabilityEnum)[keyof typeof ProgramResourceRequestAvailabilityEnum]

export const ProgramResourceResourceTypeEnumDescriptions = {
  program: "",
} as const

export const ProgramResourceResourceTypeEnum = {
  Program: "program",
} as const

export type ProgramResourceResourceTypeEnum =
  (typeof ProgramResourceResourceTypeEnum)[keyof typeof ProgramResourceResourceTypeEnum]

/**
 * * `PROGRAM_COURSES` - Program Courses * `PROGRAM_PROGRAMS` - Program Programs * `LEARNING_PATH_ITEMS` - Learning Path Items * `PODCAST_EPISODES` - Podcast Episodes * `PLAYLIST_VIDEOS` - Playlist Videos * `COURSE_LEARNING_MATERIALS` - Course Learning Materials
 */

export const RelationTypeEnumDescriptions = {
  PROGRAM_COURSES: "Program Courses",
  PROGRAM_PROGRAMS: "Program Programs",
  LEARNING_PATH_ITEMS: "Learning Path Items",
  PODCAST_EPISODES: "Podcast Episodes",
  PLAYLIST_VIDEOS: "Playlist Videos",
  COURSE_LEARNING_MATERIALS: "Course Learning Materials",
} as const

export const RelationTypeEnum = {
  /**
   * Program Courses
   */
  ProgramCourses: "PROGRAM_COURSES",
  /**
   * Program Programs
   */
  ProgramPrograms: "PROGRAM_PROGRAMS",
  /**
   * Learning Path Items
   */
  LearningPathItems: "LEARNING_PATH_ITEMS",
  /**
   * Podcast Episodes
   */
  PodcastEpisodes: "PODCAST_EPISODES",
  /**
   * Playlist Videos
   */
  PlaylistVideos: "PLAYLIST_VIDEOS",
  /**
   * Course Learning Materials
   */
  CourseLearningMaterials: "COURSE_LEARNING_MATERIALS",
} as const

export type RelationTypeEnum =
  (typeof RelationTypeEnum)[keyof typeof RelationTypeEnum]

/**
 * Serializer for child course/program entries within a program.
 */
export interface ResourceChildSummary {
  title: string
  readable_id: string
  description: string
  resource_type: string
  topics: Array<string>
  parent_program?: string
}
/**
 * * `course` - course * `program` - program * `learning_path` - learning_path * `podcast` - podcast * `podcast_episode` - podcast_episode * `video` - video * `video_playlist` - video_playlist * `document` - document
 */

export const ResourceTypeEnumDescriptions = {
  course: "course",
  program: "program",
  learning_path: "learning_path",
  podcast: "podcast",
  podcast_episode: "podcast_episode",
  video: "video",
  video_playlist: "video_playlist",
  document: "document",
} as const

export const ResourceTypeEnum = {
  /**
   * course
   */
  Course: "course",
  /**
   * program
   */
  Program: "program",
  /**
   * learning_path
   */
  LearningPath: "learning_path",
  /**
   * podcast
   */
  Podcast: "podcast",
  /**
   * podcast_episode
   */
  PodcastEpisode: "podcast_episode",
  /**
   * video
   */
  Video: "video",
  /**
   * video_playlist
   */
  VideoPlaylist: "video_playlist",
  /**
   * document
   */
  Document: "document",
} as const

export type ResourceTypeEnum =
  (typeof ResourceTypeEnum)[keyof typeof ResourceTypeEnum]

/**
 * * `course` - Course * `program` - Program * `learning_material` - Learning Material
 */

export const ResourceTypeGroupEnumDescriptions = {
  course: "Course",
  program: "Program",
  learning_material: "Learning Material",
} as const

export const ResourceTypeGroupEnum = {
  /**
   * Course
   */
  Course: "course",
  /**
   * Program
   */
  Program: "program",
  /**
   * Learning Material
   */
  LearningMaterial: "learning_material",
} as const

export type ResourceTypeGroupEnum =
  (typeof ResourceTypeGroupEnum)[keyof typeof ResourceTypeGroupEnum]

/**
 * * `phrase` - phrase * `best_fields` - best_fields * `most_fields` - most_fields * `hybrid` - hybrid  * `phrase` - phrase * `best_fields` - best_fields * `most_fields` - most_fields * `hybrid` - hybrid
 */

export const SearchModeEnumDescriptions = {
  phrase: "phrase",
  best_fields: "best_fields",
  most_fields: "most_fields",
  hybrid: "hybrid",
} as const

export const SearchModeEnum = {
  /**
   * phrase
   */
  Phrase: "phrase",
  /**
   * best_fields
   */
  BestFields: "best_fields",
  /**
   * most_fields
   */
  MostFields: "most_fields",
  /**
   * hybrid
   */
  Hybrid: "hybrid",
} as const

export type SearchModeEnum =
  (typeof SearchModeEnum)[keyof typeof SearchModeEnum]

/**
 * What a shadow run found for one (etl_source, resource_type), as ETLShadowRun.counts holds it.
 */
export interface ShadowRunCounts {
  items: number
  before: number
  before_published: number
  created: number
  unpublished: number
  republished: number
  updated: number
  unchanged: number
}
/**
 * The shadow run of one (etl_source, resource_type) of a batch. It has ``counts`` when the pair was compared and ``error`` when it was not.
 */
export interface ShadowRunResult {
  etl_source: string
  resource_type: string
  counts?: ShadowRunCounts
  error?: string
}
/**
 * * `featured` - Featured * `id` - Object ID ascending * `-id` - Object ID descending * `readable_id` - Readable ID ascending * `-readable_id` - Readable ID descending * `last_modified` - Last Modified Date ascending * `-last_modified` - Last Modified Date descending * `new` - Newest resources first * `start_date` - Start Date ascending * `-start_date` - Start Date descending * `mitcoursenumber` - MIT course number ascending * `-mitcoursenumber` - MIT course number descending * `views` - Popularity ascending * `-views` - Popularity descending * `upcoming` - Next start date ascending
 */

export const SortbyEnumDescriptions = {
  featured: "Featured",
  id: "Object ID ascending",
  "-id": "Object ID descending",
  readable_id: "Readable ID ascending",
  "-readable_id": "Readable ID descending",
  last_modified: "Last Modified Date ascending",
  "-last_modified": "Last Modified Date descending",
  new: "Newest resources first",
  start_date: "Start Date ascending",
  "-start_date": "Start Date descending",
  mitcoursenumber: "MIT course number ascending",
  "-mitcoursenumber": "MIT course number descending",
  views: "Popularity ascending",
  "-views": "Popularity descending",
  upcoming: "Next start date ascending",
} as const

export const SortbyEnum = {
  /**
   * Featured
   */
  Featured: "featured",
  /**
   * Object ID ascending
   */
  Id: "id",
  /**
   * Object ID descending
   */
  Id2: "-id",
  /**
   * Readable ID ascending
   */
  ReadableId: "readable_id",
  /**
   * Readable ID descending
   */
  ReadableId2: "-readable_id",
  /**
   * Last Modified Date ascending
   */
  LastModified: "last_modified",
  /**
   * Last Modified Date descending
   */
  LastModified2: "-last_modified",
  /**
   * Newest resources first
   */
  New: "new",
  /**
   * Start Date ascending
   */
  StartDate: "start_date",
  /**
   * Start Date descending
   */
  StartDate2: "-start_date",
  /**
   * MIT course number ascending
   */
  Mitcoursenumber: "mitcoursenumber",
  /**
   * MIT course number descending
   */
  Mitcoursenumber2: "-mitcoursenumber",
  /**
   * Popularity ascending
   */
  Views: "views",
  /**
   * Popularity descending
   */
  Views2: "-views",
  /**
   * Next start date ascending
   */
  Upcoming: "upcoming",
} as const

export type SortbyEnum = (typeof SortbyEnum)[keyof typeof SortbyEnum]

/**
 * * `mit_edx` - mit_edx * `mitpe` - mitpe * `mitxonline` - mitxonline * `oll` - oll * `ocw` - ocw * `podcast` - podcast * `mit_climate` - mit_climate * `see` - see * `xpro` - xpro * `youtube` - youtube * `canvas` - canvas * `ovs` - ovs
 */

export const SourceEnumDescriptions = {
  mit_edx: "mit_edx",
  mitpe: "mitpe",
  mitxonline: "mitxonline",
  oll: "oll",
  ocw: "ocw",
  podcast: "podcast",
  mit_climate: "mit_climate",
  see: "see",
  xpro: "xpro",
  youtube: "youtube",
  canvas: "canvas",
  ovs: "ovs",
} as const

export const SourceEnum = {
  /**
   * mit_edx
   */
  MitEdx: "mit_edx",
  /**
   * mitpe
   */
  Mitpe: "mitpe",
  /**
   * mitxonline
   */
  Mitxonline: "mitxonline",
  /**
   * oll
   */
  Oll: "oll",
  /**
   * ocw
   */
  Ocw: "ocw",
  /**
   * podcast
   */
  Podcast: "podcast",
  /**
   * mit_climate
   */
  MitClimate: "mit_climate",
  /**
   * see
   */
  See: "see",
  /**
   * xpro
   */
  Xpro: "xpro",
  /**
   * youtube
   */
  Youtube: "youtube",
  /**
   * canvas
   */
  Canvas: "canvas",
  /**
   * ovs
   */
  Ovs: "ovs",
} as const

export type SourceEnum = (typeof SourceEnum)[keyof typeof SourceEnum]

/**
 * * `search_subscription_type` - search_subscription_type * `channel_subscription_type` - channel_subscription_type
 */

export const SourceTypeEnumDescriptions = {
  search_subscription_type: "search_subscription_type",
  channel_subscription_type: "channel_subscription_type",
} as const

export const SourceTypeEnum = {
  /**
   * search_subscription_type
   */
  SearchSubscriptionType: "search_subscription_type",
  /**
   * channel_subscription_type
   */
  ChannelSubscriptionType: "channel_subscription_type",
} as const

export type SourceTypeEnum =
  (typeof SourceTypeEnum)[keyof typeof SourceTypeEnum]

export interface UnsubscribeCreate400Response {
  error?: string
}
export interface User {
  first_name?: string
  last_name?: string
}
/**
 * Simplified serializer for UserList model.
 */
export interface UserList {
  id: number
  topics?: Array<LearningResourceTopic>
  /**
   * Number of published items in the list.
   */
  item_count: number
  /**
   * Return the image of the first item
   */
  image: { [key: string]: any }
  title: string
  description?: string
  privacy_level?: PrivacyLevelEnum
  author: number
}

/**
 * Serializer for UserListRelationship model
 */
export interface UserListRelationship {
  id: number
  resource: LearningResource
  position?: number
  parent: number
  child: number
}
/**
 * Serializer for UserListRelationship model
 */
export interface UserListRelationshipRequest {
  position?: number
  parent: number
  child: number
}
/**
 * Simplified serializer for UserList model.
 */
export interface UserListRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string
  privacy_level?: PrivacyLevelEnum
}

export interface UserRequest {
  first_name?: string
  last_name?: string
}
/**
 * Serializer for the Video model
 */
export interface Video {
  id: number
  caption_urls: Array<CaptionUrl>
  streaming_url: VideoStreamingUrl | null
  cover_image_url: VideoStreamingUrl | null
  duration: string
}
/**
 * Serializer for the VideoChannel model
 */
export interface VideoChannel {
  channel_id: string
  title: string
}
/**
 * Serializer for the VideoChannel model
 */
export interface VideoChannelRequest {
  channel_id: string
  title: string
}
/**
 * Serializer for the VideoPlaylist model
 */
export interface VideoPlaylist {
  id: number
  channel: VideoChannel | null
  video_count: number
  parent_learning_resource_id: number | null
  parent_title: string | null
  parent_url: string | null
  /**
   * Extract the course number(s) from the parent course, if any
   */
  parent_course_numbers: Array<string>
}
/**
 * Serializer for the VideoPlaylist model
 */
export interface VideoPlaylistRequest {
  video_count: number
}
/**
 * Serializer for video playlist resources
 */
export interface VideoPlaylistResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: VideoPlaylistResourceResourceTypeEnum
  video_playlist: VideoPlaylist
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: VideoPlaylistResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const VideoPlaylistResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoPlaylistResourceAvailabilityEnum =
  (typeof VideoPlaylistResourceAvailabilityEnum)[keyof typeof VideoPlaylistResourceAvailabilityEnum]

/**
 * Serializer for video playlist resources
 */
export interface VideoPlaylistResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: VideoPlaylistResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const VideoPlaylistResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoPlaylistResourceRequestAvailabilityEnum =
  (typeof VideoPlaylistResourceRequestAvailabilityEnum)[keyof typeof VideoPlaylistResourceRequestAvailabilityEnum]

export const VideoPlaylistResourceResourceTypeEnumDescriptions = {
  video_playlist: "",
} as const

export const VideoPlaylistResourceResourceTypeEnum = {
  VideoPlaylist: "video_playlist",
} as const

export type VideoPlaylistResourceResourceTypeEnum =
  (typeof VideoPlaylistResourceResourceTypeEnum)[keyof typeof VideoPlaylistResourceResourceTypeEnum]

/**
 * Serializer for the Video model
 */
export interface VideoRequest {
  duration: string
}
/**
 * Serializer for video resources
 */
export interface VideoResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: VideoResourceResourceTypeEnum
  video: Video | null
  /**
   * Get the playlist id(s) the video belongs to
   */
  playlists: Array<string>
  content_files: Array<NestedContentFile> | null
  description: string | null
  readable_id: string
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: VideoResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const VideoResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoResourceAvailabilityEnum =
  (typeof VideoResourceAvailabilityEnum)[keyof typeof VideoResourceAvailabilityEnum]

/**
 * Serializer for video resources
 */
export interface VideoResourceRequest {
  topics?: Array<LearningResourceTopic>
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  next_start_date?: string | null
  availability?: VideoResourceRequestAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const VideoResourceRequestAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoResourceRequestAvailabilityEnum =
  (typeof VideoResourceRequestAvailabilityEnum)[keyof typeof VideoResourceRequestAvailabilityEnum]

export const VideoResourceResourceTypeEnumDescriptions = {
  video: "",
} as const

export const VideoResourceResourceTypeEnum = {
  Video: "video",
} as const

export type VideoResourceResourceTypeEnum =
  (typeof VideoResourceResourceTypeEnum)[keyof typeof VideoResourceResourceTypeEnum]

/**
 * @type VideoStreamingUrl
 */
export type VideoStreamingUrl = string

/**
 * Serializer for webhook responses.
 */
export interface WebhookResponse {
  status: string
  message?: string
  error?: string
}
/**
 * Serializer for WebsiteContent model.
 */
export interface WebsiteContent {
  id: number
  title: string
  author_name?: string
  content?: any
  content_type?: WebsiteContentContentTypeEnum
  user: User
  created_on: string
  updated_on: string
  publish_date: string
  is_published?: boolean
  slug?: PatchedWebsiteContentRequestSlug
  cover_image: WebsiteContentCoverImage
  topics?: Array<number>
  seo_title_override?: string
  seo_description_override?: string
  seo_title: string
  seo_description: string
}

/**
 * * `news` - News * `article` - Article
 */

export const WebsiteContentContentTypeEnumDescriptions = {
  news: "News",
  article: "Article",
} as const

export const WebsiteContentContentTypeEnum = {
  /**
   * News
   */
  News: "news",
  /**
   * Article
   */
  Article: "article",
} as const

export type WebsiteContentContentTypeEnum =
  (typeof WebsiteContentContentTypeEnum)[keyof typeof WebsiteContentContentTypeEnum]

/**
 * @type WebsiteContentCoverImage
 */
export type WebsiteContentCoverImage = string

/**
 * Serializer for WebsiteContent model.
 */
export interface WebsiteContentRequest {
  title: string
  author_name?: string
  content?: any
  content_type?: WebsiteContentContentTypeEnum
  is_published?: boolean
  slug?: PatchedWebsiteContentRequestSlug
  topics?: Array<number>
  seo_title_override?: string
  seo_description_override?: string
}

/**
 * ArticlesApi - axios parameter creator
 */
export const ArticlesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {WebsiteContentRequest} WebsiteContentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesCreate: async (
      WebsiteContentRequest: WebsiteContentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'WebsiteContentRequest' is not null or undefined
      assertParamExists(
        "articlesCreate",
        "WebsiteContentRequest",
        WebsiteContentRequest,
      )
      const localVarPath = `/api/v1/articles/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        WebsiteContentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("articlesDestroy", "id", id)
      const localVarPath = `/api/v1/articles/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {string} identifier Numeric ID or slug of the content item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesDetailRetrieve: async (
      identifier: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'identifier' is not null or undefined
      assertParamExists("articlesDetailRetrieve", "identifier", identifier)
      const localVarPath = `/api/v1/articles/detail/{identifier}/`.replace(
        "{identifier}",
        encodeURIComponent(String(identifier)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {ArticlesListContentTypeEnum} [content_type] Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
     * @param {boolean} [draft] Filter to show only draft (unpublished) items
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesList: async (
      content_type?: ArticlesListContentTypeEnum,
      draft?: boolean,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/articles/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_type !== undefined) {
        localVarQueryParameter["content_type"] = content_type
      }

      if (draft !== undefined) {
        localVarQueryParameter["draft"] = draft
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update a content item
     * @summary Update
     * @param {number} id A unique integer value identifying this website content.
     * @param {PatchedWebsiteContentRequest} [PatchedWebsiteContentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesPartialUpdate: async (
      id: number,
      PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("articlesPartialUpdate", "id", id)
      const localVarPath = `/api/v1/articles/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedWebsiteContentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("articlesRetrieve", "id", id)
      const localVarPath = `/api/v1/articles/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ArticlesApi - functional programming interface
 */
export const ArticlesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ArticlesApiAxiosParamCreator(configuration)
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {WebsiteContentRequest} WebsiteContentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesCreate(
      WebsiteContentRequest: WebsiteContentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.articlesCreate(
        WebsiteContentRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesDestroy(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.articlesDestroy(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {string} identifier Numeric ID or slug of the content item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesDetailRetrieve(
      identifier: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.articlesDetailRetrieve(
          identifier,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesDetailRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {ArticlesListContentTypeEnum} [content_type] Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
     * @param {boolean} [draft] Filter to show only draft (unpublished) items
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesList(
      content_type?: ArticlesListContentTypeEnum,
      draft?: boolean,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedWebsiteContentList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.articlesList(
        content_type,
        draft,
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update a content item
     * @summary Update
     * @param {number} id A unique integer value identifying this website content.
     * @param {PatchedWebsiteContentRequest} [PatchedWebsiteContentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesPartialUpdate(
      id: number,
      PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.articlesPartialUpdate(
          id,
          PatchedWebsiteContentRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async articlesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.articlesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ArticlesApi.articlesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ArticlesApi - factory interface
 */
export const ArticlesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ArticlesApiFp(configuration)
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {ArticlesApiArticlesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesCreate(
      requestParameters: ArticlesApiArticlesCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .articlesCreate(requestParameters.WebsiteContentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {ArticlesApiArticlesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesDestroy(
      requestParameters: ArticlesApiArticlesDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .articlesDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {ArticlesApiArticlesDetailRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesDetailRetrieve(
      requestParameters: ArticlesApiArticlesDetailRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .articlesDetailRetrieve(requestParameters.identifier, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {ArticlesApiArticlesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesList(
      requestParameters: ArticlesApiArticlesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedWebsiteContentList> {
      return localVarFp
        .articlesList(
          requestParameters.content_type,
          requestParameters.draft,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Update a content item
     * @summary Update
     * @param {ArticlesApiArticlesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesPartialUpdate(
      requestParameters: ArticlesApiArticlesPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .articlesPartialUpdate(
          requestParameters.id,
          requestParameters.PatchedWebsiteContentRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {ArticlesApiArticlesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    articlesRetrieve(
      requestParameters: ArticlesApiArticlesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .articlesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for articlesCreate operation in ArticlesApi.
 */
export interface ArticlesApiArticlesCreateRequest {
  readonly WebsiteContentRequest: WebsiteContentRequest
}

/**
 * Request parameters for articlesDestroy operation in ArticlesApi.
 */
export interface ArticlesApiArticlesDestroyRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number
}

/**
 * Request parameters for articlesDetailRetrieve operation in ArticlesApi.
 */
export interface ArticlesApiArticlesDetailRetrieveRequest {
  /**
   * Numeric ID or slug of the content item
   */
  readonly identifier: string
}

/**
 * Request parameters for articlesList operation in ArticlesApi.
 */
export interface ArticlesApiArticlesListRequest {
  /**
   * Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
   */
  readonly content_type?: ArticlesListContentTypeEnum

  /**
   * Filter to show only draft (unpublished) items
   */
  readonly draft?: boolean

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for articlesPartialUpdate operation in ArticlesApi.
 */
export interface ArticlesApiArticlesPartialUpdateRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number

  readonly PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest
}

/**
 * Request parameters for articlesRetrieve operation in ArticlesApi.
 */
export interface ArticlesApiArticlesRetrieveRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number
}

/**
 * ArticlesApi - object-oriented interface
 */
export class ArticlesApi extends BaseAPI {
  /**
   * Create a new content item
   * @summary Create
   * @param {ArticlesApiArticlesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesCreate(
    requestParameters: ArticlesApiArticlesCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesCreate(requestParameters.WebsiteContentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete a content item
   * @summary Destroy
   * @param {ArticlesApiArticlesDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesDestroy(
    requestParameters: ArticlesApiArticlesDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a content item by numeric ID or slug
   * @summary Retrieve by ID or slug
   * @param {ArticlesApiArticlesDetailRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesDetailRetrieve(
    requestParameters: ArticlesApiArticlesDetailRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesDetailRetrieve(requestParameters.identifier, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of website content items
   * @summary List
   * @param {ArticlesApiArticlesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesList(
    requestParameters: ArticlesApiArticlesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesList(
        requestParameters.content_type,
        requestParameters.draft,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update a content item
   * @summary Update
   * @param {ArticlesApiArticlesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesPartialUpdate(
    requestParameters: ArticlesApiArticlesPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesPartialUpdate(
        requestParameters.id,
        requestParameters.PatchedWebsiteContentRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single content item
   * @summary Retrieve
   * @param {ArticlesApiArticlesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public articlesRetrieve(
    requestParameters: ArticlesApiArticlesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ArticlesApiFp(this.configuration)
      .articlesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const ArticlesListContentTypeEnum = {
  Article: "article",
  News: "news",
} as const
export type ArticlesListContentTypeEnum =
  (typeof ArticlesListContentTypeEnum)[keyof typeof ArticlesListContentTypeEnum]

/**
 * ContentFileSearchApi - axios parameter creator
 */
export const ContentFileSearchApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Search for content files
     * @summary Search
     * @param {Array<ContentFileSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {Array<number>} [id] The id value for the content file
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<ContentFileSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<ContentFileSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {string} [q] The search text
     * @param {Array<number>} [resource_id] The id value of the parent learning resource for the content file
     * @param {Array<number>} [run_id] The id value of the run that the content file belongs to
     * @param {ContentFileSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentFileSearchRetrieve: async (
      aggregations?: Array<ContentFileSearchRetrieveAggregationsEnum>,
      content_feature_type?: Array<string>,
      dev_mode?: boolean | null,
      id?: Array<number>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<ContentFileSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<ContentFileSearchRetrievePlatformEnum>,
      q?: string,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      sortby?: ContentFileSearchRetrieveSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/content_file_search/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (content_feature_type) {
        localVarQueryParameter["content_feature_type"] = content_feature_type
      }

      if (dev_mode !== undefined) {
        localVarQueryParameter["dev_mode"] = dev_mode
      }

      if (id) {
        localVarQueryParameter["id"] = id
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (run_id) {
        localVarQueryParameter["run_id"] = run_id
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContentFileSearchApi - functional programming interface
 */
export const ContentFileSearchApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContentFileSearchApiAxiosParamCreator(configuration)
  return {
    /**
     * Search for content files
     * @summary Search
     * @param {Array<ContentFileSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {Array<number>} [id] The id value for the content file
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<ContentFileSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<ContentFileSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {string} [q] The search text
     * @param {Array<number>} [resource_id] The id value of the parent learning resource for the content file
     * @param {Array<number>} [run_id] The id value of the run that the content file belongs to
     * @param {ContentFileSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentFileSearchRetrieve(
      aggregations?: Array<ContentFileSearchRetrieveAggregationsEnum>,
      content_feature_type?: Array<string>,
      dev_mode?: boolean | null,
      id?: Array<number>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<ContentFileSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<ContentFileSearchRetrievePlatformEnum>,
      q?: string,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      sortby?: ContentFileSearchRetrieveSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ContentFileSearchResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contentFileSearchRetrieve(
          aggregations,
          content_feature_type,
          dev_mode,
          id,
          limit,
          ocw_topic,
          offered_by,
          offset,
          platform,
          q,
          resource_id,
          run_id,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ContentFileSearchApi.contentFileSearchRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ContentFileSearchApi - factory interface
 */
export const ContentFileSearchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ContentFileSearchApiFp(configuration)
  return {
    /**
     * Search for content files
     * @summary Search
     * @param {ContentFileSearchApiContentFileSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentFileSearchRetrieve(
      requestParameters: ContentFileSearchApiContentFileSearchRetrieveRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFileSearchResponse> {
      return localVarFp
        .contentFileSearchRetrieve(
          requestParameters.aggregations,
          requestParameters.content_feature_type,
          requestParameters.dev_mode,
          requestParameters.id,
          requestParameters.limit,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.q,
          requestParameters.resource_id,
          requestParameters.run_id,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for contentFileSearchRetrieve operation in ContentFileSearchApi.
 */
export interface ContentFileSearchApiContentFileSearchRetrieveRequest {
  /**
   * Show resource counts by category
   */
  readonly aggregations?: Array<ContentFileSearchRetrieveAggregationsEnum>

  /**
   * The feature type of the content file. Possible options are at api/v1/course_features/
   */
  readonly content_feature_type?: Array<string>

  /**
   * If true return raw open search results with score explanations
   */
  readonly dev_mode?: boolean | null

  /**
   * The id value for the content file
   */
  readonly id?: Array<number>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<ContentFileSearchRetrieveOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<ContentFileSearchRetrievePlatformEnum>

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The id value of the parent learning resource for the content file
   */
  readonly resource_id?: Array<number>

  /**
   * The id value of the run that the content file belongs to
   */
  readonly run_id?: Array<number>

  /**
   * if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
   */
  readonly sortby?: ContentFileSearchRetrieveSortbyEnum

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>
}

/**
 * ContentFileSearchApi - object-oriented interface
 */
export class ContentFileSearchApi extends BaseAPI {
  /**
   * Search for content files
   * @summary Search
   * @param {ContentFileSearchApiContentFileSearchRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public contentFileSearchRetrieve(
    requestParameters: ContentFileSearchApiContentFileSearchRetrieveRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ContentFileSearchApiFp(this.configuration)
      .contentFileSearchRetrieve(
        requestParameters.aggregations,
        requestParameters.content_feature_type,
        requestParameters.dev_mode,
        requestParameters.id,
        requestParameters.limit,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.q,
        requestParameters.resource_id,
        requestParameters.run_id,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const ContentFileSearchRetrieveAggregationsEnum = {
  Topic: "topic",
  ContentFeatureType: "content_feature_type",
  Platform: "platform",
  OfferedBy: "offered_by",
} as const
export type ContentFileSearchRetrieveAggregationsEnum =
  (typeof ContentFileSearchRetrieveAggregationsEnum)[keyof typeof ContentFileSearchRetrieveAggregationsEnum]
export const ContentFileSearchRetrieveOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type ContentFileSearchRetrieveOfferedByEnum =
  (typeof ContentFileSearchRetrieveOfferedByEnum)[keyof typeof ContentFileSearchRetrieveOfferedByEnum]
export const ContentFileSearchRetrievePlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type ContentFileSearchRetrievePlatformEnum =
  (typeof ContentFileSearchRetrievePlatformEnum)[keyof typeof ContentFileSearchRetrievePlatformEnum]
export const ContentFileSearchRetrieveSortbyEnum = {
  Id: "id",
  Id2: "-id",
  ResourceReadableId: "resource_readable_id",
  ResourceReadableId2: "-resource_readable_id",
} as const
export type ContentFileSearchRetrieveSortbyEnum =
  (typeof ContentFileSearchRetrieveSortbyEnum)[keyof typeof ContentFileSearchRetrieveSortbyEnum]

/**
 * ContentfilesApi - axios parameter creator
 */
export const ContentfilesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Viewset for ContentFiles
     * @summary List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<ContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<ContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentfilesList: async (
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<ContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<ContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "contentfilesList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath = `/api/v1/contentfiles/`.replace(
        "{learning_resource_id}",
        encodeURIComponent(String(learning_resource_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_feature_type) {
        localVarQueryParameter["content_feature_type"] = content_feature_type
      }

      if (edx_module_id) {
        localVarQueryParameter["edx_module_id"] = edx_module_id
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (run_id) {
        localVarQueryParameter["run_id"] = run_id
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for ContentFiles
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentfilesRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("contentfilesRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "contentfilesRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath = `/api/v1/contentfiles/{id}/`
        .replace("{id}", encodeURIComponent(String(id)))
        .replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContentfilesApi - functional programming interface
 */
export const ContentfilesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContentfilesApiAxiosParamCreator(configuration)
  return {
    /**
     * Viewset for ContentFiles
     * @summary List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<ContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<ContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentfilesList(
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<ContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<ContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedContentFileList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contentfilesList(
          learning_resource_id,
          content_feature_type,
          edx_module_id,
          limit,
          offered_by,
          offset,
          platform,
          resource_id,
          run_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ContentfilesApi.contentfilesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for ContentFiles
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentfilesRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentFile>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contentfilesRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ContentfilesApi.contentfilesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ContentfilesApi - factory interface
 */
export const ContentfilesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ContentfilesApiFp(configuration)
  return {
    /**
     * Viewset for ContentFiles
     * @summary List
     * @param {ContentfilesApiContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentfilesList(
      requestParameters: ContentfilesApiContentfilesListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedContentFileList> {
      return localVarFp
        .contentfilesList(
          requestParameters.learning_resource_id,
          requestParameters.content_feature_type,
          requestParameters.edx_module_id,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.resource_id,
          requestParameters.run_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for ContentFiles
     * @summary Retrieve
     * @param {ContentfilesApiContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentfilesRetrieve(
      requestParameters: ContentfilesApiContentfilesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFile> {
      return localVarFp
        .contentfilesRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for contentfilesList operation in ContentfilesApi.
 */
export interface ContentfilesApiContentfilesListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly content_feature_type?: Array<string>

  /**
   * The edx module id of the content file
   */
  readonly edx_module_id?: Array<string>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<ContentfilesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<ContentfilesListPlatformEnum>

  /**
   * The id of the learning resource the content file belongs to
   */
  readonly resource_id?: Array<number>

  /**
   * The id of the learning resource run the content file belongs to
   */
  readonly run_id?: Array<number>
}

/**
 * Request parameters for contentfilesRetrieve operation in ContentfilesApi.
 */
export interface ContentfilesApiContentfilesRetrieveRequest {
  /**
   * A unique integer value identifying this contentfile.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * ContentfilesApi - object-oriented interface
 */
export class ContentfilesApi extends BaseAPI {
  /**
   * Viewset for ContentFiles
   * @summary List
   * @param {ContentfilesApiContentfilesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public contentfilesList(
    requestParameters: ContentfilesApiContentfilesListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ContentfilesApiFp(this.configuration)
      .contentfilesList(
        requestParameters.learning_resource_id,
        requestParameters.content_feature_type,
        requestParameters.edx_module_id,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.resource_id,
        requestParameters.run_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for ContentFiles
   * @summary Retrieve
   * @param {ContentfilesApiContentfilesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public contentfilesRetrieve(
    requestParameters: ContentfilesApiContentfilesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ContentfilesApiFp(this.configuration)
      .contentfilesRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const ContentfilesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type ContentfilesListOfferedByEnum =
  (typeof ContentfilesListOfferedByEnum)[keyof typeof ContentfilesListOfferedByEnum]
export const ContentfilesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type ContentfilesListPlatformEnum =
  (typeof ContentfilesListPlatformEnum)[keyof typeof ContentfilesListPlatformEnum]

/**
 * CourseFeaturesApi - axios parameter creator
 */
export const CourseFeaturesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Course Features and Content Feature Types
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    courseFeaturesList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/course_features/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Course Features and Content Feature Types
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource content tag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    courseFeaturesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("courseFeaturesRetrieve", "id", id)
      const localVarPath = `/api/v1/course_features/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CourseFeaturesApi - functional programming interface
 */
export const CourseFeaturesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CourseFeaturesApiAxiosParamCreator(configuration)
  return {
    /**
     * Course Features and Content Feature Types
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async courseFeaturesList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceContentTagList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.courseFeaturesList(
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CourseFeaturesApi.courseFeaturesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Course Features and Content Feature Types
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource content tag.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async courseFeaturesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceContentTag>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.courseFeaturesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CourseFeaturesApi.courseFeaturesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CourseFeaturesApi - factory interface
 */
export const CourseFeaturesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CourseFeaturesApiFp(configuration)
  return {
    /**
     * Course Features and Content Feature Types
     * @summary List
     * @param {CourseFeaturesApiCourseFeaturesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    courseFeaturesList(
      requestParameters: CourseFeaturesApiCourseFeaturesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceContentTagList> {
      return localVarFp
        .courseFeaturesList(
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Course Features and Content Feature Types
     * @summary Retrieve
     * @param {CourseFeaturesApiCourseFeaturesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    courseFeaturesRetrieve(
      requestParameters: CourseFeaturesApiCourseFeaturesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceContentTag> {
      return localVarFp
        .courseFeaturesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for courseFeaturesList operation in CourseFeaturesApi.
 */
export interface CourseFeaturesApiCourseFeaturesListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for courseFeaturesRetrieve operation in CourseFeaturesApi.
 */
export interface CourseFeaturesApiCourseFeaturesRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource content tag.
   */
  readonly id: number
}

/**
 * CourseFeaturesApi - object-oriented interface
 */
export class CourseFeaturesApi extends BaseAPI {
  /**
   * Course Features and Content Feature Types
   * @summary List
   * @param {CourseFeaturesApiCourseFeaturesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public courseFeaturesList(
    requestParameters: CourseFeaturesApiCourseFeaturesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return CourseFeaturesApiFp(this.configuration)
      .courseFeaturesList(
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Course Features and Content Feature Types
   * @summary Retrieve
   * @param {CourseFeaturesApiCourseFeaturesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public courseFeaturesRetrieve(
    requestParameters: CourseFeaturesApiCourseFeaturesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CourseFeaturesApiFp(this.configuration)
      .courseFeaturesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CoursesApi - axios parameter creator
 */
export const CoursesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<CoursesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<CoursesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesContentfilesList: async (
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<CoursesContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<CoursesContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "coursesContentfilesList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/courses/{learning_resource_id}/contentfiles/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_feature_type) {
        localVarQueryParameter["content_feature_type"] = content_feature_type
      }

      if (edx_module_id) {
        localVarQueryParameter["edx_module_id"] = edx_module_id
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (run_id) {
        localVarQueryParameter["run_id"] = run_id
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesContentfilesRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("coursesContentfilesRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "coursesContentfilesRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/courses/{learning_resource_id}/contentfiles/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of courses
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<CoursesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<CoursesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<CoursesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<CoursesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<CoursesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<CoursesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<CoursesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<CoursesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {CoursesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesList: async (
      certification?: boolean,
      certification_type?: Array<CoursesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<CoursesListDeliveryEnum>>,
      department?: Array<CoursesListDepartmentEnum>,
      free?: boolean,
      level?: Array<CoursesListLevelEnum>,
      limit?: number,
      offered_by?: Array<CoursesListOfferedByEnum>,
      offset?: number,
      platform?: Array<CoursesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<CoursesListResourceTypeEnum>,
      resource_type_group?: Array<CoursesListResourceTypeGroupEnum>,
      sortby?: CoursesListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/courses/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single course
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("coursesRetrieve", "id", id)
      const localVarPath = `/api/v1/courses/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoursesApi - functional programming interface
 */
export const CoursesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CoursesApiAxiosParamCreator(configuration)
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<CoursesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<CoursesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coursesContentfilesList(
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<CoursesContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<CoursesContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedContentFileList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.coursesContentfilesList(
          learning_resource_id,
          content_feature_type,
          edx_module_id,
          limit,
          offered_by,
          offset,
          platform,
          resource_id,
          run_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CoursesApi.coursesContentfilesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coursesContentfilesRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentFile>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.coursesContentfilesRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CoursesApi.coursesContentfilesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of courses
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<CoursesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<CoursesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<CoursesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<CoursesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<CoursesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<CoursesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<CoursesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<CoursesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {CoursesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coursesList(
      certification?: boolean,
      certification_type?: Array<CoursesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<CoursesListDeliveryEnum>>,
      department?: Array<CoursesListDepartmentEnum>,
      free?: boolean,
      level?: Array<CoursesListLevelEnum>,
      limit?: number,
      offered_by?: Array<CoursesListOfferedByEnum>,
      offset?: number,
      platform?: Array<CoursesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<CoursesListResourceTypeEnum>,
      resource_type_group?: Array<CoursesListResourceTypeGroupEnum>,
      sortby?: CoursesListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedCourseResourceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.coursesList(
        certification,
        certification_type,
        course_feature,
        delivery,
        department,
        free,
        level,
        limit,
        offered_by,
        offset,
        platform,
        professional,
        readable_id,
        resource_id,
        resource_type,
        resource_type_group,
        sortby,
        topic,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CoursesApi.coursesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single course
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coursesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResource>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.coursesRetrieve(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CoursesApi.coursesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CoursesApi - factory interface
 */
export const CoursesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CoursesApiFp(configuration)
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {CoursesApiCoursesContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesContentfilesList(
      requestParameters: CoursesApiCoursesContentfilesListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedContentFileList> {
      return localVarFp
        .coursesContentfilesList(
          requestParameters.learning_resource_id,
          requestParameters.content_feature_type,
          requestParameters.edx_module_id,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.resource_id,
          requestParameters.run_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {CoursesApiCoursesContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesContentfilesRetrieve(
      requestParameters: CoursesApiCoursesContentfilesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFile> {
      return localVarFp
        .coursesContentfilesRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of courses
     * @summary List
     * @param {CoursesApiCoursesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesList(
      requestParameters: CoursesApiCoursesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedCourseResourceList> {
      return localVarFp
        .coursesList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single course
     * @summary Retrieve
     * @param {CoursesApiCoursesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coursesRetrieve(
      requestParameters: CoursesApiCoursesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CourseResource> {
      return localVarFp
        .coursesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for coursesContentfilesList operation in CoursesApi.
 */
export interface CoursesApiCoursesContentfilesListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly content_feature_type?: Array<string>

  /**
   * The edx module id of the content file
   */
  readonly edx_module_id?: Array<string>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<CoursesContentfilesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<CoursesContentfilesListPlatformEnum>

  /**
   * The id of the learning resource the content file belongs to
   */
  readonly resource_id?: Array<number>

  /**
   * The id of the learning resource run the content file belongs to
   */
  readonly run_id?: Array<number>
}

/**
 * Request parameters for coursesContentfilesRetrieve operation in CoursesApi.
 */
export interface CoursesApiCoursesContentfilesRetrieveRequest {
  /**
   * A unique integer value identifying this contentfile.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for coursesList operation in CoursesApi.
 */
export interface CoursesApiCoursesListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<CoursesListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<CoursesListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<CoursesListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<CoursesListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<CoursesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<CoursesListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<CoursesListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<CoursesListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: CoursesListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for coursesRetrieve operation in CoursesApi.
 */
export interface CoursesApiCoursesRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * CoursesApi - object-oriented interface
 */
export class CoursesApi extends BaseAPI {
  /**
   * Show content files for a learning resource
   * @summary Learning Resource Content File List
   * @param {CoursesApiCoursesContentfilesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public coursesContentfilesList(
    requestParameters: CoursesApiCoursesContentfilesListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CoursesApiFp(this.configuration)
      .coursesContentfilesList(
        requestParameters.learning_resource_id,
        requestParameters.content_feature_type,
        requestParameters.edx_module_id,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.resource_id,
        requestParameters.run_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Show content files for a learning resource
   * @summary Learning Resource Content File Retrieve
   * @param {CoursesApiCoursesContentfilesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public coursesContentfilesRetrieve(
    requestParameters: CoursesApiCoursesContentfilesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CoursesApiFp(this.configuration)
      .coursesContentfilesRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of courses
   * @summary List
   * @param {CoursesApiCoursesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public coursesList(
    requestParameters: CoursesApiCoursesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return CoursesApiFp(this.configuration)
      .coursesList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single course
   * @summary Retrieve
   * @param {CoursesApiCoursesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public coursesRetrieve(
    requestParameters: CoursesApiCoursesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CoursesApiFp(this.configuration)
      .coursesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const CoursesContentfilesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type CoursesContentfilesListOfferedByEnum =
  (typeof CoursesContentfilesListOfferedByEnum)[keyof typeof CoursesContentfilesListOfferedByEnum]
export const CoursesContentfilesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type CoursesContentfilesListPlatformEnum =
  (typeof CoursesContentfilesListPlatformEnum)[keyof typeof CoursesContentfilesListPlatformEnum]
export const CoursesListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type CoursesListCertificationTypeEnum =
  (typeof CoursesListCertificationTypeEnum)[keyof typeof CoursesListCertificationTypeEnum]
export const CoursesListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type CoursesListDeliveryEnum =
  (typeof CoursesListDeliveryEnum)[keyof typeof CoursesListDeliveryEnum]
export const CoursesListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type CoursesListDepartmentEnum =
  (typeof CoursesListDepartmentEnum)[keyof typeof CoursesListDepartmentEnum]
export const CoursesListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type CoursesListLevelEnum =
  (typeof CoursesListLevelEnum)[keyof typeof CoursesListLevelEnum]
export const CoursesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type CoursesListOfferedByEnum =
  (typeof CoursesListOfferedByEnum)[keyof typeof CoursesListOfferedByEnum]
export const CoursesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type CoursesListPlatformEnum =
  (typeof CoursesListPlatformEnum)[keyof typeof CoursesListPlatformEnum]
export const CoursesListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type CoursesListResourceTypeEnum =
  (typeof CoursesListResourceTypeEnum)[keyof typeof CoursesListResourceTypeEnum]
export const CoursesListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type CoursesListResourceTypeGroupEnum =
  (typeof CoursesListResourceTypeGroupEnum)[keyof typeof CoursesListResourceTypeGroupEnum]
export const CoursesListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type CoursesListSortbyEnum =
  (typeof CoursesListSortbyEnum)[keyof typeof CoursesListSortbyEnum]

/**
 * DepartmentsApi - axios parameter creator
 */
export const DepartmentsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * MIT academic departments
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departmentsList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/departments/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * MIT academic departments
     * @summary Retrieve
     * @param {string} department_id A unique value identifying this learning resource department.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departmentsRetrieve: async (
      department_id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'department_id' is not null or undefined
      assertParamExists("departmentsRetrieve", "department_id", department_id)
      const localVarPath = `/api/v1/departments/{department_id}/`.replace(
        "{department_id}",
        encodeURIComponent(String(department_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DepartmentsApi - functional programming interface
 */
export const DepartmentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DepartmentsApiAxiosParamCreator(configuration)
  return {
    /**
     * MIT academic departments
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async departmentsList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceDepartmentList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.departmentsList(
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["DepartmentsApi.departmentsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * MIT academic departments
     * @summary Retrieve
     * @param {string} department_id A unique value identifying this learning resource department.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async departmentsRetrieve(
      department_id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceDepartment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.departmentsRetrieve(
          department_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["DepartmentsApi.departmentsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DepartmentsApi - factory interface
 */
export const DepartmentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DepartmentsApiFp(configuration)
  return {
    /**
     * MIT academic departments
     * @summary List
     * @param {DepartmentsApiDepartmentsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departmentsList(
      requestParameters: DepartmentsApiDepartmentsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceDepartmentList> {
      return localVarFp
        .departmentsList(
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * MIT academic departments
     * @summary Retrieve
     * @param {DepartmentsApiDepartmentsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departmentsRetrieve(
      requestParameters: DepartmentsApiDepartmentsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceDepartment> {
      return localVarFp
        .departmentsRetrieve(requestParameters.department_id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for departmentsList operation in DepartmentsApi.
 */
export interface DepartmentsApiDepartmentsListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for departmentsRetrieve operation in DepartmentsApi.
 */
export interface DepartmentsApiDepartmentsRetrieveRequest {
  /**
   * A unique value identifying this learning resource department.
   */
  readonly department_id: string
}

/**
 * DepartmentsApi - object-oriented interface
 */
export class DepartmentsApi extends BaseAPI {
  /**
   * MIT academic departments
   * @summary List
   * @param {DepartmentsApiDepartmentsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public departmentsList(
    requestParameters: DepartmentsApiDepartmentsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return DepartmentsApiFp(this.configuration)
      .departmentsList(
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * MIT academic departments
   * @summary Retrieve
   * @param {DepartmentsApiDepartmentsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public departmentsRetrieve(
    requestParameters: DepartmentsApiDepartmentsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DepartmentsApiFp(this.configuration)
      .departmentsRetrieve(requestParameters.department_id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FeaturedApi - axios parameter creator
 */
export const FeaturedApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of featured resources
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<FeaturedListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<FeaturedListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<FeaturedListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<FeaturedListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<FeaturedListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<FeaturedListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<FeaturedListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<FeaturedListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {FeaturedListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featuredList: async (
      certification?: boolean,
      certification_type?: Array<FeaturedListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<FeaturedListDeliveryEnum>>,
      department?: Array<FeaturedListDepartmentEnum>,
      free?: boolean,
      level?: Array<FeaturedListLevelEnum>,
      limit?: number,
      offered_by?: Array<FeaturedListOfferedByEnum>,
      offset?: number,
      platform?: Array<FeaturedListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<FeaturedListResourceTypeEnum>,
      resource_type_group?: Array<FeaturedListResourceTypeGroupEnum>,
      sortby?: FeaturedListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/featured/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single featured resource
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featuredRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("featuredRetrieve", "id", id)
      const localVarPath = `/api/v1/featured/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * FeaturedApi - functional programming interface
 */
export const FeaturedApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FeaturedApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of featured resources
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<FeaturedListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<FeaturedListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<FeaturedListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<FeaturedListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<FeaturedListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<FeaturedListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<FeaturedListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<FeaturedListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {FeaturedListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async featuredList(
      certification?: boolean,
      certification_type?: Array<FeaturedListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<FeaturedListDeliveryEnum>>,
      department?: Array<FeaturedListDepartmentEnum>,
      free?: boolean,
      level?: Array<FeaturedListLevelEnum>,
      limit?: number,
      offered_by?: Array<FeaturedListOfferedByEnum>,
      offset?: number,
      platform?: Array<FeaturedListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<FeaturedListResourceTypeEnum>,
      resource_type_group?: Array<FeaturedListResourceTypeGroupEnum>,
      sortby?: FeaturedListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.featuredList(
        certification,
        certification_type,
        course_feature,
        delivery,
        department,
        free,
        level,
        limit,
        offered_by,
        offset,
        platform,
        professional,
        readable_id,
        resource_id,
        resource_type,
        resource_type_group,
        sortby,
        topic,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FeaturedApi.featuredList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single featured resource
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async featuredRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.featuredRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FeaturedApi.featuredRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * FeaturedApi - factory interface
 */
export const FeaturedApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FeaturedApiFp(configuration)
  return {
    /**
     * Get a paginated list of featured resources
     * @summary List
     * @param {FeaturedApiFeaturedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featuredList(
      requestParameters: FeaturedApiFeaturedListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceList> {
      return localVarFp
        .featuredList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single featured resource
     * @summary Retrieve
     * @param {FeaturedApiFeaturedRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featuredRetrieve(
      requestParameters: FeaturedApiFeaturedRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResource> {
      return localVarFp
        .featuredRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for featuredList operation in FeaturedApi.
 */
export interface FeaturedApiFeaturedListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<FeaturedListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<FeaturedListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<FeaturedListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<FeaturedListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<FeaturedListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<FeaturedListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<FeaturedListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<FeaturedListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: FeaturedListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for featuredRetrieve operation in FeaturedApi.
 */
export interface FeaturedApiFeaturedRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * FeaturedApi - object-oriented interface
 */
export class FeaturedApi extends BaseAPI {
  /**
   * Get a paginated list of featured resources
   * @summary List
   * @param {FeaturedApiFeaturedListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public featuredList(
    requestParameters: FeaturedApiFeaturedListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return FeaturedApiFp(this.configuration)
      .featuredList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single featured resource
   * @summary Retrieve
   * @param {FeaturedApiFeaturedRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public featuredRetrieve(
    requestParameters: FeaturedApiFeaturedRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FeaturedApiFp(this.configuration)
      .featuredRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const FeaturedListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type FeaturedListCertificationTypeEnum =
  (typeof FeaturedListCertificationTypeEnum)[keyof typeof FeaturedListCertificationTypeEnum]
export const FeaturedListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type FeaturedListDeliveryEnum =
  (typeof FeaturedListDeliveryEnum)[keyof typeof FeaturedListDeliveryEnum]
export const FeaturedListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type FeaturedListDepartmentEnum =
  (typeof FeaturedListDepartmentEnum)[keyof typeof FeaturedListDepartmentEnum]
export const FeaturedListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type FeaturedListLevelEnum =
  (typeof FeaturedListLevelEnum)[keyof typeof FeaturedListLevelEnum]
export const FeaturedListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type FeaturedListOfferedByEnum =
  (typeof FeaturedListOfferedByEnum)[keyof typeof FeaturedListOfferedByEnum]
export const FeaturedListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type FeaturedListPlatformEnum =
  (typeof FeaturedListPlatformEnum)[keyof typeof FeaturedListPlatformEnum]
export const FeaturedListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type FeaturedListResourceTypeEnum =
  (typeof FeaturedListResourceTypeEnum)[keyof typeof FeaturedListResourceTypeEnum]
export const FeaturedListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type FeaturedListResourceTypeGroupEnum =
  (typeof FeaturedListResourceTypeGroupEnum)[keyof typeof FeaturedListResourceTypeGroupEnum]
export const FeaturedListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type FeaturedListSortbyEnum =
  (typeof FeaturedListSortbyEnum)[keyof typeof FeaturedListSortbyEnum]

/**
 * HubspotApi - axios parameter creator
 */
export const HubspotApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get one HubSpot form by id from the backend.
     * @param {string} form_id
     * @param {boolean} [archived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsDetailRetrieve: async (
      form_id: string,
      archived?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'form_id' is not null or undefined
      assertParamExists("hubspotFormsDetailRetrieve", "form_id", form_id)
      const localVarPath = `/api/v1/hubspot/forms/{form_id}/`.replace(
        "{form_id}",
        encodeURIComponent(String(form_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (archived !== undefined) {
        localVarQueryParameter["archived"] = archived
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List HubSpot forms from the backend.
     * @param {string} [after]
     * @param {boolean} [archived]
     * @param {Array<string>} [form_types]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsList: async (
      after?: string,
      archived?: boolean,
      form_types?: Array<string>,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/hubspot/forms/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (after !== undefined) {
        localVarQueryParameter["after"] = after
      }

      if (archived !== undefined) {
        localVarQueryParameter["archived"] = archived
      }

      if (form_types) {
        localVarQueryParameter["form_types"] = form_types
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Submit a form to HubSpot.
     * @param {string} form_id
     * @param {HubspotFormSubmitRequestRequest} HubspotFormSubmitRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsSubmit: async (
      form_id: string,
      HubspotFormSubmitRequestRequest: HubspotFormSubmitRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'form_id' is not null or undefined
      assertParamExists("hubspotFormsSubmit", "form_id", form_id)
      // verify required parameter 'HubspotFormSubmitRequestRequest' is not null or undefined
      assertParamExists(
        "hubspotFormsSubmit",
        "HubspotFormSubmitRequestRequest",
        HubspotFormSubmitRequestRequest,
      )
      const localVarPath = `/api/v1/hubspot/forms/{form_id}/submit/`.replace(
        "{form_id}",
        encodeURIComponent(String(form_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        HubspotFormSubmitRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HubspotApi - functional programming interface
 */
export const HubspotApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HubspotApiAxiosParamCreator(configuration)
  return {
    /**
     * Get one HubSpot form by id from the backend.
     * @param {string} form_id
     * @param {boolean} [archived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hubspotFormsDetailRetrieve(
      form_id: string,
      archived?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HubspotFormDefinition>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hubspotFormsDetailRetrieve(
          form_id,
          archived,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HubspotApi.hubspotFormsDetailRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * List HubSpot forms from the backend.
     * @param {string} [after]
     * @param {boolean} [archived]
     * @param {Array<string>} [form_types]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hubspotFormsList(
      after?: string,
      archived?: boolean,
      form_types?: Array<string>,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HubspotCollectionResponseFormDefinitionBaseForwardPaging>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hubspotFormsList(
          after,
          archived,
          form_types,
          limit,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HubspotApi.hubspotFormsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Submit a form to HubSpot.
     * @param {string} form_id
     * @param {HubspotFormSubmitRequestRequest} HubspotFormSubmitRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hubspotFormsSubmit(
      form_id: string,
      HubspotFormSubmitRequestRequest: HubspotFormSubmitRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HubspotFormSubmitResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hubspotFormsSubmit(
          form_id,
          HubspotFormSubmitRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HubspotApi.hubspotFormsSubmit"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * HubspotApi - factory interface
 */
export const HubspotApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HubspotApiFp(configuration)
  return {
    /**
     * Get one HubSpot form by id from the backend.
     * @param {HubspotApiHubspotFormsDetailRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsDetailRetrieve(
      requestParameters: HubspotApiHubspotFormsDetailRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HubspotFormDefinition> {
      return localVarFp
        .hubspotFormsDetailRetrieve(
          requestParameters.form_id,
          requestParameters.archived,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List HubSpot forms from the backend.
     * @param {HubspotApiHubspotFormsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsList(
      requestParameters: HubspotApiHubspotFormsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HubspotCollectionResponseFormDefinitionBaseForwardPaging> {
      return localVarFp
        .hubspotFormsList(
          requestParameters.after,
          requestParameters.archived,
          requestParameters.form_types,
          requestParameters.limit,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Submit a form to HubSpot.
     * @param {HubspotApiHubspotFormsSubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hubspotFormsSubmit(
      requestParameters: HubspotApiHubspotFormsSubmitRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HubspotFormSubmitResponse> {
      return localVarFp
        .hubspotFormsSubmit(
          requestParameters.form_id,
          requestParameters.HubspotFormSubmitRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for hubspotFormsDetailRetrieve operation in HubspotApi.
 */
export interface HubspotApiHubspotFormsDetailRetrieveRequest {
  readonly form_id: string

  readonly archived?: boolean
}

/**
 * Request parameters for hubspotFormsList operation in HubspotApi.
 */
export interface HubspotApiHubspotFormsListRequest {
  readonly after?: string

  readonly archived?: boolean

  readonly form_types?: Array<string>

  readonly limit?: number
}

/**
 * Request parameters for hubspotFormsSubmit operation in HubspotApi.
 */
export interface HubspotApiHubspotFormsSubmitRequest {
  readonly form_id: string

  readonly HubspotFormSubmitRequestRequest: HubspotFormSubmitRequestRequest
}

/**
 * HubspotApi - object-oriented interface
 */
export class HubspotApi extends BaseAPI {
  /**
   * Get one HubSpot form by id from the backend.
   * @param {HubspotApiHubspotFormsDetailRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public hubspotFormsDetailRetrieve(
    requestParameters: HubspotApiHubspotFormsDetailRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HubspotApiFp(this.configuration)
      .hubspotFormsDetailRetrieve(
        requestParameters.form_id,
        requestParameters.archived,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List HubSpot forms from the backend.
   * @param {HubspotApiHubspotFormsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public hubspotFormsList(
    requestParameters: HubspotApiHubspotFormsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return HubspotApiFp(this.configuration)
      .hubspotFormsList(
        requestParameters.after,
        requestParameters.archived,
        requestParameters.form_types,
        requestParameters.limit,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Submit a form to HubSpot.
   * @param {HubspotApiHubspotFormsSubmitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public hubspotFormsSubmit(
    requestParameters: HubspotApiHubspotFormsSubmitRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HubspotApiFp(this.configuration)
      .hubspotFormsSubmit(
        requestParameters.form_id,
        requestParameters.HubspotFormSubmitRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LearningResourceDisplayInfoApi - axios parameter creator
 */
export const LearningResourceDisplayInfoApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of learning resource display info
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningResourceDisplayInfoListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourceDisplayInfoListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourceDisplayInfoListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourceDisplayInfoListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourceDisplayInfoListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourceDisplayInfoListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourceDisplayInfoListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourceDisplayInfoListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourceDisplayInfoList: async (
      certification?: boolean,
      certification_type?: Array<LearningResourceDisplayInfoListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>,
      department?: Array<LearningResourceDisplayInfoListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourceDisplayInfoListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourceDisplayInfoListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourceDisplayInfoListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourceDisplayInfoListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourceDisplayInfoListResourceTypeGroupEnum>,
      sortby?: LearningResourceDisplayInfoListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resource_display_info/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve display info for a learning resource.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourceDisplayInfoRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourceDisplayInfoRetrieve", "id", id)
      const localVarPath =
        `/api/v1/learning_resource_display_info/{id}/`.replace(
          "{id}",
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningResourceDisplayInfoApi - functional programming interface
 */
export const LearningResourceDisplayInfoApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    LearningResourceDisplayInfoApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of learning resource display info
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningResourceDisplayInfoListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourceDisplayInfoListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourceDisplayInfoListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourceDisplayInfoListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourceDisplayInfoListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourceDisplayInfoListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourceDisplayInfoListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourceDisplayInfoListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourceDisplayInfoList(
      certification?: boolean,
      certification_type?: Array<LearningResourceDisplayInfoListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>,
      department?: Array<LearningResourceDisplayInfoListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourceDisplayInfoListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourceDisplayInfoListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourceDisplayInfoListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourceDisplayInfoListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourceDisplayInfoListResourceTypeGroupEnum>,
      sortby?: LearningResourceDisplayInfoListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceDisplayInfoResponseList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourceDisplayInfoList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourceDisplayInfoApi.learningResourceDisplayInfoList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve display info for a learning resource.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourceDisplayInfoRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceDisplayInfoResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourceDisplayInfoRetrieve(
          id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourceDisplayInfoApi.learningResourceDisplayInfoRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningResourceDisplayInfoApi - factory interface
 */
export const LearningResourceDisplayInfoApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningResourceDisplayInfoApiFp(configuration)
  return {
    /**
     * Get a paginated list of learning resource display info
     * @summary List
     * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourceDisplayInfoList(
      requestParameters: LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceDisplayInfoResponseList> {
      return localVarFp
        .learningResourceDisplayInfoList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve display info for a learning resource.
     * @summary Retrieve
     * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourceDisplayInfoRetrieve(
      requestParameters: LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceDisplayInfoResponse> {
      return localVarFp
        .learningResourceDisplayInfoRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for learningResourceDisplayInfoList operation in LearningResourceDisplayInfoApi.
 */
export interface LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourceDisplayInfoListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourceDisplayInfoListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<LearningResourceDisplayInfoListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourceDisplayInfoListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourceDisplayInfoListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<LearningResourceDisplayInfoListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningResourceDisplayInfoListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourceDisplayInfoListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for learningResourceDisplayInfoRetrieve operation in LearningResourceDisplayInfoApi.
 */
export interface LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * LearningResourceDisplayInfoApi - object-oriented interface
 */
export class LearningResourceDisplayInfoApi extends BaseAPI {
  /**
   * Get a paginated list of learning resource display info
   * @summary List
   * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourceDisplayInfoList(
    requestParameters: LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourceDisplayInfoApiFp(this.configuration)
      .learningResourceDisplayInfoList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve display info for a learning resource.
   * @summary Retrieve
   * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourceDisplayInfoRetrieve(
    requestParameters: LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourceDisplayInfoApiFp(this.configuration)
      .learningResourceDisplayInfoRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const LearningResourceDisplayInfoListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type LearningResourceDisplayInfoListCertificationTypeEnum =
  (typeof LearningResourceDisplayInfoListCertificationTypeEnum)[keyof typeof LearningResourceDisplayInfoListCertificationTypeEnum]
export const LearningResourceDisplayInfoListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourceDisplayInfoListDeliveryEnum =
  (typeof LearningResourceDisplayInfoListDeliveryEnum)[keyof typeof LearningResourceDisplayInfoListDeliveryEnum]
export const LearningResourceDisplayInfoListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourceDisplayInfoListDepartmentEnum =
  (typeof LearningResourceDisplayInfoListDepartmentEnum)[keyof typeof LearningResourceDisplayInfoListDepartmentEnum]
export const LearningResourceDisplayInfoListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type LearningResourceDisplayInfoListLevelEnum =
  (typeof LearningResourceDisplayInfoListLevelEnum)[keyof typeof LearningResourceDisplayInfoListLevelEnum]
export const LearningResourceDisplayInfoListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type LearningResourceDisplayInfoListOfferedByEnum =
  (typeof LearningResourceDisplayInfoListOfferedByEnum)[keyof typeof LearningResourceDisplayInfoListOfferedByEnum]
export const LearningResourceDisplayInfoListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type LearningResourceDisplayInfoListPlatformEnum =
  (typeof LearningResourceDisplayInfoListPlatformEnum)[keyof typeof LearningResourceDisplayInfoListPlatformEnum]
export const LearningResourceDisplayInfoListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type LearningResourceDisplayInfoListResourceTypeEnum =
  (typeof LearningResourceDisplayInfoListResourceTypeEnum)[keyof typeof LearningResourceDisplayInfoListResourceTypeEnum]
export const LearningResourceDisplayInfoListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type LearningResourceDisplayInfoListResourceTypeGroupEnum =
  (typeof LearningResourceDisplayInfoListResourceTypeGroupEnum)[keyof typeof LearningResourceDisplayInfoListResourceTypeGroupEnum]
export const LearningResourceDisplayInfoListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type LearningResourceDisplayInfoListSortbyEnum =
  (typeof LearningResourceDisplayInfoListSortbyEnum)[keyof typeof LearningResourceDisplayInfoListSortbyEnum]

/**
 * LearningResourcesApi - axios parameter creator
 */
export const LearningResourcesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesContentfilesList: async (
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<LearningResourcesContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningResourcesContentfilesList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learning_resources/{learning_resource_id}/contentfiles/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_feature_type) {
        localVarQueryParameter["content_feature_type"] = content_feature_type
      }

      if (edx_module_id) {
        localVarQueryParameter["edx_module_id"] = edx_module_id
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (run_id) {
        localVarQueryParameter["run_id"] = run_id
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesContentfilesRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesContentfilesRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningResourcesContentfilesRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learning_resources/{learning_resource_id}/contentfiles/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesItemsList: async (
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningResourcesItemsList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learning_resources/{learning_resource_id}/items/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesItemsRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesItemsRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningResourcesItemsRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learning_resources/{learning_resource_id}/items/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Set Learning Path Relationships on a given Learning Resource.
     * @summary Set Learning Path Relationships
     * @param {number} id id of the learning resource
     * @param {Array<number>} [learning_path_id] id of the parent learning path
     * @param {PatchedLearningResourceRelationshipRequest} [PatchedLearningResourceRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesLearningPathsPartialUpdate: async (
      id: number,
      learning_path_id?: Array<number>,
      PatchedLearningResourceRelationshipRequest?: PatchedLearningResourceRelationshipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesLearningPathsPartialUpdate", "id", id)
      const localVarPath =
        `/api/v1/learning_resources/{id}/learning_paths/`.replace(
          "{id}",
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (learning_path_id) {
        localVarQueryParameter["learning_path_id"] = learning_path_id
      }

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedLearningResourceRelationshipRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of learning resources.
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningResourcesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourcesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourcesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourcesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourcesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourcesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesList: async (
      certification?: boolean,
      certification_type?: Array<LearningResourcesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourcesListDeliveryEnum>>,
      department?: Array<LearningResourcesListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourcesListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourcesListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourcesListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesListResourceTypeGroupEnum>,
      sortby?: LearningResourcesListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single learning resource.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesRetrieve", "id", id)
      const localVarPath = `/api/v1/learning_resources/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Fetch similar learning resources, optionally narrowed by filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources
     * @param {number} id
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesSimilarListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesSimilarListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSimilarListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {Array<LearningResourcesSimilarListLevelEnum>} [level]
     * @param {number} [limit]
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesSimilarListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {Array<LearningResourcesSimilarListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesSimilarListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesSimilarListResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSimilarList: async (
      id: number,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesSimilarListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesSimilarListDeliveryEnum>,
      department?: Array<LearningResourcesSimilarListDepartmentEnum>,
      free?: boolean | null,
      level?: Array<LearningResourcesSimilarListLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesSimilarListOfferedByEnum>,
      platform?: Array<LearningResourcesSimilarListPlatformEnum>,
      professional?: boolean | null,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesSimilarListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSimilarListResourceTypeGroupEnum>,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesSimilarList", "id", id)
      const localVarPath = `/api/v1/learning_resources/{id}/similar/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of learning resources with summary fields
     * @summary Get learning resources summary
     * @param {boolean} [certification]
     * @param {Array<LearningResourcesSummaryListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourcesSummaryListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSummaryListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourcesSummaryListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesSummaryListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesSummaryListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourcesSummaryListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourcesSummaryListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourcesSummaryListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSummaryList: async (
      certification?: boolean,
      certification_type?: Array<LearningResourcesSummaryListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourcesSummaryListDeliveryEnum>>,
      department?: Array<LearningResourcesSummaryListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourcesSummaryListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourcesSummaryListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesSummaryListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourcesSummaryListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSummaryListResourceTypeGroupEnum>,
      sortby?: LearningResourcesSummaryListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources/summary/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Set User List Relationships on a given Learning Resource.
     * @summary Set User List Relationships
     * @param {number} id id of the learning resource
     * @param {Array<number>} [userlist_id] id of the parent user list
     * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserlistsPartialUpdate: async (
      id: number,
      userlist_id?: Array<number>,
      PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesUserlistsPartialUpdate", "id", id)
      const localVarPath = `/api/v1/learning_resources/{id}/userlists/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (userlist_id) {
        localVarQueryParameter["userlist_id"] = userlist_id
      }

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedUserListRelationshipRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Fetch similar learning resources, optionally narrowed by Qdrant filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources using vector embeddings
     * @param {number} id
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesVectorSimilarListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesVectorSimilarListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesVectorSimilarListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {Array<LearningResourcesVectorSimilarListLevelEnum>} [level]
     * @param {number} [limit]
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesVectorSimilarListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {Array<LearningResourcesVectorSimilarListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesVectorSimilarListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesVectorSimilarListResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesVectorSimilarList: async (
      id: number,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesVectorSimilarListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesVectorSimilarListDeliveryEnum>,
      department?: Array<LearningResourcesVectorSimilarListDepartmentEnum>,
      free?: boolean | null,
      level?: Array<LearningResourcesVectorSimilarListLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesVectorSimilarListOfferedByEnum>,
      platform?: Array<LearningResourcesVectorSimilarListPlatformEnum>,
      professional?: boolean | null,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesVectorSimilarListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesVectorSimilarListResourceTypeGroupEnum>,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningResourcesVectorSimilarList", "id", id)
      const localVarPath =
        `/api/v1/learning_resources/{id}/vector_similar/`.replace(
          "{id}",
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningResourcesApi - functional programming interface
 */
export const LearningResourcesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    LearningResourcesApiAxiosParamCreator(configuration)
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {Array<string>} [content_feature_type] Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<string>} [edx_module_id] The edx module id of the content file
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {Array<number>} [resource_id] The id of the learning resource the content file belongs to
     * @param {Array<number>} [run_id] The id of the learning resource run the content file belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesContentfilesList(
      learning_resource_id: number,
      content_feature_type?: Array<string>,
      edx_module_id?: Array<string>,
      limit?: number,
      offered_by?: Array<LearningResourcesContentfilesListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesContentfilesListPlatformEnum>,
      resource_id?: Array<number>,
      run_id?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedContentFileList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesContentfilesList(
          learning_resource_id,
          content_feature_type,
          edx_module_id,
          limit,
          offered_by,
          offset,
          platform,
          resource_id,
          run_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesContentfilesList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {number} id A unique integer value identifying this contentfile.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesContentfilesRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentFile>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesContentfilesRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesContentfilesRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesItemsList(
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceRelationshipList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesItemsList(
          learning_resource_id,
          limit,
          offset,
          sortby,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningResourcesApi.learningResourcesItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesItemsRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesItemsRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesItemsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Set Learning Path Relationships on a given Learning Resource.
     * @summary Set Learning Path Relationships
     * @param {number} id id of the learning resource
     * @param {Array<number>} [learning_path_id] id of the parent learning path
     * @param {PatchedLearningResourceRelationshipRequest} [PatchedLearningResourceRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesLearningPathsPartialUpdate(
      id: number,
      learning_path_id?: Array<number>,
      PatchedLearningResourceRelationshipRequest?: PatchedLearningResourceRelationshipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<LearningResourceRelationship>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesLearningPathsPartialUpdate(
          id,
          learning_path_id,
          PatchedLearningResourceRelationshipRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesLearningPathsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of learning resources.
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningResourcesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourcesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourcesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourcesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourcesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourcesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesList(
      certification?: boolean,
      certification_type?: Array<LearningResourcesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourcesListDeliveryEnum>>,
      department?: Array<LearningResourcesListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourcesListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourcesListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourcesListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesListResourceTypeGroupEnum>,
      sortby?: LearningResourcesListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningResourcesApi.learningResourcesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single learning resource.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningResourcesApi.learningResourcesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Fetch similar learning resources, optionally narrowed by filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources
     * @param {number} id
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesSimilarListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesSimilarListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSimilarListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {Array<LearningResourcesSimilarListLevelEnum>} [level]
     * @param {number} [limit]
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesSimilarListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {Array<LearningResourcesSimilarListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesSimilarListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesSimilarListResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesSimilarList(
      id: number,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesSimilarListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesSimilarListDeliveryEnum>,
      department?: Array<LearningResourcesSimilarListDepartmentEnum>,
      free?: boolean | null,
      level?: Array<LearningResourcesSimilarListLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesSimilarListOfferedByEnum>,
      platform?: Array<LearningResourcesSimilarListPlatformEnum>,
      professional?: boolean | null,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesSimilarListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSimilarListResourceTypeGroupEnum>,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<LearningResource>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesSimilarList(
          id,
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          ocw_topic,
          offered_by,
          platform,
          professional,
          resource_category,
          resource_type,
          resource_type_group,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesSimilarList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of learning resources with summary fields
     * @summary Get learning resources summary
     * @param {boolean} [certification]
     * @param {Array<LearningResourcesSummaryListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningResourcesSummaryListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSummaryListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningResourcesSummaryListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningResourcesSummaryListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningResourcesSummaryListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningResourcesSummaryListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningResourcesSummaryListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningResourcesSummaryListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesSummaryList(
      certification?: boolean,
      certification_type?: Array<LearningResourcesSummaryListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningResourcesSummaryListDeliveryEnum>>,
      department?: Array<LearningResourcesSummaryListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningResourcesSummaryListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningResourcesSummaryListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesSummaryListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningResourcesSummaryListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSummaryListResourceTypeGroupEnum>,
      sortby?: LearningResourcesSummaryListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceSummaryList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesSummaryList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesSummaryList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Set User List Relationships on a given Learning Resource.
     * @summary Set User List Relationships
     * @param {number} id id of the learning resource
     * @param {Array<number>} [userlist_id] id of the parent user list
     * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesUserlistsPartialUpdate(
      id: number,
      userlist_id?: Array<number>,
      PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<UserListRelationship>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesUserlistsPartialUpdate(
          id,
          userlist_id,
          PatchedUserListRelationshipRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesUserlistsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Fetch similar learning resources, optionally narrowed by Qdrant filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources using vector embeddings
     * @param {number} id
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesVectorSimilarListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesVectorSimilarListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesVectorSimilarListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {Array<LearningResourcesVectorSimilarListLevelEnum>} [level]
     * @param {number} [limit]
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesVectorSimilarListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {Array<LearningResourcesVectorSimilarListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesVectorSimilarListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesVectorSimilarListResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesVectorSimilarList(
      id: number,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesVectorSimilarListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesVectorSimilarListDeliveryEnum>,
      department?: Array<LearningResourcesVectorSimilarListDepartmentEnum>,
      free?: boolean | null,
      level?: Array<LearningResourcesVectorSimilarListLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesVectorSimilarListOfferedByEnum>,
      platform?: Array<LearningResourcesVectorSimilarListPlatformEnum>,
      professional?: boolean | null,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesVectorSimilarListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesVectorSimilarListResourceTypeGroupEnum>,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<LearningResource>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesVectorSimilarList(
          id,
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          ocw_topic,
          offered_by,
          platform,
          professional,
          resource_category,
          resource_type,
          resource_type_group,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesApi.learningResourcesVectorSimilarList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningResourcesApi - factory interface
 */
export const LearningResourcesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningResourcesApiFp(configuration)
  return {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {LearningResourcesApiLearningResourcesContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesContentfilesList(
      requestParameters: LearningResourcesApiLearningResourcesContentfilesListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedContentFileList> {
      return localVarFp
        .learningResourcesContentfilesList(
          requestParameters.learning_resource_id,
          requestParameters.content_feature_type,
          requestParameters.edx_module_id,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.resource_id,
          requestParameters.run_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {LearningResourcesApiLearningResourcesContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesContentfilesRetrieve(
      requestParameters: LearningResourcesApiLearningResourcesContentfilesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFile> {
      return localVarFp
        .learningResourcesContentfilesRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {LearningResourcesApiLearningResourcesItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesItemsList(
      requestParameters: LearningResourcesApiLearningResourcesItemsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceRelationshipList> {
      return localVarFp
        .learningResourcesItemsList(
          requestParameters.learning_resource_id,
          requestParameters.limit,
          requestParameters.offset,
          requestParameters.sortby,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {LearningResourcesApiLearningResourcesItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesItemsRetrieve(
      requestParameters: LearningResourcesApiLearningResourcesItemsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceRelationship> {
      return localVarFp
        .learningResourcesItemsRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Set Learning Path Relationships on a given Learning Resource.
     * @summary Set Learning Path Relationships
     * @param {LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesLearningPathsPartialUpdate(
      requestParameters: LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LearningResourceRelationship>> {
      return localVarFp
        .learningResourcesLearningPathsPartialUpdate(
          requestParameters.id,
          requestParameters.learning_path_id,
          requestParameters.PatchedLearningResourceRelationshipRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of learning resources.
     * @summary List
     * @param {LearningResourcesApiLearningResourcesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesList(
      requestParameters: LearningResourcesApiLearningResourcesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceList> {
      return localVarFp
        .learningResourcesList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single learning resource.
     * @summary Retrieve
     * @param {LearningResourcesApiLearningResourcesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesRetrieve(
      requestParameters: LearningResourcesApiLearningResourcesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResource> {
      return localVarFp
        .learningResourcesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Fetch similar learning resources, optionally narrowed by filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources
     * @param {LearningResourcesApiLearningResourcesSimilarListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSimilarList(
      requestParameters: LearningResourcesApiLearningResourcesSimilarListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LearningResource>> {
      return localVarFp
        .learningResourcesSimilarList(
          requestParameters.id,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of learning resources with summary fields
     * @summary Get learning resources summary
     * @param {LearningResourcesApiLearningResourcesSummaryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSummaryList(
      requestParameters: LearningResourcesApiLearningResourcesSummaryListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceSummaryList> {
      return localVarFp
        .learningResourcesSummaryList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Set User List Relationships on a given Learning Resource.
     * @summary Set User List Relationships
     * @param {LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserlistsPartialUpdate(
      requestParameters: LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<UserListRelationship>> {
      return localVarFp
        .learningResourcesUserlistsPartialUpdate(
          requestParameters.id,
          requestParameters.userlist_id,
          requestParameters.PatchedUserListRelationshipRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Fetch similar learning resources, optionally narrowed by Qdrant filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources using vector embeddings
     * @param {LearningResourcesApiLearningResourcesVectorSimilarListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesVectorSimilarList(
      requestParameters: LearningResourcesApiLearningResourcesVectorSimilarListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LearningResource>> {
      return localVarFp
        .learningResourcesVectorSimilarList(
          requestParameters.id,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for learningResourcesContentfilesList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesContentfilesListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Content feature type for the content file. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly content_feature_type?: Array<string>

  /**
   * The edx module id of the content file
   */
  readonly edx_module_id?: Array<string>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesContentfilesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesContentfilesListPlatformEnum>

  /**
   * The id of the learning resource the content file belongs to
   */
  readonly resource_id?: Array<number>

  /**
   * The id of the learning resource run the content file belongs to
   */
  readonly run_id?: Array<number>
}

/**
 * Request parameters for learningResourcesContentfilesRetrieve operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesContentfilesRetrieveRequest {
  /**
   * A unique integer value identifying this contentfile.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for learningResourcesItemsList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesItemsListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Which field to use when ordering the results.
   */
  readonly sortby?: string
}

/**
 * Request parameters for learningResourcesItemsRetrieve operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesItemsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for learningResourcesLearningPathsPartialUpdate operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest {
  /**
   * id of the learning resource
   */
  readonly id: number

  /**
   * id of the parent learning path
   */
  readonly learning_path_id?: Array<number>

  readonly PatchedLearningResourceRelationshipRequest?: PatchedLearningResourceRelationshipRequest
}

/**
 * Request parameters for learningResourcesList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<LearningResourcesListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<LearningResourcesListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<LearningResourcesListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningResourcesListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for learningResourcesRetrieve operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * Request parameters for learningResourcesSimilarList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesSimilarListRequest {
  readonly id: number

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesSimilarListCertificationTypeEnum>

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesSimilarListDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesSimilarListDepartmentEnum>

  readonly free?: boolean | null

  readonly level?: Array<LearningResourcesSimilarListLevelEnum>

  readonly limit?: number

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesSimilarListOfferedByEnum>

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesSimilarListPlatformEnum>

  readonly professional?: boolean | null

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesSimilarListResourceTypeEnum>

  /**
   * The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningResourcesSimilarListResourceTypeGroupEnum>

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for learningResourcesSummaryList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesSummaryListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesSummaryListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<LearningResourcesSummaryListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesSummaryListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<LearningResourcesSummaryListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesSummaryListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesSummaryListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<LearningResourcesSummaryListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningResourcesSummaryListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesSummaryListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for learningResourcesUserlistsPartialUpdate operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest {
  /**
   * id of the learning resource
   */
  readonly id: number

  /**
   * id of the parent user list
   */
  readonly userlist_id?: Array<number>

  readonly PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest
}

/**
 * Request parameters for learningResourcesVectorSimilarList operation in LearningResourcesApi.
 */
export interface LearningResourcesApiLearningResourcesVectorSimilarListRequest {
  readonly id: number

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesVectorSimilarListCertificationTypeEnum>

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesVectorSimilarListDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesVectorSimilarListDepartmentEnum>

  readonly free?: boolean | null

  readonly level?: Array<LearningResourcesVectorSimilarListLevelEnum>

  readonly limit?: number

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesVectorSimilarListOfferedByEnum>

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesVectorSimilarListPlatformEnum>

  readonly professional?: boolean | null

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesVectorSimilarListResourceTypeEnum>

  /**
   * The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningResourcesVectorSimilarListResourceTypeGroupEnum>

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>
}

/**
 * LearningResourcesApi - object-oriented interface
 */
export class LearningResourcesApi extends BaseAPI {
  /**
   * Show content files for a learning resource
   * @summary Learning Resource Content File List
   * @param {LearningResourcesApiLearningResourcesContentfilesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesContentfilesList(
    requestParameters: LearningResourcesApiLearningResourcesContentfilesListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesContentfilesList(
        requestParameters.learning_resource_id,
        requestParameters.content_feature_type,
        requestParameters.edx_module_id,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.resource_id,
        requestParameters.run_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Show content files for a learning resource
   * @summary Learning Resource Content File Retrieve
   * @param {LearningResourcesApiLearningResourcesContentfilesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesContentfilesRetrieve(
    requestParameters: LearningResourcesApiLearningResourcesContentfilesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesContentfilesRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a list of related learning resources for a learning resource.
   * @summary Nested Learning Resource List
   * @param {LearningResourcesApiLearningResourcesItemsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesItemsList(
    requestParameters: LearningResourcesApiLearningResourcesItemsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesItemsList(
        requestParameters.learning_resource_id,
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.sortby,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a singe related learning resource for a learning resource.
   * @summary Nested Learning Resource Retrieve
   * @param {LearningResourcesApiLearningResourcesItemsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesItemsRetrieve(
    requestParameters: LearningResourcesApiLearningResourcesItemsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesItemsRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Set Learning Path Relationships on a given Learning Resource.
   * @summary Set Learning Path Relationships
   * @param {LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesLearningPathsPartialUpdate(
    requestParameters: LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesLearningPathsPartialUpdate(
        requestParameters.id,
        requestParameters.learning_path_id,
        requestParameters.PatchedLearningResourceRelationshipRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of learning resources.
   * @summary List
   * @param {LearningResourcesApiLearningResourcesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesList(
    requestParameters: LearningResourcesApiLearningResourcesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single learning resource.
   * @summary Retrieve
   * @param {LearningResourcesApiLearningResourcesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesRetrieve(
    requestParameters: LearningResourcesApiLearningResourcesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Fetch similar learning resources, optionally narrowed by filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
   * @summary Get similar resources
   * @param {LearningResourcesApiLearningResourcesSimilarListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesSimilarList(
    requestParameters: LearningResourcesApiLearningResourcesSimilarListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesSimilarList(
        requestParameters.id,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of learning resources with summary fields
   * @summary Get learning resources summary
   * @param {LearningResourcesApiLearningResourcesSummaryListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesSummaryList(
    requestParameters: LearningResourcesApiLearningResourcesSummaryListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesSummaryList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Set User List Relationships on a given Learning Resource.
   * @summary Set User List Relationships
   * @param {LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesUserlistsPartialUpdate(
    requestParameters: LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesUserlistsPartialUpdate(
        requestParameters.id,
        requestParameters.userlist_id,
        requestParameters.PatchedUserListRelationshipRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Fetch similar learning resources, optionally narrowed by Qdrant filters.  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
   * @summary Get similar resources using vector embeddings
   * @param {LearningResourcesApiLearningResourcesVectorSimilarListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesVectorSimilarList(
    requestParameters: LearningResourcesApiLearningResourcesVectorSimilarListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesApiFp(this.configuration)
      .learningResourcesVectorSimilarList(
        requestParameters.id,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const LearningResourcesContentfilesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type LearningResourcesContentfilesListOfferedByEnum =
  (typeof LearningResourcesContentfilesListOfferedByEnum)[keyof typeof LearningResourcesContentfilesListOfferedByEnum]
export const LearningResourcesContentfilesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type LearningResourcesContentfilesListPlatformEnum =
  (typeof LearningResourcesContentfilesListPlatformEnum)[keyof typeof LearningResourcesContentfilesListPlatformEnum]
export const LearningResourcesListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type LearningResourcesListCertificationTypeEnum =
  (typeof LearningResourcesListCertificationTypeEnum)[keyof typeof LearningResourcesListCertificationTypeEnum]
export const LearningResourcesListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesListDeliveryEnum =
  (typeof LearningResourcesListDeliveryEnum)[keyof typeof LearningResourcesListDeliveryEnum]
export const LearningResourcesListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesListDepartmentEnum =
  (typeof LearningResourcesListDepartmentEnum)[keyof typeof LearningResourcesListDepartmentEnum]
export const LearningResourcesListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type LearningResourcesListLevelEnum =
  (typeof LearningResourcesListLevelEnum)[keyof typeof LearningResourcesListLevelEnum]
export const LearningResourcesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type LearningResourcesListOfferedByEnum =
  (typeof LearningResourcesListOfferedByEnum)[keyof typeof LearningResourcesListOfferedByEnum]
export const LearningResourcesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type LearningResourcesListPlatformEnum =
  (typeof LearningResourcesListPlatformEnum)[keyof typeof LearningResourcesListPlatformEnum]
export const LearningResourcesListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type LearningResourcesListResourceTypeEnum =
  (typeof LearningResourcesListResourceTypeEnum)[keyof typeof LearningResourcesListResourceTypeEnum]
export const LearningResourcesListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type LearningResourcesListResourceTypeGroupEnum =
  (typeof LearningResourcesListResourceTypeGroupEnum)[keyof typeof LearningResourcesListResourceTypeGroupEnum]
export const LearningResourcesListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type LearningResourcesListSortbyEnum =
  (typeof LearningResourcesListSortbyEnum)[keyof typeof LearningResourcesListSortbyEnum]
export const LearningResourcesSimilarListCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type LearningResourcesSimilarListCertificationTypeEnum =
  (typeof LearningResourcesSimilarListCertificationTypeEnum)[keyof typeof LearningResourcesSimilarListCertificationTypeEnum]
export const LearningResourcesSimilarListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesSimilarListDeliveryEnum =
  (typeof LearningResourcesSimilarListDeliveryEnum)[keyof typeof LearningResourcesSimilarListDeliveryEnum]
export const LearningResourcesSimilarListDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesSimilarListDepartmentEnum =
  (typeof LearningResourcesSimilarListDepartmentEnum)[keyof typeof LearningResourcesSimilarListDepartmentEnum]
export const LearningResourcesSimilarListLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesSimilarListLevelEnum =
  (typeof LearningResourcesSimilarListLevelEnum)[keyof typeof LearningResourcesSimilarListLevelEnum]
export const LearningResourcesSimilarListOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesSimilarListOfferedByEnum =
  (typeof LearningResourcesSimilarListOfferedByEnum)[keyof typeof LearningResourcesSimilarListOfferedByEnum]
export const LearningResourcesSimilarListPlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesSimilarListPlatformEnum =
  (typeof LearningResourcesSimilarListPlatformEnum)[keyof typeof LearningResourcesSimilarListPlatformEnum]
export const LearningResourcesSimilarListResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type LearningResourcesSimilarListResourceTypeEnum =
  (typeof LearningResourcesSimilarListResourceTypeEnum)[keyof typeof LearningResourcesSimilarListResourceTypeEnum]
export const LearningResourcesSimilarListResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type LearningResourcesSimilarListResourceTypeGroupEnum =
  (typeof LearningResourcesSimilarListResourceTypeGroupEnum)[keyof typeof LearningResourcesSimilarListResourceTypeGroupEnum]
export const LearningResourcesSummaryListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type LearningResourcesSummaryListCertificationTypeEnum =
  (typeof LearningResourcesSummaryListCertificationTypeEnum)[keyof typeof LearningResourcesSummaryListCertificationTypeEnum]
export const LearningResourcesSummaryListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesSummaryListDeliveryEnum =
  (typeof LearningResourcesSummaryListDeliveryEnum)[keyof typeof LearningResourcesSummaryListDeliveryEnum]
export const LearningResourcesSummaryListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesSummaryListDepartmentEnum =
  (typeof LearningResourcesSummaryListDepartmentEnum)[keyof typeof LearningResourcesSummaryListDepartmentEnum]
export const LearningResourcesSummaryListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type LearningResourcesSummaryListLevelEnum =
  (typeof LearningResourcesSummaryListLevelEnum)[keyof typeof LearningResourcesSummaryListLevelEnum]
export const LearningResourcesSummaryListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type LearningResourcesSummaryListOfferedByEnum =
  (typeof LearningResourcesSummaryListOfferedByEnum)[keyof typeof LearningResourcesSummaryListOfferedByEnum]
export const LearningResourcesSummaryListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type LearningResourcesSummaryListPlatformEnum =
  (typeof LearningResourcesSummaryListPlatformEnum)[keyof typeof LearningResourcesSummaryListPlatformEnum]
export const LearningResourcesSummaryListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type LearningResourcesSummaryListResourceTypeEnum =
  (typeof LearningResourcesSummaryListResourceTypeEnum)[keyof typeof LearningResourcesSummaryListResourceTypeEnum]
export const LearningResourcesSummaryListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type LearningResourcesSummaryListResourceTypeGroupEnum =
  (typeof LearningResourcesSummaryListResourceTypeGroupEnum)[keyof typeof LearningResourcesSummaryListResourceTypeGroupEnum]
export const LearningResourcesSummaryListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type LearningResourcesSummaryListSortbyEnum =
  (typeof LearningResourcesSummaryListSortbyEnum)[keyof typeof LearningResourcesSummaryListSortbyEnum]
export const LearningResourcesVectorSimilarListCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type LearningResourcesVectorSimilarListCertificationTypeEnum =
  (typeof LearningResourcesVectorSimilarListCertificationTypeEnum)[keyof typeof LearningResourcesVectorSimilarListCertificationTypeEnum]
export const LearningResourcesVectorSimilarListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesVectorSimilarListDeliveryEnum =
  (typeof LearningResourcesVectorSimilarListDeliveryEnum)[keyof typeof LearningResourcesVectorSimilarListDeliveryEnum]
export const LearningResourcesVectorSimilarListDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesVectorSimilarListDepartmentEnum =
  (typeof LearningResourcesVectorSimilarListDepartmentEnum)[keyof typeof LearningResourcesVectorSimilarListDepartmentEnum]
export const LearningResourcesVectorSimilarListLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesVectorSimilarListLevelEnum =
  (typeof LearningResourcesVectorSimilarListLevelEnum)[keyof typeof LearningResourcesVectorSimilarListLevelEnum]
export const LearningResourcesVectorSimilarListOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesVectorSimilarListOfferedByEnum =
  (typeof LearningResourcesVectorSimilarListOfferedByEnum)[keyof typeof LearningResourcesVectorSimilarListOfferedByEnum]
export const LearningResourcesVectorSimilarListPlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesVectorSimilarListPlatformEnum =
  (typeof LearningResourcesVectorSimilarListPlatformEnum)[keyof typeof LearningResourcesVectorSimilarListPlatformEnum]
export const LearningResourcesVectorSimilarListResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type LearningResourcesVectorSimilarListResourceTypeEnum =
  (typeof LearningResourcesVectorSimilarListResourceTypeEnum)[keyof typeof LearningResourcesVectorSimilarListResourceTypeEnum]
export const LearningResourcesVectorSimilarListResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type LearningResourcesVectorSimilarListResourceTypeGroupEnum =
  (typeof LearningResourcesVectorSimilarListResourceTypeGroupEnum)[keyof typeof LearningResourcesVectorSimilarListResourceTypeGroupEnum]

/**
 * LearningResourcesSearchApi - axios parameter creator
 */
export const LearningResourcesSearchApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Search for learning resources
     * @summary Search
     * @param {Array<LearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesSearchRetrieveLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesSearchRetrieveResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesSearchRetrieveSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesSearchRetrieveSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSearchRetrieve: async (
      aggregations?: Array<LearningResourcesSearchRetrieveAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesSearchRetrieveCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesSearchRetrieveDeliveryEnum>,
      department?: Array<LearningResourcesSearchRetrieveDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesSearchRetrieveLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesSearchRetrievePlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesSearchRetrieveResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSearchRetrieveResourceTypeGroupEnum>,
      search_mode?: LearningResourcesSearchRetrieveSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesSearchRetrieveSortbyEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources_search/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (content_file_score_weight !== undefined) {
        localVarQueryParameter["content_file_score_weight"] =
          content_file_score_weight
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (dev_mode !== undefined) {
        localVarQueryParameter["dev_mode"] = dev_mode
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (id) {
        localVarQueryParameter["id"] = id
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (max_incompleteness_penalty !== undefined) {
        localVarQueryParameter["max_incompleteness_penalty"] =
          max_incompleteness_penalty
      }

      if (min_score !== undefined) {
        localVarQueryParameter["min_score"] = min_score
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (search_mode !== undefined) {
        localVarQueryParameter["search_mode"] = search_mode
      }

      if (show_ocw_files !== undefined) {
        localVarQueryParameter["show_ocw_files"] = show_ocw_files
      }

      if (slop !== undefined) {
        localVarQueryParameter["slop"] = slop
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      if (yearly_decay_percent !== undefined) {
        localVarQueryParameter["yearly_decay_percent"] = yearly_decay_percent
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningResourcesSearchApi - functional programming interface
 */
export const LearningResourcesSearchApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    LearningResourcesSearchApiAxiosParamCreator(configuration)
  return {
    /**
     * Search for learning resources
     * @summary Search
     * @param {Array<LearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesSearchRetrieveLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesSearchRetrieveResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesSearchRetrieveSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesSearchRetrieveSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesSearchRetrieve(
      aggregations?: Array<LearningResourcesSearchRetrieveAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesSearchRetrieveCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesSearchRetrieveDeliveryEnum>,
      department?: Array<LearningResourcesSearchRetrieveDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesSearchRetrieveLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesSearchRetrievePlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesSearchRetrieveResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesSearchRetrieveResourceTypeGroupEnum>,
      search_mode?: LearningResourcesSearchRetrieveSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesSearchRetrieveSortbyEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourcesSearchResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesSearchRetrieve(
          aggregations,
          certification,
          certification_type,
          content_file_score_weight,
          course_feature,
          delivery,
          department,
          dev_mode,
          free,
          id,
          level,
          limit,
          max_incompleteness_penalty,
          min_score,
          ocw_topic,
          offered_by,
          offset,
          platform,
          professional,
          q,
          resource_category,
          resource_type,
          resource_type_group,
          search_mode,
          show_ocw_files,
          slop,
          sortby,
          topic,
          yearly_decay_percent,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesSearchApi.learningResourcesSearchRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningResourcesSearchApi - factory interface
 */
export const LearningResourcesSearchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningResourcesSearchApiFp(configuration)
  return {
    /**
     * Search for learning resources
     * @summary Search
     * @param {LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSearchRetrieve(
      requestParameters: LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourcesSearchResponse> {
      return localVarFp
        .learningResourcesSearchRetrieve(
          requestParameters.aggregations,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.content_file_score_weight,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.dev_mode,
          requestParameters.free,
          requestParameters.id,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.max_incompleteness_penalty,
          requestParameters.min_score,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.q,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.search_mode,
          requestParameters.show_ocw_files,
          requestParameters.slop,
          requestParameters.sortby,
          requestParameters.topic,
          requestParameters.yearly_decay_percent,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for learningResourcesSearchRetrieve operation in LearningResourcesSearchApi.
 */
export interface LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest {
  /**
   * Show resource counts by category
   */
  readonly aggregations?: Array<LearningResourcesSearchRetrieveAggregationsEnum>

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesSearchRetrieveCertificationTypeEnum>

  /**
   * Score weight for content file data.  1 is the default. 0 means content files are ignored
   */
  readonly content_file_score_weight?: number | null

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesSearchRetrieveDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesSearchRetrieveDepartmentEnum>

  /**
   * If true return raw open search results with score explanations
   */
  readonly dev_mode?: boolean | null

  readonly free?: boolean | null

  /**
   * The id value for the learning resource
   */
  readonly id?: Array<number>

  readonly level?: Array<LearningResourcesSearchRetrieveLevelEnum>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
   */
  readonly max_incompleteness_penalty?: number | null

  /**
   * Minimum score value a text query result needs to have to be displayed
   */
  readonly min_score?: number | null

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesSearchRetrieveOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesSearchRetrievePlatformEnum>

  readonly professional?: boolean | null

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesSearchRetrieveResourceTypeEnum>

  readonly resource_type_group?: Array<LearningResourcesSearchRetrieveResourceTypeGroupEnum>

  /**
   * The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
   */
  readonly search_mode?: LearningResourcesSearchRetrieveSearchModeEnum

  /**
   * Whether to include select OCW content files in search results.
   */
  readonly show_ocw_files?: boolean | null

  /**
   * Allowed distance for phrase search
   */
  readonly slop?: number | null

  /**
   * If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesSearchRetrieveSortbyEnum

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>

  /**
   * Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
   */
  readonly yearly_decay_percent?: number | null
}

/**
 * LearningResourcesSearchApi - object-oriented interface
 */
export class LearningResourcesSearchApi extends BaseAPI {
  /**
   * Search for learning resources
   * @summary Search
   * @param {LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesSearchRetrieve(
    requestParameters: LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesSearchApiFp(this.configuration)
      .learningResourcesSearchRetrieve(
        requestParameters.aggregations,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.content_file_score_weight,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.dev_mode,
        requestParameters.free,
        requestParameters.id,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.max_incompleteness_penalty,
        requestParameters.min_score,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.q,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.search_mode,
        requestParameters.show_ocw_files,
        requestParameters.slop,
        requestParameters.sortby,
        requestParameters.topic,
        requestParameters.yearly_decay_percent,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const LearningResourcesSearchRetrieveAggregationsEnum = {
  ResourceType: "resource_type",
  Certification: "certification",
  CertificationType: "certification_type",
  OfferedBy: "offered_by",
  Platform: "platform",
  Topic: "topic",
  Department: "department",
  Level: "level",
  CourseFeature: "course_feature",
  Professional: "professional",
  Free: "free",
  Delivery: "delivery",
  ResourceTypeGroup: "resource_type_group",
  ResourceCategory: "resource_category",
} as const
export type LearningResourcesSearchRetrieveAggregationsEnum =
  (typeof LearningResourcesSearchRetrieveAggregationsEnum)[keyof typeof LearningResourcesSearchRetrieveAggregationsEnum]
export const LearningResourcesSearchRetrieveCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type LearningResourcesSearchRetrieveCertificationTypeEnum =
  (typeof LearningResourcesSearchRetrieveCertificationTypeEnum)[keyof typeof LearningResourcesSearchRetrieveCertificationTypeEnum]
export const LearningResourcesSearchRetrieveDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesSearchRetrieveDeliveryEnum =
  (typeof LearningResourcesSearchRetrieveDeliveryEnum)[keyof typeof LearningResourcesSearchRetrieveDeliveryEnum]
export const LearningResourcesSearchRetrieveDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesSearchRetrieveDepartmentEnum =
  (typeof LearningResourcesSearchRetrieveDepartmentEnum)[keyof typeof LearningResourcesSearchRetrieveDepartmentEnum]
export const LearningResourcesSearchRetrieveLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesSearchRetrieveLevelEnum =
  (typeof LearningResourcesSearchRetrieveLevelEnum)[keyof typeof LearningResourcesSearchRetrieveLevelEnum]
export const LearningResourcesSearchRetrieveOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesSearchRetrieveOfferedByEnum =
  (typeof LearningResourcesSearchRetrieveOfferedByEnum)[keyof typeof LearningResourcesSearchRetrieveOfferedByEnum]
export const LearningResourcesSearchRetrievePlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesSearchRetrievePlatformEnum =
  (typeof LearningResourcesSearchRetrievePlatformEnum)[keyof typeof LearningResourcesSearchRetrievePlatformEnum]
export const LearningResourcesSearchRetrieveResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type LearningResourcesSearchRetrieveResourceTypeEnum =
  (typeof LearningResourcesSearchRetrieveResourceTypeEnum)[keyof typeof LearningResourcesSearchRetrieveResourceTypeEnum]
export const LearningResourcesSearchRetrieveResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type LearningResourcesSearchRetrieveResourceTypeGroupEnum =
  (typeof LearningResourcesSearchRetrieveResourceTypeGroupEnum)[keyof typeof LearningResourcesSearchRetrieveResourceTypeGroupEnum]
export const LearningResourcesSearchRetrieveSearchModeEnum = {
  Phrase: "phrase",
  BestFields: "best_fields",
  MostFields: "most_fields",
  Hybrid: "hybrid",
} as const
export type LearningResourcesSearchRetrieveSearchModeEnum =
  (typeof LearningResourcesSearchRetrieveSearchModeEnum)[keyof typeof LearningResourcesSearchRetrieveSearchModeEnum]
export const LearningResourcesSearchRetrieveSortbyEnum = {
  Featured: "featured",
  Id: "id",
  Id2: "-id",
  ReadableId: "readable_id",
  ReadableId2: "-readable_id",
  LastModified: "last_modified",
  LastModified2: "-last_modified",
  New: "new",
  StartDate: "start_date",
  StartDate2: "-start_date",
  Mitcoursenumber: "mitcoursenumber",
  Mitcoursenumber2: "-mitcoursenumber",
  Views: "views",
  Views2: "-views",
  Upcoming: "upcoming",
} as const
export type LearningResourcesSearchRetrieveSortbyEnum =
  (typeof LearningResourcesSearchRetrieveSortbyEnum)[keyof typeof LearningResourcesSearchRetrieveSortbyEnum]

/**
 * LearningResourcesUserSubscriptionApi - axios parameter creator
 */
export const LearningResourcesUserSubscriptionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * View for listing percolate query subscriptions for a user
     * @summary Check if a user is subscribed to a specific query
     * @param {Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionCheckListLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionCheckListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionCheckListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {LearningResourcesUserSubscriptionCheckListSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionCheckList: async (
      aggregations?: Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionCheckListLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionCheckListSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionCheckListSortbyEnum,
      source_type?: LearningResourcesUserSubscriptionCheckListSourceTypeEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources_user_subscription/check/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (content_file_score_weight !== undefined) {
        localVarQueryParameter["content_file_score_weight"] =
          content_file_score_weight
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (dev_mode !== undefined) {
        localVarQueryParameter["dev_mode"] = dev_mode
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (id) {
        localVarQueryParameter["id"] = id
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (max_incompleteness_penalty !== undefined) {
        localVarQueryParameter["max_incompleteness_penalty"] =
          max_incompleteness_penalty
      }

      if (min_score !== undefined) {
        localVarQueryParameter["min_score"] = min_score
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (search_mode !== undefined) {
        localVarQueryParameter["search_mode"] = search_mode
      }

      if (show_ocw_files !== undefined) {
        localVarQueryParameter["show_ocw_files"] = show_ocw_files
      }

      if (slop !== undefined) {
        localVarQueryParameter["slop"] = slop
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (source_type !== undefined) {
        localVarQueryParameter["source_type"] = source_type
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      if (yearly_decay_percent !== undefined) {
        localVarQueryParameter["yearly_decay_percent"] = yearly_decay_percent
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for listing percolate query subscriptions for a user
     * @summary List subscribed queries
     * @param {Array<LearningResourcesUserSubscriptionListAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionListLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionListResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionList: async (
      aggregations?: Array<LearningResourcesUserSubscriptionListAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionListDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionListDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionListLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionListPlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionListResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionListSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionListSortbyEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources_user_subscription/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (content_file_score_weight !== undefined) {
        localVarQueryParameter["content_file_score_weight"] =
          content_file_score_weight
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (dev_mode !== undefined) {
        localVarQueryParameter["dev_mode"] = dev_mode
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (id) {
        localVarQueryParameter["id"] = id
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (max_incompleteness_penalty !== undefined) {
        localVarQueryParameter["max_incompleteness_penalty"] =
          max_incompleteness_penalty
      }

      if (min_score !== undefined) {
        localVarQueryParameter["min_score"] = min_score
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (search_mode !== undefined) {
        localVarQueryParameter["search_mode"] = search_mode
      }

      if (show_ocw_files !== undefined) {
        localVarQueryParameter["show_ocw_files"] = show_ocw_files
      }

      if (slop !== undefined) {
        localVarQueryParameter["slop"] = slop
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      if (yearly_decay_percent !== undefined) {
        localVarQueryParameter["yearly_decay_percent"] = yearly_decay_percent
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Subscribe a user to query
     * @summary Subscribe user to query
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {PercolateQuerySubscriptionRequestRequest} [PercolateQuerySubscriptionRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionSubscribeCreate: async (
      aggregations?: Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum,
      source_type?: LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      PercolateQuerySubscriptionRequestRequest?: PercolateQuerySubscriptionRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learning_resources_user_subscription/subscribe/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (content_file_score_weight !== undefined) {
        localVarQueryParameter["content_file_score_weight"] =
          content_file_score_weight
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (dev_mode !== undefined) {
        localVarQueryParameter["dev_mode"] = dev_mode
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (id) {
        localVarQueryParameter["id"] = id
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (max_incompleteness_penalty !== undefined) {
        localVarQueryParameter["max_incompleteness_penalty"] =
          max_incompleteness_penalty
      }

      if (min_score !== undefined) {
        localVarQueryParameter["min_score"] = min_score
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (search_mode !== undefined) {
        localVarQueryParameter["search_mode"] = search_mode
      }

      if (show_ocw_files !== undefined) {
        localVarQueryParameter["show_ocw_files"] = show_ocw_files
      }

      if (slop !== undefined) {
        localVarQueryParameter["slop"] = slop
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (source_type !== undefined) {
        localVarQueryParameter["source_type"] = source_type
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      if (yearly_decay_percent !== undefined) {
        localVarQueryParameter["yearly_decay_percent"] = yearly_decay_percent
      }

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PercolateQuerySubscriptionRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
     * @summary Unsubscribe user from query
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionUnsubscribeDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "learningResourcesUserSubscriptionUnsubscribeDestroy",
        "id",
        id,
      )
      const localVarPath =
        `/api/v1/learning_resources_user_subscription/{id}/unsubscribe/`.replace(
          "{id}",
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningResourcesUserSubscriptionApi - functional programming interface
 */
export const LearningResourcesUserSubscriptionApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    LearningResourcesUserSubscriptionApiAxiosParamCreator(configuration)
  return {
    /**
     * View for listing percolate query subscriptions for a user
     * @summary Check if a user is subscribed to a specific query
     * @param {Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionCheckListLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionCheckListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionCheckListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {LearningResourcesUserSubscriptionCheckListSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesUserSubscriptionCheckList(
      aggregations?: Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionCheckListLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionCheckListSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionCheckListSortbyEnum,
      source_type?: LearningResourcesUserSubscriptionCheckListSourceTypeEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PercolateQuery>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesUserSubscriptionCheckList(
          aggregations,
          certification,
          certification_type,
          content_file_score_weight,
          course_feature,
          delivery,
          department,
          dev_mode,
          free,
          id,
          level,
          limit,
          max_incompleteness_penalty,
          min_score,
          ocw_topic,
          offered_by,
          offset,
          platform,
          professional,
          q,
          resource_category,
          resource_type,
          resource_type_group,
          search_mode,
          show_ocw_files,
          slop,
          sortby,
          source_type,
          topic,
          yearly_decay_percent,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionCheckList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for listing percolate query subscriptions for a user
     * @summary List subscribed queries
     * @param {Array<LearningResourcesUserSubscriptionListAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionListLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionListResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesUserSubscriptionList(
      aggregations?: Array<LearningResourcesUserSubscriptionListAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionListDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionListDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionListLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionListPlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionListResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionListResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionListSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionListSortbyEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PercolateQuery>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesUserSubscriptionList(
          aggregations,
          certification,
          certification_type,
          content_file_score_weight,
          course_feature,
          delivery,
          department,
          dev_mode,
          free,
          id,
          level,
          limit,
          max_incompleteness_penalty,
          min_score,
          ocw_topic,
          offered_by,
          offset,
          platform,
          professional,
          q,
          resource_category,
          resource_type,
          resource_type_group,
          search_mode,
          show_ocw_files,
          slop,
          sortby,
          topic,
          yearly_decay_percent,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionList"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Subscribe a user to query
     * @summary Subscribe user to query
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>} [aggregations] Show resource counts by category
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
     * @param {boolean | null} [free]
     * @param {Array<number>} [id] The id value for the learning resource
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
     * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum>} [resource_type_group]
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
     * @param {boolean | null} [show_ocw_files] Whether to include select OCW content files in search results.
     * @param {number | null} [slop] Allowed distance for phrase search
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
     * @param {PercolateQuerySubscriptionRequestRequest} [PercolateQuerySubscriptionRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesUserSubscriptionSubscribeCreate(
      aggregations?: Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>,
      content_file_score_weight?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>,
      department?: Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>,
      dev_mode?: boolean | null,
      free?: boolean | null,
      id?: Array<number>,
      level?: Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>,
      limit?: number,
      max_incompleteness_penalty?: number | null,
      min_score?: number | null,
      ocw_topic?: Array<string>,
      offered_by?: Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>,
      professional?: boolean | null,
      q?: string,
      resource_category?: Array<string>,
      resource_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>,
      resource_type_group?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum>,
      search_mode?: LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum,
      show_ocw_files?: boolean | null,
      slop?: number | null,
      sortby?: LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum,
      source_type?: LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum,
      topic?: Array<string>,
      yearly_decay_percent?: number | null,
      PercolateQuerySubscriptionRequestRequest?: PercolateQuerySubscriptionRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PercolateQuery>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesUserSubscriptionSubscribeCreate(
          aggregations,
          certification,
          certification_type,
          content_file_score_weight,
          course_feature,
          delivery,
          department,
          dev_mode,
          free,
          id,
          level,
          limit,
          max_incompleteness_penalty,
          min_score,
          ocw_topic,
          offered_by,
          offset,
          platform,
          professional,
          q,
          resource_category,
          resource_type,
          resource_type_group,
          search_mode,
          show_ocw_files,
          slop,
          sortby,
          source_type,
          topic,
          yearly_decay_percent,
          PercolateQuerySubscriptionRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionSubscribeCreate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
     * @summary Unsubscribe user from query
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesUserSubscriptionUnsubscribeDestroy(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesUserSubscriptionUnsubscribeDestroy(
          id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionUnsubscribeDestroy"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningResourcesUserSubscriptionApi - factory interface
 */
export const LearningResourcesUserSubscriptionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningResourcesUserSubscriptionApiFp(configuration)
  return {
    /**
     * View for listing percolate query subscriptions for a user
     * @summary Check if a user is subscribed to a specific query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionCheckList(
      requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PercolateQuery>> {
      return localVarFp
        .learningResourcesUserSubscriptionCheckList(
          requestParameters.aggregations,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.content_file_score_weight,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.dev_mode,
          requestParameters.free,
          requestParameters.id,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.max_incompleteness_penalty,
          requestParameters.min_score,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.q,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.search_mode,
          requestParameters.show_ocw_files,
          requestParameters.slop,
          requestParameters.sortby,
          requestParameters.source_type,
          requestParameters.topic,
          requestParameters.yearly_decay_percent,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * View for listing percolate query subscriptions for a user
     * @summary List subscribed queries
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionList(
      requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PercolateQuery>> {
      return localVarFp
        .learningResourcesUserSubscriptionList(
          requestParameters.aggregations,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.content_file_score_weight,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.dev_mode,
          requestParameters.free,
          requestParameters.id,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.max_incompleteness_penalty,
          requestParameters.min_score,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.q,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.search_mode,
          requestParameters.show_ocw_files,
          requestParameters.slop,
          requestParameters.sortby,
          requestParameters.topic,
          requestParameters.yearly_decay_percent,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Subscribe a user to query
     * @summary Subscribe user to query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionSubscribeCreate(
      requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PercolateQuery> {
      return localVarFp
        .learningResourcesUserSubscriptionSubscribeCreate(
          requestParameters.aggregations,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.content_file_score_weight,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.dev_mode,
          requestParameters.free,
          requestParameters.id,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.max_incompleteness_penalty,
          requestParameters.min_score,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.q,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.search_mode,
          requestParameters.show_ocw_files,
          requestParameters.slop,
          requestParameters.sortby,
          requestParameters.source_type,
          requestParameters.topic,
          requestParameters.yearly_decay_percent,
          requestParameters.PercolateQuerySubscriptionRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
     * @summary Unsubscribe user from query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesUserSubscriptionUnsubscribeDestroy(
      requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .learningResourcesUserSubscriptionUnsubscribeDestroy(
          requestParameters.id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for learningResourcesUserSubscriptionCheckList operation in LearningResourcesUserSubscriptionApi.
 */
export interface LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest {
  /**
   * Show resource counts by category
   */
  readonly aggregations?: Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>

  /**
   * Score weight for content file data.  1 is the default. 0 means content files are ignored
   */
  readonly content_file_score_weight?: number | null

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>

  /**
   * If true return raw open search results with score explanations
   */
  readonly dev_mode?: boolean | null

  readonly free?: boolean | null

  /**
   * The id value for the learning resource
   */
  readonly id?: Array<number>

  readonly level?: Array<LearningResourcesUserSubscriptionCheckListLevelEnum>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
   */
  readonly max_incompleteness_penalty?: number | null

  /**
   * Minimum score value a text query result needs to have to be displayed
   */
  readonly min_score?: number | null

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>

  readonly professional?: boolean | null

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>

  readonly resource_type_group?: Array<LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum>

  /**
   * The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
   */
  readonly search_mode?: LearningResourcesUserSubscriptionCheckListSearchModeEnum

  /**
   * Whether to include select OCW content files in search results.
   */
  readonly show_ocw_files?: boolean | null

  /**
   * Allowed distance for phrase search
   */
  readonly slop?: number | null

  /**
   * If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesUserSubscriptionCheckListSortbyEnum

  /**
   * The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
   */
  readonly source_type?: LearningResourcesUserSubscriptionCheckListSourceTypeEnum

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>

  /**
   * Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
   */
  readonly yearly_decay_percent?: number | null
}

/**
 * Request parameters for learningResourcesUserSubscriptionList operation in LearningResourcesUserSubscriptionApi.
 */
export interface LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest {
  /**
   * Show resource counts by category
   */
  readonly aggregations?: Array<LearningResourcesUserSubscriptionListAggregationsEnum>

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>

  /**
   * Score weight for content file data.  1 is the default. 0 means content files are ignored
   */
  readonly content_file_score_weight?: number | null

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesUserSubscriptionListDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesUserSubscriptionListDepartmentEnum>

  /**
   * If true return raw open search results with score explanations
   */
  readonly dev_mode?: boolean | null

  readonly free?: boolean | null

  /**
   * The id value for the learning resource
   */
  readonly id?: Array<number>

  readonly level?: Array<LearningResourcesUserSubscriptionListLevelEnum>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
   */
  readonly max_incompleteness_penalty?: number | null

  /**
   * Minimum score value a text query result needs to have to be displayed
   */
  readonly min_score?: number | null

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesUserSubscriptionListOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesUserSubscriptionListPlatformEnum>

  readonly professional?: boolean | null

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesUserSubscriptionListResourceTypeEnum>

  readonly resource_type_group?: Array<LearningResourcesUserSubscriptionListResourceTypeGroupEnum>

  /**
   * The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
   */
  readonly search_mode?: LearningResourcesUserSubscriptionListSearchModeEnum

  /**
   * Whether to include select OCW content files in search results.
   */
  readonly show_ocw_files?: boolean | null

  /**
   * Allowed distance for phrase search
   */
  readonly slop?: number | null

  /**
   * If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesUserSubscriptionListSortbyEnum

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>

  /**
   * Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
   */
  readonly yearly_decay_percent?: number | null
}

/**
 * Request parameters for learningResourcesUserSubscriptionSubscribeCreate operation in LearningResourcesUserSubscriptionApi.
 */
export interface LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest {
  /**
   * Show resource counts by category
   */
  readonly aggregations?: Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>

  /**
   * Score weight for content file data.  1 is the default. 0 means content files are ignored
   */
  readonly content_file_score_weight?: number | null

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>

  /**
   * If true return raw open search results with score explanations
   */
  readonly dev_mode?: boolean | null

  readonly free?: boolean | null

  /**
   * The id value for the learning resource
   */
  readonly id?: Array<number>

  readonly level?: Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
   */
  readonly max_incompleteness_penalty?: number | null

  /**
   * Minimum score value a text query result needs to have to be displayed
   */
  readonly min_score?: number | null

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>

  readonly professional?: boolean | null

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>

  readonly resource_type_group?: Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum>

  /**
   * The open search search type for text queries               * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid  * &#x60;phrase&#x60; - phrase * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;hybrid&#x60; - hybrid
   */
  readonly search_mode?: LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum

  /**
   * Whether to include select OCW content files in search results.
   */
  readonly show_ocw_files?: boolean | null

  /**
   * Allowed distance for phrase search
   */
  readonly slop?: number | null

  /**
   * If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum

  /**
   * The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
   */
  readonly source_type?: LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>

  /**
   * Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
   */
  readonly yearly_decay_percent?: number | null

  readonly PercolateQuerySubscriptionRequestRequest?: PercolateQuerySubscriptionRequestRequest
}

/**
 * Request parameters for learningResourcesUserSubscriptionUnsubscribeDestroy operation in LearningResourcesUserSubscriptionApi.
 */
export interface LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest {
  readonly id: number
}

/**
 * LearningResourcesUserSubscriptionApi - object-oriented interface
 */
export class LearningResourcesUserSubscriptionApi extends BaseAPI {
  /**
   * View for listing percolate query subscriptions for a user
   * @summary Check if a user is subscribed to a specific query
   * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesUserSubscriptionCheckList(
    requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesUserSubscriptionApiFp(this.configuration)
      .learningResourcesUserSubscriptionCheckList(
        requestParameters.aggregations,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.content_file_score_weight,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.dev_mode,
        requestParameters.free,
        requestParameters.id,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.max_incompleteness_penalty,
        requestParameters.min_score,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.q,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.search_mode,
        requestParameters.show_ocw_files,
        requestParameters.slop,
        requestParameters.sortby,
        requestParameters.source_type,
        requestParameters.topic,
        requestParameters.yearly_decay_percent,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for listing percolate query subscriptions for a user
   * @summary List subscribed queries
   * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesUserSubscriptionList(
    requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesUserSubscriptionApiFp(this.configuration)
      .learningResourcesUserSubscriptionList(
        requestParameters.aggregations,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.content_file_score_weight,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.dev_mode,
        requestParameters.free,
        requestParameters.id,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.max_incompleteness_penalty,
        requestParameters.min_score,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.q,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.search_mode,
        requestParameters.show_ocw_files,
        requestParameters.slop,
        requestParameters.sortby,
        requestParameters.topic,
        requestParameters.yearly_decay_percent,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Subscribe a user to query
   * @summary Subscribe user to query
   * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesUserSubscriptionSubscribeCreate(
    requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesUserSubscriptionApiFp(this.configuration)
      .learningResourcesUserSubscriptionSubscribeCreate(
        requestParameters.aggregations,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.content_file_score_weight,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.dev_mode,
        requestParameters.free,
        requestParameters.id,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.max_incompleteness_penalty,
        requestParameters.min_score,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.q,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.search_mode,
        requestParameters.show_ocw_files,
        requestParameters.slop,
        requestParameters.sortby,
        requestParameters.source_type,
        requestParameters.topic,
        requestParameters.yearly_decay_percent,
        requestParameters.PercolateQuerySubscriptionRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
   * @summary Unsubscribe user from query
   * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesUserSubscriptionUnsubscribeDestroy(
    requestParameters: LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesUserSubscriptionApiFp(this.configuration)
      .learningResourcesUserSubscriptionUnsubscribeDestroy(
        requestParameters.id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const LearningResourcesUserSubscriptionCheckListAggregationsEnum = {
  ResourceType: "resource_type",
  Certification: "certification",
  CertificationType: "certification_type",
  OfferedBy: "offered_by",
  Platform: "platform",
  Topic: "topic",
  Department: "department",
  Level: "level",
  CourseFeature: "course_feature",
  Professional: "professional",
  Free: "free",
  Delivery: "delivery",
  ResourceTypeGroup: "resource_type_group",
  ResourceCategory: "resource_category",
} as const
export type LearningResourcesUserSubscriptionCheckListAggregationsEnum =
  (typeof LearningResourcesUserSubscriptionCheckListAggregationsEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListAggregationsEnum]
export const LearningResourcesUserSubscriptionCheckListCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type LearningResourcesUserSubscriptionCheckListCertificationTypeEnum =
  (typeof LearningResourcesUserSubscriptionCheckListCertificationTypeEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListCertificationTypeEnum]
export const LearningResourcesUserSubscriptionCheckListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesUserSubscriptionCheckListDeliveryEnum =
  (typeof LearningResourcesUserSubscriptionCheckListDeliveryEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListDeliveryEnum]
export const LearningResourcesUserSubscriptionCheckListDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesUserSubscriptionCheckListDepartmentEnum =
  (typeof LearningResourcesUserSubscriptionCheckListDepartmentEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListDepartmentEnum]
export const LearningResourcesUserSubscriptionCheckListLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesUserSubscriptionCheckListLevelEnum =
  (typeof LearningResourcesUserSubscriptionCheckListLevelEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListLevelEnum]
export const LearningResourcesUserSubscriptionCheckListOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesUserSubscriptionCheckListOfferedByEnum =
  (typeof LearningResourcesUserSubscriptionCheckListOfferedByEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListOfferedByEnum]
export const LearningResourcesUserSubscriptionCheckListPlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesUserSubscriptionCheckListPlatformEnum =
  (typeof LearningResourcesUserSubscriptionCheckListPlatformEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListPlatformEnum]
export const LearningResourcesUserSubscriptionCheckListResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type LearningResourcesUserSubscriptionCheckListResourceTypeEnum =
  (typeof LearningResourcesUserSubscriptionCheckListResourceTypeEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListResourceTypeEnum]
export const LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum =
  (typeof LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListResourceTypeGroupEnum]
export const LearningResourcesUserSubscriptionCheckListSearchModeEnum = {
  Phrase: "phrase",
  BestFields: "best_fields",
  MostFields: "most_fields",
  Hybrid: "hybrid",
} as const
export type LearningResourcesUserSubscriptionCheckListSearchModeEnum =
  (typeof LearningResourcesUserSubscriptionCheckListSearchModeEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListSearchModeEnum]
export const LearningResourcesUserSubscriptionCheckListSortbyEnum = {
  Featured: "featured",
  Id: "id",
  Id2: "-id",
  ReadableId: "readable_id",
  ReadableId2: "-readable_id",
  LastModified: "last_modified",
  LastModified2: "-last_modified",
  New: "new",
  StartDate: "start_date",
  StartDate2: "-start_date",
  Mitcoursenumber: "mitcoursenumber",
  Mitcoursenumber2: "-mitcoursenumber",
  Views: "views",
  Views2: "-views",
  Upcoming: "upcoming",
} as const
export type LearningResourcesUserSubscriptionCheckListSortbyEnum =
  (typeof LearningResourcesUserSubscriptionCheckListSortbyEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListSortbyEnum]
export const LearningResourcesUserSubscriptionCheckListSourceTypeEnum = {
  SearchSubscriptionType: "search_subscription_type",
  ChannelSubscriptionType: "channel_subscription_type",
} as const
export type LearningResourcesUserSubscriptionCheckListSourceTypeEnum =
  (typeof LearningResourcesUserSubscriptionCheckListSourceTypeEnum)[keyof typeof LearningResourcesUserSubscriptionCheckListSourceTypeEnum]
export const LearningResourcesUserSubscriptionListAggregationsEnum = {
  ResourceType: "resource_type",
  Certification: "certification",
  CertificationType: "certification_type",
  OfferedBy: "offered_by",
  Platform: "platform",
  Topic: "topic",
  Department: "department",
  Level: "level",
  CourseFeature: "course_feature",
  Professional: "professional",
  Free: "free",
  Delivery: "delivery",
  ResourceTypeGroup: "resource_type_group",
  ResourceCategory: "resource_category",
} as const
export type LearningResourcesUserSubscriptionListAggregationsEnum =
  (typeof LearningResourcesUserSubscriptionListAggregationsEnum)[keyof typeof LearningResourcesUserSubscriptionListAggregationsEnum]
export const LearningResourcesUserSubscriptionListCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type LearningResourcesUserSubscriptionListCertificationTypeEnum =
  (typeof LearningResourcesUserSubscriptionListCertificationTypeEnum)[keyof typeof LearningResourcesUserSubscriptionListCertificationTypeEnum]
export const LearningResourcesUserSubscriptionListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesUserSubscriptionListDeliveryEnum =
  (typeof LearningResourcesUserSubscriptionListDeliveryEnum)[keyof typeof LearningResourcesUserSubscriptionListDeliveryEnum]
export const LearningResourcesUserSubscriptionListDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesUserSubscriptionListDepartmentEnum =
  (typeof LearningResourcesUserSubscriptionListDepartmentEnum)[keyof typeof LearningResourcesUserSubscriptionListDepartmentEnum]
export const LearningResourcesUserSubscriptionListLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesUserSubscriptionListLevelEnum =
  (typeof LearningResourcesUserSubscriptionListLevelEnum)[keyof typeof LearningResourcesUserSubscriptionListLevelEnum]
export const LearningResourcesUserSubscriptionListOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesUserSubscriptionListOfferedByEnum =
  (typeof LearningResourcesUserSubscriptionListOfferedByEnum)[keyof typeof LearningResourcesUserSubscriptionListOfferedByEnum]
export const LearningResourcesUserSubscriptionListPlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesUserSubscriptionListPlatformEnum =
  (typeof LearningResourcesUserSubscriptionListPlatformEnum)[keyof typeof LearningResourcesUserSubscriptionListPlatformEnum]
export const LearningResourcesUserSubscriptionListResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type LearningResourcesUserSubscriptionListResourceTypeEnum =
  (typeof LearningResourcesUserSubscriptionListResourceTypeEnum)[keyof typeof LearningResourcesUserSubscriptionListResourceTypeEnum]
export const LearningResourcesUserSubscriptionListResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type LearningResourcesUserSubscriptionListResourceTypeGroupEnum =
  (typeof LearningResourcesUserSubscriptionListResourceTypeGroupEnum)[keyof typeof LearningResourcesUserSubscriptionListResourceTypeGroupEnum]
export const LearningResourcesUserSubscriptionListSearchModeEnum = {
  Phrase: "phrase",
  BestFields: "best_fields",
  MostFields: "most_fields",
  Hybrid: "hybrid",
} as const
export type LearningResourcesUserSubscriptionListSearchModeEnum =
  (typeof LearningResourcesUserSubscriptionListSearchModeEnum)[keyof typeof LearningResourcesUserSubscriptionListSearchModeEnum]
export const LearningResourcesUserSubscriptionListSortbyEnum = {
  Featured: "featured",
  Id: "id",
  Id2: "-id",
  ReadableId: "readable_id",
  ReadableId2: "-readable_id",
  LastModified: "last_modified",
  LastModified2: "-last_modified",
  New: "new",
  StartDate: "start_date",
  StartDate2: "-start_date",
  Mitcoursenumber: "mitcoursenumber",
  Mitcoursenumber2: "-mitcoursenumber",
  Views: "views",
  Views2: "-views",
  Upcoming: "upcoming",
} as const
export type LearningResourcesUserSubscriptionListSortbyEnum =
  (typeof LearningResourcesUserSubscriptionListSortbyEnum)[keyof typeof LearningResourcesUserSubscriptionListSortbyEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum =
  {
    ResourceType: "resource_type",
    Certification: "certification",
    CertificationType: "certification_type",
    OfferedBy: "offered_by",
    Platform: "platform",
    Topic: "topic",
    Department: "department",
    Level: "level",
    CourseFeature: "course_feature",
    Professional: "professional",
    Free: "free",
    Delivery: "delivery",
    ResourceTypeGroup: "resource_type_group",
    ResourceCategory: "resource_category",
  } as const
export type LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum =
  {
    Micromasters: "micromasters",
    Professional: "professional",
    Completion: "completion",
    None: "none",
  } as const
export type LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateLevelEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateLevelEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateLevelEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum]
export const LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum =
  {
    Course: "course",
    Program: "program",
    LearningPath: "learning_path",
    Podcast: "podcast",
    PodcastEpisode: "podcast_episode",
    Video: "video",
    VideoPlaylist: "video_playlist",
    Document: "document",
  } as const
export type LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum =
  {
    Course: "course",
    Program: "program",
    LearningMaterial: "learning_material",
  } as const
export type LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateResourceTypeGroupEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum = {
  Phrase: "phrase",
  BestFields: "best_fields",
  MostFields: "most_fields",
  Hybrid: "hybrid",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum = {
  Featured: "featured",
  Id: "id",
  Id2: "-id",
  ReadableId: "readable_id",
  ReadableId2: "-readable_id",
  LastModified: "last_modified",
  LastModified2: "-last_modified",
  New: "new",
  StartDate: "start_date",
  StartDate2: "-start_date",
  Mitcoursenumber: "mitcoursenumber",
  Mitcoursenumber2: "-mitcoursenumber",
  Views: "views",
  Views2: "-views",
  Upcoming: "upcoming",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum]
export const LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum = {
  SearchSubscriptionType: "search_subscription_type",
  ChannelSubscriptionType: "channel_subscription_type",
} as const
export type LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum =
  (typeof LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum)[keyof typeof LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum]

/**
 * LearningpathsApi - axios parameter creator
 */
export const LearningpathsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Create a learning path
     * @summary Create
     * @param {LearningPathResourceRequest} LearningPathResourceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsCreate: async (
      LearningPathResourceRequest: LearningPathResourceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'LearningPathResourceRequest' is not null or undefined
      assertParamExists(
        "learningpathsCreate",
        "LearningPathResourceRequest",
        LearningPathResourceRequest,
      )
      const localVarPath = `/api/v1/learningpaths/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        LearningPathResourceRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Remove a learning path
     * @summary Destroy
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsDestroy", "id", id)
      const localVarPath = `/api/v1/learningpaths/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Add
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {LearningPathRelationshipCreateRequest} LearningPathRelationshipCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsCreate: async (
      learning_resource_id: number,
      LearningPathRelationshipCreateRequest: LearningPathRelationshipCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningpathsItemsCreate",
        "learning_resource_id",
        learning_resource_id,
      )
      // verify required parameter 'LearningPathRelationshipCreateRequest' is not null or undefined
      assertParamExists(
        "learningpathsItemsCreate",
        "LearningPathRelationshipCreateRequest",
        LearningPathRelationshipCreateRequest,
      )
      const localVarPath =
        `/api/v1/learningpaths/{learning_resource_id}/items/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        LearningPathRelationshipCreateRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Remove
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsDestroy: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsItemsDestroy", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningpathsItemsDestroy",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for LearningPath related resources
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsList: async (
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningpathsItemsList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learningpaths/{learning_resource_id}/items/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Update
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {PatchedLearningPathRelationshipCreateRequest} [PatchedLearningPathRelationshipCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsPartialUpdate: async (
      id: number,
      learning_resource_id: number,
      PatchedLearningPathRelationshipCreateRequest?: PatchedLearningPathRelationshipCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsItemsPartialUpdate", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningpathsItemsPartialUpdate",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedLearningPathRelationshipCreateRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsItemsRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "learningpathsItemsRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of learning paths
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningpathsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningpathsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningpathsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningpathsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningpathsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningpathsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningpathsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningpathsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningpathsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsList: async (
      certification?: boolean,
      certification_type?: Array<LearningpathsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningpathsListDeliveryEnum>>,
      department?: Array<LearningpathsListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningpathsListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningpathsListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningpathsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningpathsListResourceTypeEnum>,
      resource_type_group?: Array<LearningpathsListResourceTypeGroupEnum>,
      sortby?: LearningpathsListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learningpaths/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a list of all learning path items
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsMembershipList: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/learningpaths/membership/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update individual fields of a learning path
     * @summary Update
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {PatchedLearningPathResourceRequest} [PatchedLearningPathResourceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsPartialUpdate: async (
      id: number,
      PatchedLearningPathResourceRequest?: PatchedLearningPathResourceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsPartialUpdate", "id", id)
      const localVarPath = `/api/v1/learningpaths/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedLearningPathResourceRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrive a single learning path
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("learningpathsRetrieve", "id", id)
      const localVarPath = `/api/v1/learningpaths/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningpathsApi - functional programming interface
 */
export const LearningpathsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    LearningpathsApiAxiosParamCreator(configuration)
  return {
    /**
     * Create a learning path
     * @summary Create
     * @param {LearningPathResourceRequest} LearningPathResourceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsCreate(
      LearningPathResourceRequest: LearningPathResourceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsCreate(
          LearningPathResourceRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Remove a learning path
     * @summary Destroy
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsDestroy(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Add
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {LearningPathRelationshipCreateRequest} LearningPathRelationshipCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsItemsCreate(
      learning_resource_id: number,
      LearningPathRelationshipCreateRequest: LearningPathRelationshipCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsItemsCreate(
          learning_resource_id,
          LearningPathRelationshipCreateRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Remove
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsItemsDestroy(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsItemsDestroy(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for LearningPath related resources
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsItemsList(
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningPathRelationshipList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsItemsList(
          learning_resource_id,
          limit,
          offset,
          sortby,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Update
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {PatchedLearningPathRelationshipCreateRequest} [PatchedLearningPathRelationshipCreateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsItemsPartialUpdate(
      id: number,
      learning_resource_id: number,
      PatchedLearningPathRelationshipCreateRequest?: PatchedLearningPathRelationshipCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathRelationshipCreate>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsItemsPartialUpdate(
          id,
          learning_resource_id,
          PatchedLearningPathRelationshipCreateRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningpathsApi.learningpathsItemsPartialUpdate"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id The learning resource id of the learning path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsItemsRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsItemsRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of learning paths
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<LearningpathsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<LearningpathsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<LearningpathsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<LearningpathsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<LearningpathsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<LearningpathsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<LearningpathsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<LearningpathsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {LearningpathsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsList(
      certification?: boolean,
      certification_type?: Array<LearningpathsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<LearningpathsListDeliveryEnum>>,
      department?: Array<LearningpathsListDepartmentEnum>,
      free?: boolean,
      level?: Array<LearningpathsListLevelEnum>,
      limit?: number,
      offered_by?: Array<LearningpathsListOfferedByEnum>,
      offset?: number,
      platform?: Array<LearningpathsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<LearningpathsListResourceTypeEnum>,
      resource_type_group?: Array<LearningpathsListResourceTypeGroupEnum>,
      sortby?: LearningpathsListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningPathResourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a list of all learning path items
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsMembershipList(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MicroLearningPathRelationship>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsMembershipList(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsMembershipList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update individual fields of a learning path
     * @summary Update
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {PatchedLearningPathResourceRequest} [PatchedLearningPathResourceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsPartialUpdate(
      id: number,
      PatchedLearningPathResourceRequest?: PatchedLearningPathResourceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsPartialUpdate(
          id,
          PatchedLearningPathResourceRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrive a single learning path
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningpathsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningPathResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningpathsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["LearningpathsApi.learningpathsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningpathsApi - factory interface
 */
export const LearningpathsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningpathsApiFp(configuration)
  return {
    /**
     * Create a learning path
     * @summary Create
     * @param {LearningpathsApiLearningpathsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsCreate(
      requestParameters: LearningpathsApiLearningpathsCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathResource> {
      return localVarFp
        .learningpathsCreate(
          requestParameters.LearningPathResourceRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Remove a learning path
     * @summary Destroy
     * @param {LearningpathsApiLearningpathsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsDestroy(
      requestParameters: LearningpathsApiLearningpathsDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .learningpathsDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Add
     * @param {LearningpathsApiLearningpathsItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsCreate(
      requestParameters: LearningpathsApiLearningpathsItemsCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathRelationship> {
      return localVarFp
        .learningpathsItemsCreate(
          requestParameters.learning_resource_id,
          requestParameters.LearningPathRelationshipCreateRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Remove
     * @param {LearningpathsApiLearningpathsItemsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsDestroy(
      requestParameters: LearningpathsApiLearningpathsItemsDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .learningpathsItemsDestroy(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for LearningPath related resources
     * @param {LearningpathsApiLearningpathsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsList(
      requestParameters: LearningpathsApiLearningpathsItemsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningPathRelationshipList> {
      return localVarFp
        .learningpathsItemsList(
          requestParameters.learning_resource_id,
          requestParameters.limit,
          requestParameters.offset,
          requestParameters.sortby,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Update
     * @param {LearningpathsApiLearningpathsItemsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsPartialUpdate(
      requestParameters: LearningpathsApiLearningpathsItemsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathRelationshipCreate> {
      return localVarFp
        .learningpathsItemsPartialUpdate(
          requestParameters.id,
          requestParameters.learning_resource_id,
          requestParameters.PatchedLearningPathRelationshipCreateRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {LearningpathsApiLearningpathsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsItemsRetrieve(
      requestParameters: LearningpathsApiLearningpathsItemsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathRelationship> {
      return localVarFp
        .learningpathsItemsRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of learning paths
     * @summary List
     * @param {LearningpathsApiLearningpathsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsList(
      requestParameters: LearningpathsApiLearningpathsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningPathResourceList> {
      return localVarFp
        .learningpathsList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a list of all learning path items
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsMembershipList(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MicroLearningPathRelationship>> {
      return localVarFp
        .learningpathsMembershipList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update individual fields of a learning path
     * @summary Update
     * @param {LearningpathsApiLearningpathsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsPartialUpdate(
      requestParameters: LearningpathsApiLearningpathsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathResource> {
      return localVarFp
        .learningpathsPartialUpdate(
          requestParameters.id,
          requestParameters.PatchedLearningPathResourceRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrive a single learning path
     * @summary Retrieve
     * @param {LearningpathsApiLearningpathsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningpathsRetrieve(
      requestParameters: LearningpathsApiLearningpathsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningPathResource> {
      return localVarFp
        .learningpathsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for learningpathsCreate operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsCreateRequest {
  readonly LearningPathResourceRequest: LearningPathResourceRequest
}

/**
 * Request parameters for learningpathsDestroy operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsDestroyRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * Request parameters for learningpathsItemsCreate operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsItemsCreateRequest {
  /**
   * The learning resource id of the learning path
   */
  readonly learning_resource_id: number

  readonly LearningPathRelationshipCreateRequest: LearningPathRelationshipCreateRequest
}

/**
 * Request parameters for learningpathsItemsDestroy operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsItemsDestroyRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * The learning resource id of the learning path
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for learningpathsItemsList operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsItemsListRequest {
  /**
   * The learning resource id of the learning path
   */
  readonly learning_resource_id: number

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Which field to use when ordering the results.
   */
  readonly sortby?: string
}

/**
 * Request parameters for learningpathsItemsPartialUpdate operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsItemsPartialUpdateRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * The learning resource id of the learning path
   */
  readonly learning_resource_id: number

  readonly PatchedLearningPathRelationshipCreateRequest?: PatchedLearningPathRelationshipCreateRequest
}

/**
 * Request parameters for learningpathsItemsRetrieve operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsItemsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * The learning resource id of the learning path
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for learningpathsList operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<LearningpathsListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<LearningpathsListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<LearningpathsListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<LearningpathsListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<LearningpathsListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<LearningpathsListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<LearningpathsListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<LearningpathsListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: LearningpathsListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for learningpathsPartialUpdate operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsPartialUpdateRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number

  readonly PatchedLearningPathResourceRequest?: PatchedLearningPathResourceRequest
}

/**
 * Request parameters for learningpathsRetrieve operation in LearningpathsApi.
 */
export interface LearningpathsApiLearningpathsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * LearningpathsApi - object-oriented interface
 */
export class LearningpathsApi extends BaseAPI {
  /**
   * Create a learning path
   * @summary Create
   * @param {LearningpathsApiLearningpathsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsCreate(
    requestParameters: LearningpathsApiLearningpathsCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsCreate(
        requestParameters.LearningPathResourceRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Remove a learning path
   * @summary Destroy
   * @param {LearningpathsApiLearningpathsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsDestroy(
    requestParameters: LearningpathsApiLearningpathsDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for LearningPath related resources
   * @summary Learning Path Resource Relationship Add
   * @param {LearningpathsApiLearningpathsItemsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsItemsCreate(
    requestParameters: LearningpathsApiLearningpathsItemsCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsItemsCreate(
        requestParameters.learning_resource_id,
        requestParameters.LearningPathRelationshipCreateRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for LearningPath related resources
   * @summary Learning Path Resource Relationship Remove
   * @param {LearningpathsApiLearningpathsItemsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsItemsDestroy(
    requestParameters: LearningpathsApiLearningpathsItemsDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsItemsDestroy(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for LearningPath related resources
   * @param {LearningpathsApiLearningpathsItemsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsItemsList(
    requestParameters: LearningpathsApiLearningpathsItemsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsItemsList(
        requestParameters.learning_resource_id,
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.sortby,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for LearningPath related resources
   * @summary Learning Path Resource Relationship Update
   * @param {LearningpathsApiLearningpathsItemsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsItemsPartialUpdate(
    requestParameters: LearningpathsApiLearningpathsItemsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsItemsPartialUpdate(
        requestParameters.id,
        requestParameters.learning_resource_id,
        requestParameters.PatchedLearningPathRelationshipCreateRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a singe related learning resource for a learning resource.
   * @summary Nested Learning Resource Retrieve
   * @param {LearningpathsApiLearningpathsItemsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsItemsRetrieve(
    requestParameters: LearningpathsApiLearningpathsItemsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsItemsRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of learning paths
   * @summary List
   * @param {LearningpathsApiLearningpathsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsList(
    requestParameters: LearningpathsApiLearningpathsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a list of all learning path items
   * @summary List
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsMembershipList(options?: RawAxiosRequestConfig) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsMembershipList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update individual fields of a learning path
   * @summary Update
   * @param {LearningpathsApiLearningpathsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsPartialUpdate(
    requestParameters: LearningpathsApiLearningpathsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsPartialUpdate(
        requestParameters.id,
        requestParameters.PatchedLearningPathResourceRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrive a single learning path
   * @summary Retrieve
   * @param {LearningpathsApiLearningpathsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningpathsRetrieve(
    requestParameters: LearningpathsApiLearningpathsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LearningpathsApiFp(this.configuration)
      .learningpathsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const LearningpathsListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type LearningpathsListCertificationTypeEnum =
  (typeof LearningpathsListCertificationTypeEnum)[keyof typeof LearningpathsListCertificationTypeEnum]
export const LearningpathsListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type LearningpathsListDeliveryEnum =
  (typeof LearningpathsListDeliveryEnum)[keyof typeof LearningpathsListDeliveryEnum]
export const LearningpathsListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type LearningpathsListDepartmentEnum =
  (typeof LearningpathsListDepartmentEnum)[keyof typeof LearningpathsListDepartmentEnum]
export const LearningpathsListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type LearningpathsListLevelEnum =
  (typeof LearningpathsListLevelEnum)[keyof typeof LearningpathsListLevelEnum]
export const LearningpathsListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type LearningpathsListOfferedByEnum =
  (typeof LearningpathsListOfferedByEnum)[keyof typeof LearningpathsListOfferedByEnum]
export const LearningpathsListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type LearningpathsListPlatformEnum =
  (typeof LearningpathsListPlatformEnum)[keyof typeof LearningpathsListPlatformEnum]
export const LearningpathsListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type LearningpathsListResourceTypeEnum =
  (typeof LearningpathsListResourceTypeEnum)[keyof typeof LearningpathsListResourceTypeEnum]
export const LearningpathsListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type LearningpathsListResourceTypeGroupEnum =
  (typeof LearningpathsListResourceTypeGroupEnum)[keyof typeof LearningpathsListResourceTypeGroupEnum]
export const LearningpathsListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type LearningpathsListSortbyEnum =
  (typeof LearningpathsListSortbyEnum)[keyof typeof LearningpathsListSortbyEnum]

/**
 * MediaApi - axios parameter creator
 */
export const MediaApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Upload an image (multipart/form-data) and return the storage URL.
     * @param {File} image_file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mediaUpload: async (
      image_file: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'image_file' is not null or undefined
      assertParamExists("mediaUpload", "image_file", image_file)
      const localVarPath = `/api/v1/upload-media/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )()

      if (image_file !== undefined) {
        localVarFormParams.append("image_file", image_file as any)
      }
      localVarHeaderParameter["Content-Type"] = "multipart/form-data"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MediaApi - functional programming interface
 */
export const MediaApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
  return {
    /**
     * Upload an image (multipart/form-data) and return the storage URL.
     * @param {File} image_file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mediaUpload(
      image_file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MediaUpload201Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mediaUpload(
        image_file,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MediaApi.mediaUpload"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * MediaApi - factory interface
 */
export const MediaApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MediaApiFp(configuration)
  return {
    /**
     * Upload an image (multipart/form-data) and return the storage URL.
     * @param {MediaApiMediaUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mediaUpload(
      requestParameters: MediaApiMediaUploadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MediaUpload201Response> {
      return localVarFp
        .mediaUpload(requestParameters.image_file, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for mediaUpload operation in MediaApi.
 */
export interface MediaApiMediaUploadRequest {
  readonly image_file: File
}

/**
 * MediaApi - object-oriented interface
 */
export class MediaApi extends BaseAPI {
  /**
   * Upload an image (multipart/form-data) and return the storage URL.
   * @param {MediaApiMediaUploadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public mediaUpload(
    requestParameters: MediaApiMediaUploadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MediaApiFp(this.configuration)
      .mediaUpload(requestParameters.image_file, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * OfferorsApi - axios parameter creator
 */
export const OfferorsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * MIT organizations that offer learning resources
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offerorsList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/offerors/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * MIT organizations that offer learning resources
     * @summary Retrieve
     * @param {string} code A unique value identifying this learning resource offeror.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offerorsRetrieve: async (
      code: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("offerorsRetrieve", "code", code)
      const localVarPath = `/api/v1/offerors/{code}/`.replace(
        "{code}",
        encodeURIComponent(String(code)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * OfferorsApi - functional programming interface
 */
export const OfferorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OfferorsApiAxiosParamCreator(configuration)
  return {
    /**
     * MIT organizations that offer learning resources
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async offerorsList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceOfferorDetailList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.offerorsList(
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OfferorsApi.offerorsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * MIT organizations that offer learning resources
     * @summary Retrieve
     * @param {string} code A unique value identifying this learning resource offeror.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async offerorsRetrieve(
      code: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceOfferorDetail>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.offerorsRetrieve(code, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["OfferorsApi.offerorsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * OfferorsApi - factory interface
 */
export const OfferorsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OfferorsApiFp(configuration)
  return {
    /**
     * MIT organizations that offer learning resources
     * @summary List
     * @param {OfferorsApiOfferorsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offerorsList(
      requestParameters: OfferorsApiOfferorsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceOfferorDetailList> {
      return localVarFp
        .offerorsList(
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * MIT organizations that offer learning resources
     * @summary Retrieve
     * @param {OfferorsApiOfferorsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    offerorsRetrieve(
      requestParameters: OfferorsApiOfferorsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceOfferorDetail> {
      return localVarFp
        .offerorsRetrieve(requestParameters.code, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for offerorsList operation in OfferorsApi.
 */
export interface OfferorsApiOfferorsListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for offerorsRetrieve operation in OfferorsApi.
 */
export interface OfferorsApiOfferorsRetrieveRequest {
  /**
   * A unique value identifying this learning resource offeror.
   */
  readonly code: string
}

/**
 * OfferorsApi - object-oriented interface
 */
export class OfferorsApi extends BaseAPI {
  /**
   * MIT organizations that offer learning resources
   * @summary List
   * @param {OfferorsApiOfferorsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public offerorsList(
    requestParameters: OfferorsApiOfferorsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return OfferorsApiFp(this.configuration)
      .offerorsList(requestParameters.limit, requestParameters.offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * MIT organizations that offer learning resources
   * @summary Retrieve
   * @param {OfferorsApiOfferorsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public offerorsRetrieve(
    requestParameters: OfferorsApiOfferorsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OfferorsApiFp(this.configuration)
      .offerorsRetrieve(requestParameters.code, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PlatformsApi - axios parameter creator
 */
export const PlatformsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Platforms on which learning resources are hosted
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformsList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/platforms/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Platforms on which learning resources are hosted
     * @summary Retrieve
     * @param {string} code A unique value identifying this learning resource platform.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformsRetrieve: async (
      code: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("platformsRetrieve", "code", code)
      const localVarPath = `/api/v1/platforms/{code}/`.replace(
        "{code}",
        encodeURIComponent(String(code)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PlatformsApi - functional programming interface
 */
export const PlatformsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlatformsApiAxiosParamCreator(configuration)
  return {
    /**
     * Platforms on which learning resources are hosted
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformsList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourcePlatformList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformsList(
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlatformsApi.platformsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Platforms on which learning resources are hosted
     * @summary Retrieve
     * @param {string} code A unique value identifying this learning resource platform.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformsRetrieve(
      code: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourcePlatform>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.platformsRetrieve(code, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PlatformsApi.platformsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PlatformsApi - factory interface
 */
export const PlatformsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlatformsApiFp(configuration)
  return {
    /**
     * Platforms on which learning resources are hosted
     * @summary List
     * @param {PlatformsApiPlatformsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformsList(
      requestParameters: PlatformsApiPlatformsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourcePlatformList> {
      return localVarFp
        .platformsList(
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Platforms on which learning resources are hosted
     * @summary Retrieve
     * @param {PlatformsApiPlatformsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformsRetrieve(
      requestParameters: PlatformsApiPlatformsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourcePlatform> {
      return localVarFp
        .platformsRetrieve(requestParameters.code, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for platformsList operation in PlatformsApi.
 */
export interface PlatformsApiPlatformsListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for platformsRetrieve operation in PlatformsApi.
 */
export interface PlatformsApiPlatformsRetrieveRequest {
  /**
   * A unique value identifying this learning resource platform.
   */
  readonly code: string
}

/**
 * PlatformsApi - object-oriented interface
 */
export class PlatformsApi extends BaseAPI {
  /**
   * Platforms on which learning resources are hosted
   * @summary List
   * @param {PlatformsApiPlatformsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public platformsList(
    requestParameters: PlatformsApiPlatformsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return PlatformsApiFp(this.configuration)
      .platformsList(requestParameters.limit, requestParameters.offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Platforms on which learning resources are hosted
   * @summary Retrieve
   * @param {PlatformsApiPlatformsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public platformsRetrieve(
    requestParameters: PlatformsApiPlatformsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlatformsApiFp(this.configuration)
      .platformsRetrieve(requestParameters.code, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PodcastEpisodesApi - axios parameter creator
 */
export const PodcastEpisodesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of podcast episodes
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<PodcastEpisodesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<PodcastEpisodesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<PodcastEpisodesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<PodcastEpisodesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<PodcastEpisodesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<PodcastEpisodesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<PodcastEpisodesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<PodcastEpisodesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {PodcastEpisodesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesList: async (
      certification?: boolean,
      certification_type?: Array<PodcastEpisodesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<PodcastEpisodesListDeliveryEnum>>,
      department?: Array<PodcastEpisodesListDepartmentEnum>,
      free?: boolean,
      level?: Array<PodcastEpisodesListLevelEnum>,
      limit?: number,
      offered_by?: Array<PodcastEpisodesListOfferedByEnum>,
      offset?: number,
      platform?: Array<PodcastEpisodesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<PodcastEpisodesListResourceTypeEnum>,
      resource_type_group?: Array<PodcastEpisodesListResourceTypeGroupEnum>,
      sortby?: PodcastEpisodesListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/podcast_episodes/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single podcast episode
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("podcastEpisodesRetrieve", "id", id)
      const localVarPath = `/api/v1/podcast_episodes/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Fetch one episode\'s transcript.  Served separately from the episode payload because the text runs tens of kilobytes; `podcast_episode.has_transcript` says whether there is anything here to fetch.  Args: id (integer): The id of the podcast episode  Returns: The episode id and its transcript text
     * @summary Get a podcast episode transcript
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesTranscriptRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("podcastEpisodesTranscriptRetrieve", "id", id)
      const localVarPath = `/api/v1/podcast_episodes/{id}/transcript/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PodcastEpisodesApi - functional programming interface
 */
export const PodcastEpisodesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PodcastEpisodesApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of podcast episodes
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<PodcastEpisodesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<PodcastEpisodesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<PodcastEpisodesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<PodcastEpisodesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<PodcastEpisodesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<PodcastEpisodesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<PodcastEpisodesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<PodcastEpisodesListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {PodcastEpisodesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastEpisodesList(
      certification?: boolean,
      certification_type?: Array<PodcastEpisodesListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<PodcastEpisodesListDeliveryEnum>>,
      department?: Array<PodcastEpisodesListDepartmentEnum>,
      free?: boolean,
      level?: Array<PodcastEpisodesListLevelEnum>,
      limit?: number,
      offered_by?: Array<PodcastEpisodesListOfferedByEnum>,
      offset?: number,
      platform?: Array<PodcastEpisodesListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<PodcastEpisodesListResourceTypeEnum>,
      resource_type_group?: Array<PodcastEpisodesListResourceTypeGroupEnum>,
      sortby?: PodcastEpisodesListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedPodcastEpisodeResourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastEpisodesList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastEpisodesApi.podcastEpisodesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single podcast episode
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastEpisodesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PodcastEpisodeResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastEpisodesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastEpisodesApi.podcastEpisodesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Fetch one episode\'s transcript.  Served separately from the episode payload because the text runs tens of kilobytes; `podcast_episode.has_transcript` says whether there is anything here to fetch.  Args: id (integer): The id of the podcast episode  Returns: The episode id and its transcript text
     * @summary Get a podcast episode transcript
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastEpisodesTranscriptRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PodcastEpisodeTranscript>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastEpisodesTranscriptRetrieve(
          id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "PodcastEpisodesApi.podcastEpisodesTranscriptRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PodcastEpisodesApi - factory interface
 */
export const PodcastEpisodesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PodcastEpisodesApiFp(configuration)
  return {
    /**
     * Get a paginated list of podcast episodes
     * @summary List
     * @param {PodcastEpisodesApiPodcastEpisodesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesList(
      requestParameters: PodcastEpisodesApiPodcastEpisodesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedPodcastEpisodeResourceList> {
      return localVarFp
        .podcastEpisodesList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single podcast episode
     * @summary Retrieve
     * @param {PodcastEpisodesApiPodcastEpisodesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesRetrieve(
      requestParameters: PodcastEpisodesApiPodcastEpisodesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PodcastEpisodeResource> {
      return localVarFp
        .podcastEpisodesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Fetch one episode\'s transcript.  Served separately from the episode payload because the text runs tens of kilobytes; `podcast_episode.has_transcript` says whether there is anything here to fetch.  Args: id (integer): The id of the podcast episode  Returns: The episode id and its transcript text
     * @summary Get a podcast episode transcript
     * @param {PodcastEpisodesApiPodcastEpisodesTranscriptRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastEpisodesTranscriptRetrieve(
      requestParameters: PodcastEpisodesApiPodcastEpisodesTranscriptRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PodcastEpisodeTranscript> {
      return localVarFp
        .podcastEpisodesTranscriptRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for podcastEpisodesList operation in PodcastEpisodesApi.
 */
export interface PodcastEpisodesApiPodcastEpisodesListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<PodcastEpisodesListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<PodcastEpisodesListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<PodcastEpisodesListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<PodcastEpisodesListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<PodcastEpisodesListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<PodcastEpisodesListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<PodcastEpisodesListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<PodcastEpisodesListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: PodcastEpisodesListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for podcastEpisodesRetrieve operation in PodcastEpisodesApi.
 */
export interface PodcastEpisodesApiPodcastEpisodesRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * Request parameters for podcastEpisodesTranscriptRetrieve operation in PodcastEpisodesApi.
 */
export interface PodcastEpisodesApiPodcastEpisodesTranscriptRetrieveRequest {
  readonly id: number
}

/**
 * PodcastEpisodesApi - object-oriented interface
 */
export class PodcastEpisodesApi extends BaseAPI {
  /**
   * Get a paginated list of podcast episodes
   * @summary List
   * @param {PodcastEpisodesApiPodcastEpisodesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastEpisodesList(
    requestParameters: PodcastEpisodesApiPodcastEpisodesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastEpisodesApiFp(this.configuration)
      .podcastEpisodesList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single podcast episode
   * @summary Retrieve
   * @param {PodcastEpisodesApiPodcastEpisodesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastEpisodesRetrieve(
    requestParameters: PodcastEpisodesApiPodcastEpisodesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastEpisodesApiFp(this.configuration)
      .podcastEpisodesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Fetch one episode\'s transcript.  Served separately from the episode payload because the text runs tens of kilobytes; `podcast_episode.has_transcript` says whether there is anything here to fetch.  Args: id (integer): The id of the podcast episode  Returns: The episode id and its transcript text
   * @summary Get a podcast episode transcript
   * @param {PodcastEpisodesApiPodcastEpisodesTranscriptRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastEpisodesTranscriptRetrieve(
    requestParameters: PodcastEpisodesApiPodcastEpisodesTranscriptRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastEpisodesApiFp(this.configuration)
      .podcastEpisodesTranscriptRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const PodcastEpisodesListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type PodcastEpisodesListCertificationTypeEnum =
  (typeof PodcastEpisodesListCertificationTypeEnum)[keyof typeof PodcastEpisodesListCertificationTypeEnum]
export const PodcastEpisodesListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type PodcastEpisodesListDeliveryEnum =
  (typeof PodcastEpisodesListDeliveryEnum)[keyof typeof PodcastEpisodesListDeliveryEnum]
export const PodcastEpisodesListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type PodcastEpisodesListDepartmentEnum =
  (typeof PodcastEpisodesListDepartmentEnum)[keyof typeof PodcastEpisodesListDepartmentEnum]
export const PodcastEpisodesListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type PodcastEpisodesListLevelEnum =
  (typeof PodcastEpisodesListLevelEnum)[keyof typeof PodcastEpisodesListLevelEnum]
export const PodcastEpisodesListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type PodcastEpisodesListOfferedByEnum =
  (typeof PodcastEpisodesListOfferedByEnum)[keyof typeof PodcastEpisodesListOfferedByEnum]
export const PodcastEpisodesListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type PodcastEpisodesListPlatformEnum =
  (typeof PodcastEpisodesListPlatformEnum)[keyof typeof PodcastEpisodesListPlatformEnum]
export const PodcastEpisodesListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type PodcastEpisodesListResourceTypeEnum =
  (typeof PodcastEpisodesListResourceTypeEnum)[keyof typeof PodcastEpisodesListResourceTypeEnum]
export const PodcastEpisodesListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type PodcastEpisodesListResourceTypeGroupEnum =
  (typeof PodcastEpisodesListResourceTypeGroupEnum)[keyof typeof PodcastEpisodesListResourceTypeGroupEnum]
export const PodcastEpisodesListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type PodcastEpisodesListSortbyEnum =
  (typeof PodcastEpisodesListSortbyEnum)[keyof typeof PodcastEpisodesListSortbyEnum]

/**
 * PodcastsApi - axios parameter creator
 */
export const PodcastsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsItemsList: async (
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "podcastsItemsList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/podcasts/{learning_resource_id}/items/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsItemsRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("podcastsItemsRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "podcastsItemsRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath = `/api/v1/podcasts/{learning_resource_id}/items/{id}/`
        .replace("{id}", encodeURIComponent(String(id)))
        .replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of podcasts
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<PodcastsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<PodcastsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<PodcastsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<PodcastsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<PodcastsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<PodcastsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<PodcastsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<PodcastsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {PodcastsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsList: async (
      certification?: boolean,
      certification_type?: Array<PodcastsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<PodcastsListDeliveryEnum>>,
      department?: Array<PodcastsListDepartmentEnum>,
      free?: boolean,
      level?: Array<PodcastsListLevelEnum>,
      limit?: number,
      offered_by?: Array<PodcastsListOfferedByEnum>,
      offset?: number,
      platform?: Array<PodcastsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<PodcastsListResourceTypeEnum>,
      resource_type_group?: Array<PodcastsListResourceTypeGroupEnum>,
      sortby?: PodcastsListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/podcasts/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single podcast
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("podcastsRetrieve", "id", id)
      const localVarPath = `/api/v1/podcasts/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PodcastsApi - functional programming interface
 */
export const PodcastsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PodcastsApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastsItemsList(
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceRelationshipList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastsItemsList(
          learning_resource_id,
          limit,
          offset,
          sortby,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastsApi.podcastsItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastsItemsRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastsItemsRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastsApi.podcastsItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of podcasts
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<PodcastsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<PodcastsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<PodcastsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<PodcastsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<PodcastsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<PodcastsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<PodcastsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<PodcastsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {PodcastsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastsList(
      certification?: boolean,
      certification_type?: Array<PodcastsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<PodcastsListDeliveryEnum>>,
      department?: Array<PodcastsListDepartmentEnum>,
      free?: boolean,
      level?: Array<PodcastsListLevelEnum>,
      limit?: number,
      offered_by?: Array<PodcastsListOfferedByEnum>,
      offset?: number,
      platform?: Array<PodcastsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<PodcastsListResourceTypeEnum>,
      resource_type_group?: Array<PodcastsListResourceTypeGroupEnum>,
      sortby?: PodcastsListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedPodcastResourceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.podcastsList(
        certification,
        certification_type,
        course_feature,
        delivery,
        department,
        free,
        level,
        limit,
        offered_by,
        offset,
        platform,
        professional,
        readable_id,
        resource_id,
        resource_type,
        resource_type_group,
        sortby,
        topic,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastsApi.podcastsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single podcast
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async podcastsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PodcastResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.podcastsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PodcastsApi.podcastsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PodcastsApi - factory interface
 */
export const PodcastsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PodcastsApiFp(configuration)
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {PodcastsApiPodcastsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsItemsList(
      requestParameters: PodcastsApiPodcastsItemsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceRelationshipList> {
      return localVarFp
        .podcastsItemsList(
          requestParameters.learning_resource_id,
          requestParameters.limit,
          requestParameters.offset,
          requestParameters.sortby,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {PodcastsApiPodcastsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsItemsRetrieve(
      requestParameters: PodcastsApiPodcastsItemsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceRelationship> {
      return localVarFp
        .podcastsItemsRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of podcasts
     * @summary List
     * @param {PodcastsApiPodcastsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsList(
      requestParameters: PodcastsApiPodcastsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedPodcastResourceList> {
      return localVarFp
        .podcastsList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single podcast
     * @summary Retrieve
     * @param {PodcastsApiPodcastsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    podcastsRetrieve(
      requestParameters: PodcastsApiPodcastsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PodcastResource> {
      return localVarFp
        .podcastsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for podcastsItemsList operation in PodcastsApi.
 */
export interface PodcastsApiPodcastsItemsListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Which field to use when ordering the results.
   */
  readonly sortby?: string
}

/**
 * Request parameters for podcastsItemsRetrieve operation in PodcastsApi.
 */
export interface PodcastsApiPodcastsItemsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for podcastsList operation in PodcastsApi.
 */
export interface PodcastsApiPodcastsListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<PodcastsListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<PodcastsListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<PodcastsListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<PodcastsListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<PodcastsListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<PodcastsListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<PodcastsListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<PodcastsListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: PodcastsListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for podcastsRetrieve operation in PodcastsApi.
 */
export interface PodcastsApiPodcastsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * PodcastsApi - object-oriented interface
 */
export class PodcastsApi extends BaseAPI {
  /**
   * Get a list of related learning resources for a learning resource.
   * @summary Nested Learning Resource List
   * @param {PodcastsApiPodcastsItemsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastsItemsList(
    requestParameters: PodcastsApiPodcastsItemsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastsApiFp(this.configuration)
      .podcastsItemsList(
        requestParameters.learning_resource_id,
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.sortby,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a singe related learning resource for a learning resource.
   * @summary Nested Learning Resource Retrieve
   * @param {PodcastsApiPodcastsItemsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastsItemsRetrieve(
    requestParameters: PodcastsApiPodcastsItemsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastsApiFp(this.configuration)
      .podcastsItemsRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of podcasts
   * @summary List
   * @param {PodcastsApiPodcastsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastsList(
    requestParameters: PodcastsApiPodcastsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastsApiFp(this.configuration)
      .podcastsList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single podcast
   * @summary Retrieve
   * @param {PodcastsApiPodcastsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public podcastsRetrieve(
    requestParameters: PodcastsApiPodcastsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PodcastsApiFp(this.configuration)
      .podcastsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const PodcastsListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type PodcastsListCertificationTypeEnum =
  (typeof PodcastsListCertificationTypeEnum)[keyof typeof PodcastsListCertificationTypeEnum]
export const PodcastsListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type PodcastsListDeliveryEnum =
  (typeof PodcastsListDeliveryEnum)[keyof typeof PodcastsListDeliveryEnum]
export const PodcastsListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type PodcastsListDepartmentEnum =
  (typeof PodcastsListDepartmentEnum)[keyof typeof PodcastsListDepartmentEnum]
export const PodcastsListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type PodcastsListLevelEnum =
  (typeof PodcastsListLevelEnum)[keyof typeof PodcastsListLevelEnum]
export const PodcastsListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type PodcastsListOfferedByEnum =
  (typeof PodcastsListOfferedByEnum)[keyof typeof PodcastsListOfferedByEnum]
export const PodcastsListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type PodcastsListPlatformEnum =
  (typeof PodcastsListPlatformEnum)[keyof typeof PodcastsListPlatformEnum]
export const PodcastsListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type PodcastsListResourceTypeEnum =
  (typeof PodcastsListResourceTypeEnum)[keyof typeof PodcastsListResourceTypeEnum]
export const PodcastsListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type PodcastsListResourceTypeGroupEnum =
  (typeof PodcastsListResourceTypeGroupEnum)[keyof typeof PodcastsListResourceTypeGroupEnum]
export const PodcastsListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type PodcastsListSortbyEnum =
  (typeof PodcastsListSortbyEnum)[keyof typeof PodcastsListSortbyEnum]

/**
 * ProgramLettersApi - axios parameter creator
 */
export const ProgramLettersApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Detail only View for program letters
     * @param {string} id A UUID string identifying this program letter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programLettersRetrieve: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("programLettersRetrieve", "id", id)
      const localVarPath = `/api/v1/program_letters/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProgramLettersApi - functional programming interface
 */
export const ProgramLettersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ProgramLettersApiAxiosParamCreator(configuration)
  return {
    /**
     * Detail only View for program letters
     * @param {string} id A UUID string identifying this program letter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async programLettersRetrieve(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramLetter>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.programLettersRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProgramLettersApi.programLettersRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ProgramLettersApi - factory interface
 */
export const ProgramLettersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProgramLettersApiFp(configuration)
  return {
    /**
     * Detail only View for program letters
     * @param {ProgramLettersApiProgramLettersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programLettersRetrieve(
      requestParameters: ProgramLettersApiProgramLettersRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ProgramLetter> {
      return localVarFp
        .programLettersRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for programLettersRetrieve operation in ProgramLettersApi.
 */
export interface ProgramLettersApiProgramLettersRetrieveRequest {
  /**
   * A UUID string identifying this program letter.
   */
  readonly id: string
}

/**
 * ProgramLettersApi - object-oriented interface
 */
export class ProgramLettersApi extends BaseAPI {
  /**
   * Detail only View for program letters
   * @param {ProgramLettersApiProgramLettersRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public programLettersRetrieve(
    requestParameters: ProgramLettersApiProgramLettersRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProgramLettersApiFp(this.configuration)
      .programLettersRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProgramsApi - axios parameter creator
 */
export const ProgramsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of programs
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<ProgramsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<ProgramsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<ProgramsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<ProgramsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<ProgramsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<ProgramsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<ProgramsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<ProgramsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {ProgramsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programsList: async (
      certification?: boolean,
      certification_type?: Array<ProgramsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<ProgramsListDeliveryEnum>>,
      department?: Array<ProgramsListDepartmentEnum>,
      free?: boolean,
      level?: Array<ProgramsListLevelEnum>,
      limit?: number,
      offered_by?: Array<ProgramsListOfferedByEnum>,
      offset?: number,
      platform?: Array<ProgramsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<ProgramsListResourceTypeEnum>,
      resource_type_group?: Array<ProgramsListResourceTypeGroupEnum>,
      sortby?: ProgramsListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/programs/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single program
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("programsRetrieve", "id", id)
      const localVarPath = `/api/v1/programs/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProgramsApi - functional programming interface
 */
export const ProgramsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProgramsApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of programs
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<ProgramsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<ProgramsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<ProgramsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<ProgramsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<ProgramsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<ProgramsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<ProgramsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<ProgramsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {ProgramsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async programsList(
      certification?: boolean,
      certification_type?: Array<ProgramsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<ProgramsListDeliveryEnum>>,
      department?: Array<ProgramsListDepartmentEnum>,
      free?: boolean,
      level?: Array<ProgramsListLevelEnum>,
      limit?: number,
      offered_by?: Array<ProgramsListOfferedByEnum>,
      offset?: number,
      platform?: Array<ProgramsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<ProgramsListResourceTypeEnum>,
      resource_type_group?: Array<ProgramsListResourceTypeGroupEnum>,
      sortby?: ProgramsListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedProgramResourceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.programsList(
        certification,
        certification_type,
        course_feature,
        delivery,
        department,
        free,
        level,
        limit,
        offered_by,
        offset,
        platform,
        professional,
        readable_id,
        resource_id,
        resource_type,
        resource_type_group,
        sortby,
        topic,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProgramsApi.programsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single program
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async programsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ProgramResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.programsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProgramsApi.programsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ProgramsApi - factory interface
 */
export const ProgramsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProgramsApiFp(configuration)
  return {
    /**
     * Get a paginated list of programs
     * @summary List
     * @param {ProgramsApiProgramsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programsList(
      requestParameters: ProgramsApiProgramsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedProgramResourceList> {
      return localVarFp
        .programsList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single program
     * @summary Retrieve
     * @param {ProgramsApiProgramsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programsRetrieve(
      requestParameters: ProgramsApiProgramsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ProgramResource> {
      return localVarFp
        .programsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for programsList operation in ProgramsApi.
 */
export interface ProgramsApiProgramsListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<ProgramsListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<ProgramsListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<ProgramsListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<ProgramsListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<ProgramsListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<ProgramsListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<ProgramsListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<ProgramsListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: ProgramsListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for programsRetrieve operation in ProgramsApi.
 */
export interface ProgramsApiProgramsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * ProgramsApi - object-oriented interface
 */
export class ProgramsApi extends BaseAPI {
  /**
   * Get a paginated list of programs
   * @summary List
   * @param {ProgramsApiProgramsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public programsList(
    requestParameters: ProgramsApiProgramsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ProgramsApiFp(this.configuration)
      .programsList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single program
   * @summary Retrieve
   * @param {ProgramsApiProgramsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public programsRetrieve(
    requestParameters: ProgramsApiProgramsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProgramsApiFp(this.configuration)
      .programsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const ProgramsListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type ProgramsListCertificationTypeEnum =
  (typeof ProgramsListCertificationTypeEnum)[keyof typeof ProgramsListCertificationTypeEnum]
export const ProgramsListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type ProgramsListDeliveryEnum =
  (typeof ProgramsListDeliveryEnum)[keyof typeof ProgramsListDeliveryEnum]
export const ProgramsListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type ProgramsListDepartmentEnum =
  (typeof ProgramsListDepartmentEnum)[keyof typeof ProgramsListDepartmentEnum]
export const ProgramsListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type ProgramsListLevelEnum =
  (typeof ProgramsListLevelEnum)[keyof typeof ProgramsListLevelEnum]
export const ProgramsListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type ProgramsListOfferedByEnum =
  (typeof ProgramsListOfferedByEnum)[keyof typeof ProgramsListOfferedByEnum]
export const ProgramsListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type ProgramsListPlatformEnum =
  (typeof ProgramsListPlatformEnum)[keyof typeof ProgramsListPlatformEnum]
export const ProgramsListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type ProgramsListResourceTypeEnum =
  (typeof ProgramsListResourceTypeEnum)[keyof typeof ProgramsListResourceTypeEnum]
export const ProgramsListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type ProgramsListResourceTypeGroupEnum =
  (typeof ProgramsListResourceTypeGroupEnum)[keyof typeof ProgramsListResourceTypeGroupEnum]
export const ProgramsListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type ProgramsListSortbyEnum =
  (typeof ProgramsListSortbyEnum)[keyof typeof ProgramsListSortbyEnum]

/**
 * SchoolsApi - axios parameter creator
 */
export const SchoolsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * MIT schools
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schoolsList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/schools/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * MIT schools
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource school.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schoolsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("schoolsRetrieve", "id", id)
      const localVarPath = `/api/v1/schools/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SchoolsApi - functional programming interface
 */
export const SchoolsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SchoolsApiAxiosParamCreator(configuration)
  return {
    /**
     * MIT schools
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async schoolsList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceSchoolList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.schoolsList(
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SchoolsApi.schoolsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * MIT schools
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource school.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async schoolsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceSchool>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.schoolsRetrieve(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SchoolsApi.schoolsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SchoolsApi - factory interface
 */
export const SchoolsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SchoolsApiFp(configuration)
  return {
    /**
     * MIT schools
     * @summary List
     * @param {SchoolsApiSchoolsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schoolsList(
      requestParameters: SchoolsApiSchoolsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceSchoolList> {
      return localVarFp
        .schoolsList(requestParameters.limit, requestParameters.offset, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * MIT schools
     * @summary Retrieve
     * @param {SchoolsApiSchoolsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schoolsRetrieve(
      requestParameters: SchoolsApiSchoolsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceSchool> {
      return localVarFp
        .schoolsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for schoolsList operation in SchoolsApi.
 */
export interface SchoolsApiSchoolsListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for schoolsRetrieve operation in SchoolsApi.
 */
export interface SchoolsApiSchoolsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource school.
   */
  readonly id: number
}

/**
 * SchoolsApi - object-oriented interface
 */
export class SchoolsApi extends BaseAPI {
  /**
   * MIT schools
   * @summary List
   * @param {SchoolsApiSchoolsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public schoolsList(
    requestParameters: SchoolsApiSchoolsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return SchoolsApiFp(this.configuration)
      .schoolsList(requestParameters.limit, requestParameters.offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * MIT schools
   * @summary Retrieve
   * @param {SchoolsApiSchoolsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public schoolsRetrieve(
    requestParameters: SchoolsApiSchoolsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SchoolsApiFp(this.configuration)
      .schoolsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TopicsApi - axios parameter creator
 */
export const TopicsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Topics covered by learning resources
     * @summary List
     * @param {boolean} [is_toplevel] Filter top-level topics
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<string>} [name] Topic name
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<number>} [parent_topic_id] Parent topic ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    topicsList: async (
      is_toplevel?: boolean,
      limit?: number,
      name?: Array<string>,
      offset?: number,
      parent_topic_id?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/topics/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (is_toplevel !== undefined) {
        localVarQueryParameter["is_toplevel"] = is_toplevel
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (name) {
        localVarQueryParameter["name"] = name
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (parent_topic_id) {
        localVarQueryParameter["parent_topic_id"] = parent_topic_id
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Topics covered by learning resources
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource topic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    topicsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("topicsRetrieve", "id", id)
      const localVarPath = `/api/v1/topics/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TopicsApi - functional programming interface
 */
export const TopicsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TopicsApiAxiosParamCreator(configuration)
  return {
    /**
     * Topics covered by learning resources
     * @summary List
     * @param {boolean} [is_toplevel] Filter top-level topics
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<string>} [name] Topic name
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<number>} [parent_topic_id] Parent topic ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async topicsList(
      is_toplevel?: boolean,
      limit?: number,
      name?: Array<string>,
      offset?: number,
      parent_topic_id?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceTopicList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.topicsList(
        is_toplevel,
        limit,
        name,
        offset,
        parent_topic_id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TopicsApi.topicsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Topics covered by learning resources
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource topic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async topicsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceTopic>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.topicsRetrieve(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TopicsApi.topicsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TopicsApi - factory interface
 */
export const TopicsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TopicsApiFp(configuration)
  return {
    /**
     * Topics covered by learning resources
     * @summary List
     * @param {TopicsApiTopicsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    topicsList(
      requestParameters: TopicsApiTopicsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceTopicList> {
      return localVarFp
        .topicsList(
          requestParameters.is_toplevel,
          requestParameters.limit,
          requestParameters.name,
          requestParameters.offset,
          requestParameters.parent_topic_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Topics covered by learning resources
     * @summary Retrieve
     * @param {TopicsApiTopicsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    topicsRetrieve(
      requestParameters: TopicsApiTopicsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceTopic> {
      return localVarFp
        .topicsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for topicsList operation in TopicsApi.
 */
export interface TopicsApiTopicsListRequest {
  /**
   * Filter top-level topics
   */
  readonly is_toplevel?: boolean

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * Topic name
   */
  readonly name?: Array<string>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Parent topic ID
   */
  readonly parent_topic_id?: Array<number>
}

/**
 * Request parameters for topicsRetrieve operation in TopicsApi.
 */
export interface TopicsApiTopicsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource topic.
   */
  readonly id: number
}

/**
 * TopicsApi - object-oriented interface
 */
export class TopicsApi extends BaseAPI {
  /**
   * Topics covered by learning resources
   * @summary List
   * @param {TopicsApiTopicsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public topicsList(
    requestParameters: TopicsApiTopicsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return TopicsApiFp(this.configuration)
      .topicsList(
        requestParameters.is_toplevel,
        requestParameters.limit,
        requestParameters.name,
        requestParameters.offset,
        requestParameters.parent_topic_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Topics covered by learning resources
   * @summary Retrieve
   * @param {TopicsApiTopicsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public topicsRetrieve(
    requestParameters: TopicsApiTopicsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TopicsApiFp(this.configuration)
      .topicsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UnsubscribeApi - axios parameter creator
 */
export const UnsubscribeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Handle email unsubscribe requests via signed token.
     * @summary One-click unsubscribe (RFC 8058)
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsubscribeCreate: async (
      token: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists("unsubscribeCreate", "token", token)
      const localVarPath = `/api/v1/unsubscribe/{token}/`.replace(
        "{token}",
        encodeURIComponent(String(token)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UnsubscribeApi - functional programming interface
 */
export const UnsubscribeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UnsubscribeApiAxiosParamCreator(configuration)
  return {
    /**
     * Handle email unsubscribe requests via signed token.
     * @summary One-click unsubscribe (RFC 8058)
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unsubscribeCreate(
      token: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.unsubscribeCreate(token, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UnsubscribeApi.unsubscribeCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * UnsubscribeApi - factory interface
 */
export const UnsubscribeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UnsubscribeApiFp(configuration)
  return {
    /**
     * Handle email unsubscribe requests via signed token.
     * @summary One-click unsubscribe (RFC 8058)
     * @param {UnsubscribeApiUnsubscribeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsubscribeCreate(
      requestParameters: UnsubscribeApiUnsubscribeCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .unsubscribeCreate(requestParameters.token, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for unsubscribeCreate operation in UnsubscribeApi.
 */
export interface UnsubscribeApiUnsubscribeCreateRequest {
  readonly token: string
}

/**
 * UnsubscribeApi - object-oriented interface
 */
export class UnsubscribeApi extends BaseAPI {
  /**
   * Handle email unsubscribe requests via signed token.
   * @summary One-click unsubscribe (RFC 8058)
   * @param {UnsubscribeApiUnsubscribeCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public unsubscribeCreate(
    requestParameters: UnsubscribeApiUnsubscribeCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UnsubscribeApiFp(this.configuration)
      .unsubscribeCreate(requestParameters.token, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserlistsApi - axios parameter creator
 */
export const UserlistsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Viewset for UserLists
     * @summary Create
     * @param {UserListRequest} UserListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsCreate: async (
      UserListRequest: UserListRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'UserListRequest' is not null or undefined
      assertParamExists("userlistsCreate", "UserListRequest", UserListRequest)
      const localVarPath = `/api/v1/userlists/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        UserListRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserLists
     * @summary Destroy
     * @param {number} id A unique integer value identifying this user list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsDestroy", "id", id)
      const localVarPath = `/api/v1/userlists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Add
     * @param {number} userlist_id id of the parent user list
     * @param {UserListRelationshipRequest} UserListRelationshipRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsCreate: async (
      userlist_id: number,
      UserListRelationshipRequest: UserListRelationshipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userlist_id' is not null or undefined
      assertParamExists("userlistsItemsCreate", "userlist_id", userlist_id)
      // verify required parameter 'UserListRelationshipRequest' is not null or undefined
      assertParamExists(
        "userlistsItemsCreate",
        "UserListRelationshipRequest",
        UserListRelationshipRequest,
      )
      const localVarPath = `/api/v1/userlists/{userlist_id}/items/`.replace(
        "{userlist_id}",
        encodeURIComponent(String(userlist_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        UserListRelationshipRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Remove
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsDestroy: async (
      id: number,
      userlist_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsItemsDestroy", "id", id)
      // verify required parameter 'userlist_id' is not null or undefined
      assertParamExists("userlistsItemsDestroy", "userlist_id", userlist_id)
      const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
        .replace("{id}", encodeURIComponent(String(id)))
        .replace("{userlist_id}", encodeURIComponent(String(userlist_id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources List
     * @param {number} userlist_id id of the parent user list
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsList: async (
      userlist_id: number,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userlist_id' is not null or undefined
      assertParamExists("userlistsItemsList", "userlist_id", userlist_id)
      const localVarPath = `/api/v1/userlists/{userlist_id}/items/`.replace(
        "{userlist_id}",
        encodeURIComponent(String(userlist_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Update
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsPartialUpdate: async (
      id: number,
      userlist_id: number,
      PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsItemsPartialUpdate", "id", id)
      // verify required parameter 'userlist_id' is not null or undefined
      assertParamExists(
        "userlistsItemsPartialUpdate",
        "userlist_id",
        userlist_id,
      )
      const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
        .replace("{id}", encodeURIComponent(String(id)))
        .replace("{userlist_id}", encodeURIComponent(String(userlist_id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedUserListRelationshipRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources Retrieve
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsRetrieve: async (
      id: number,
      userlist_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsItemsRetrieve", "id", id)
      // verify required parameter 'userlist_id' is not null or undefined
      assertParamExists("userlistsItemsRetrieve", "userlist_id", userlist_id)
      const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
        .replace("{id}", encodeURIComponent(String(id)))
        .replace("{userlist_id}", encodeURIComponent(String(userlist_id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserLists
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsList: async (
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/userlists/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a list of all userlist items for a user
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsMembershipList: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/userlists/membership/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserLists
     * @summary Update
     * @param {number} id A unique integer value identifying this user list.
     * @param {PatchedUserListRequest} [PatchedUserListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsPartialUpdate: async (
      id: number,
      PatchedUserListRequest?: PatchedUserListRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsPartialUpdate", "id", id)
      const localVarPath = `/api/v1/userlists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedUserListRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Viewset for UserLists
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this user list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userlistsRetrieve", "id", id)
      const localVarPath = `/api/v1/userlists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UserlistsApi - functional programming interface
 */
export const UserlistsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserlistsApiAxiosParamCreator(configuration)
  return {
    /**
     * Viewset for UserLists
     * @summary Create
     * @param {UserListRequest} UserListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsCreate(
      UserListRequest: UserListRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userlistsCreate(
        UserListRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserLists
     * @summary Destroy
     * @param {number} id A unique integer value identifying this user list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsDestroy(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Add
     * @param {number} userlist_id id of the parent user list
     * @param {UserListRelationshipRequest} UserListRelationshipRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsItemsCreate(
      userlist_id: number,
      UserListRelationshipRequest: UserListRelationshipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserListRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsItemsCreate(
          userlist_id,
          UserListRelationshipRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsItemsCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Remove
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsItemsDestroy(
      id: number,
      userlist_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsItemsDestroy(
          id,
          userlist_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsItemsDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources List
     * @param {number} userlist_id id of the parent user list
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsItemsList(
      userlist_id: number,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedUserListRelationshipList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsItemsList(
          userlist_id,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Update
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsItemsPartialUpdate(
      id: number,
      userlist_id: number,
      PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserListRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsItemsPartialUpdate(
          id,
          userlist_id,
          PatchedUserListRelationshipRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsItemsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources Retrieve
     * @param {number} id A unique integer value identifying this user list relationship.
     * @param {number} userlist_id id of the parent user list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsItemsRetrieve(
      id: number,
      userlist_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserListRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsItemsRetrieve(
          id,
          userlist_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserLists
     * @summary List
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsList(
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedUserListList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userlistsList(
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a list of all userlist items for a user
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsMembershipList(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MicroUserListRelationship>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsMembershipList(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsMembershipList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserLists
     * @summary Update
     * @param {number} id A unique integer value identifying this user list.
     * @param {PatchedUserListRequest} [PatchedUserListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsPartialUpdate(
      id: number,
      PatchedUserListRequest?: PatchedUserListRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsPartialUpdate(
          id,
          PatchedUserListRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Viewset for UserLists
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this user list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userlistsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userlistsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UserlistsApi.userlistsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * UserlistsApi - factory interface
 */
export const UserlistsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserlistsApiFp(configuration)
  return {
    /**
     * Viewset for UserLists
     * @summary Create
     * @param {UserlistsApiUserlistsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsCreate(
      requestParameters: UserlistsApiUserlistsCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserList> {
      return localVarFp
        .userlistsCreate(requestParameters.UserListRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserLists
     * @summary Destroy
     * @param {UserlistsApiUserlistsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsDestroy(
      requestParameters: UserlistsApiUserlistsDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .userlistsDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Add
     * @param {UserlistsApiUserlistsItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsCreate(
      requestParameters: UserlistsApiUserlistsItemsCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserListRelationship> {
      return localVarFp
        .userlistsItemsCreate(
          requestParameters.userlist_id,
          requestParameters.UserListRelationshipRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Remove
     * @param {UserlistsApiUserlistsItemsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsDestroy(
      requestParameters: UserlistsApiUserlistsItemsDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .userlistsItemsDestroy(
          requestParameters.id,
          requestParameters.userlist_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources List
     * @param {UserlistsApiUserlistsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsList(
      requestParameters: UserlistsApiUserlistsItemsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedUserListRelationshipList> {
      return localVarFp
        .userlistsItemsList(
          requestParameters.userlist_id,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Update
     * @param {UserlistsApiUserlistsItemsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsPartialUpdate(
      requestParameters: UserlistsApiUserlistsItemsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserListRelationship> {
      return localVarFp
        .userlistsItemsPartialUpdate(
          requestParameters.id,
          requestParameters.userlist_id,
          requestParameters.PatchedUserListRelationshipRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources Retrieve
     * @param {UserlistsApiUserlistsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsItemsRetrieve(
      requestParameters: UserlistsApiUserlistsItemsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserListRelationship> {
      return localVarFp
        .userlistsItemsRetrieve(
          requestParameters.id,
          requestParameters.userlist_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserLists
     * @summary List
     * @param {UserlistsApiUserlistsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsList(
      requestParameters: UserlistsApiUserlistsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedUserListList> {
      return localVarFp
        .userlistsList(
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a list of all userlist items for a user
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsMembershipList(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MicroUserListRelationship>> {
      return localVarFp
        .userlistsMembershipList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserLists
     * @summary Update
     * @param {UserlistsApiUserlistsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsPartialUpdate(
      requestParameters: UserlistsApiUserlistsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserList> {
      return localVarFp
        .userlistsPartialUpdate(
          requestParameters.id,
          requestParameters.PatchedUserListRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Viewset for UserLists
     * @summary Retrieve
     * @param {UserlistsApiUserlistsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userlistsRetrieve(
      requestParameters: UserlistsApiUserlistsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserList> {
      return localVarFp
        .userlistsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for userlistsCreate operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsCreateRequest {
  readonly UserListRequest: UserListRequest
}

/**
 * Request parameters for userlistsDestroy operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsDestroyRequest {
  /**
   * A unique integer value identifying this user list.
   */
  readonly id: number
}

/**
 * Request parameters for userlistsItemsCreate operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsItemsCreateRequest {
  /**
   * id of the parent user list
   */
  readonly userlist_id: number

  readonly UserListRelationshipRequest: UserListRelationshipRequest
}

/**
 * Request parameters for userlistsItemsDestroy operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsItemsDestroyRequest {
  /**
   * A unique integer value identifying this user list relationship.
   */
  readonly id: number

  /**
   * id of the parent user list
   */
  readonly userlist_id: number
}

/**
 * Request parameters for userlistsItemsList operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsItemsListRequest {
  /**
   * id of the parent user list
   */
  readonly userlist_id: number

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for userlistsItemsPartialUpdate operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsItemsPartialUpdateRequest {
  /**
   * A unique integer value identifying this user list relationship.
   */
  readonly id: number

  /**
   * id of the parent user list
   */
  readonly userlist_id: number

  readonly PatchedUserListRelationshipRequest?: PatchedUserListRelationshipRequest
}

/**
 * Request parameters for userlistsItemsRetrieve operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsItemsRetrieveRequest {
  /**
   * A unique integer value identifying this user list relationship.
   */
  readonly id: number

  /**
   * id of the parent user list
   */
  readonly userlist_id: number
}

/**
 * Request parameters for userlistsList operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsListRequest {
  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for userlistsPartialUpdate operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsPartialUpdateRequest {
  /**
   * A unique integer value identifying this user list.
   */
  readonly id: number

  readonly PatchedUserListRequest?: PatchedUserListRequest
}

/**
 * Request parameters for userlistsRetrieve operation in UserlistsApi.
 */
export interface UserlistsApiUserlistsRetrieveRequest {
  /**
   * A unique integer value identifying this user list.
   */
  readonly id: number
}

/**
 * UserlistsApi - object-oriented interface
 */
export class UserlistsApi extends BaseAPI {
  /**
   * Viewset for UserLists
   * @summary Create
   * @param {UserlistsApiUserlistsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsCreate(
    requestParameters: UserlistsApiUserlistsCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsCreate(requestParameters.UserListRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserLists
   * @summary Destroy
   * @param {UserlistsApiUserlistsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsDestroy(
    requestParameters: UserlistsApiUserlistsDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserListRelationships
   * @summary User List Resource Relationship Add
   * @param {UserlistsApiUserlistsItemsCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsItemsCreate(
    requestParameters: UserlistsApiUserlistsItemsCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsItemsCreate(
        requestParameters.userlist_id,
        requestParameters.UserListRelationshipRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserListRelationships
   * @summary User List Resource Relationship Remove
   * @param {UserlistsApiUserlistsItemsDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsItemsDestroy(
    requestParameters: UserlistsApiUserlistsItemsDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsItemsDestroy(
        requestParameters.id,
        requestParameters.userlist_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserListRelationships
   * @summary User List Resources List
   * @param {UserlistsApiUserlistsItemsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsItemsList(
    requestParameters: UserlistsApiUserlistsItemsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsItemsList(
        requestParameters.userlist_id,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserListRelationships
   * @summary User List Resource Relationship Update
   * @param {UserlistsApiUserlistsItemsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsItemsPartialUpdate(
    requestParameters: UserlistsApiUserlistsItemsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsItemsPartialUpdate(
        requestParameters.id,
        requestParameters.userlist_id,
        requestParameters.PatchedUserListRelationshipRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserListRelationships
   * @summary User List Resources Retrieve
   * @param {UserlistsApiUserlistsItemsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsItemsRetrieve(
    requestParameters: UserlistsApiUserlistsItemsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsItemsRetrieve(
        requestParameters.id,
        requestParameters.userlist_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserLists
   * @summary List
   * @param {UserlistsApiUserlistsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsList(
    requestParameters: UserlistsApiUserlistsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsList(requestParameters.limit, requestParameters.offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a list of all userlist items for a user
   * @summary List
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsMembershipList(options?: RawAxiosRequestConfig) {
    return UserlistsApiFp(this.configuration)
      .userlistsMembershipList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserLists
   * @summary Update
   * @param {UserlistsApiUserlistsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsPartialUpdate(
    requestParameters: UserlistsApiUserlistsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsPartialUpdate(
        requestParameters.id,
        requestParameters.PatchedUserListRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Viewset for UserLists
   * @summary Retrieve
   * @param {UserlistsApiUserlistsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public userlistsRetrieve(
    requestParameters: UserlistsApiUserlistsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserlistsApiFp(this.configuration)
      .userlistsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VideoPlaylistsApi - axios parameter creator
 */
export const VideoPlaylistsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsItemsList: async (
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "videoPlaylistsItemsList",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/video_playlists/{learning_resource_id}/items/`.replace(
          "{learning_resource_id}",
          encodeURIComponent(String(learning_resource_id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsItemsRetrieve: async (
      id: number,
      learning_resource_id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("videoPlaylistsItemsRetrieve", "id", id)
      // verify required parameter 'learning_resource_id' is not null or undefined
      assertParamExists(
        "videoPlaylistsItemsRetrieve",
        "learning_resource_id",
        learning_resource_id,
      )
      const localVarPath =
        `/api/v1/video_playlists/{learning_resource_id}/items/{id}/`
          .replace("{id}", encodeURIComponent(String(id)))
          .replace(
            "{learning_resource_id}",
            encodeURIComponent(String(learning_resource_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of video playlists
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<VideoPlaylistsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<VideoPlaylistsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VideoPlaylistsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<VideoPlaylistsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<VideoPlaylistsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<VideoPlaylistsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<VideoPlaylistsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<VideoPlaylistsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {VideoPlaylistsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsList: async (
      certification?: boolean,
      certification_type?: Array<VideoPlaylistsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<VideoPlaylistsListDeliveryEnum>>,
      department?: Array<VideoPlaylistsListDepartmentEnum>,
      free?: boolean,
      level?: Array<VideoPlaylistsListLevelEnum>,
      limit?: number,
      offered_by?: Array<VideoPlaylistsListOfferedByEnum>,
      offset?: number,
      platform?: Array<VideoPlaylistsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<VideoPlaylistsListResourceTypeEnum>,
      resource_type_group?: Array<VideoPlaylistsListResourceTypeGroupEnum>,
      sortby?: VideoPlaylistsListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/video_playlists/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single video playlist
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("videoPlaylistsRetrieve", "id", id)
      const localVarPath = `/api/v1/video_playlists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VideoPlaylistsApi - functional programming interface
 */
export const VideoPlaylistsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    VideoPlaylistsApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [sortby] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoPlaylistsItemsList(
      learning_resource_id: number,
      limit?: number,
      offset?: number,
      sortby?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceRelationshipList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videoPlaylistsItemsList(
          learning_resource_id,
          limit,
          offset,
          sortby,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideoPlaylistsApi.videoPlaylistsItemsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {number} id A unique integer value identifying this learning resource relationship.
     * @param {number} learning_resource_id id of the parent learning resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoPlaylistsItemsRetrieve(
      id: number,
      learning_resource_id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceRelationship>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videoPlaylistsItemsRetrieve(
          id,
          learning_resource_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideoPlaylistsApi.videoPlaylistsItemsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of video playlists
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<VideoPlaylistsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<VideoPlaylistsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VideoPlaylistsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<VideoPlaylistsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<VideoPlaylistsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<VideoPlaylistsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<VideoPlaylistsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<VideoPlaylistsListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {VideoPlaylistsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoPlaylistsList(
      certification?: boolean,
      certification_type?: Array<VideoPlaylistsListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<VideoPlaylistsListDeliveryEnum>>,
      department?: Array<VideoPlaylistsListDepartmentEnum>,
      free?: boolean,
      level?: Array<VideoPlaylistsListLevelEnum>,
      limit?: number,
      offered_by?: Array<VideoPlaylistsListOfferedByEnum>,
      offset?: number,
      platform?: Array<VideoPlaylistsListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<VideoPlaylistsListResourceTypeEnum>,
      resource_type_group?: Array<VideoPlaylistsListResourceTypeGroupEnum>,
      sortby?: VideoPlaylistsListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedVideoPlaylistResourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videoPlaylistsList(
          certification,
          certification_type,
          course_feature,
          delivery,
          department,
          free,
          level,
          limit,
          offered_by,
          offset,
          platform,
          professional,
          readable_id,
          resource_id,
          resource_type,
          resource_type_group,
          sortby,
          topic,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideoPlaylistsApi.videoPlaylistsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single video playlist
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videoPlaylistsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<VideoPlaylistResource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videoPlaylistsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideoPlaylistsApi.videoPlaylistsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * VideoPlaylistsApi - factory interface
 */
export const VideoPlaylistsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VideoPlaylistsApiFp(configuration)
  return {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {VideoPlaylistsApiVideoPlaylistsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsItemsList(
      requestParameters: VideoPlaylistsApiVideoPlaylistsItemsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceRelationshipList> {
      return localVarFp
        .videoPlaylistsItemsList(
          requestParameters.learning_resource_id,
          requestParameters.limit,
          requestParameters.offset,
          requestParameters.sortby,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsItemsRetrieve(
      requestParameters: VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceRelationship> {
      return localVarFp
        .videoPlaylistsItemsRetrieve(
          requestParameters.id,
          requestParameters.learning_resource_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of video playlists
     * @summary List
     * @param {VideoPlaylistsApiVideoPlaylistsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsList(
      requestParameters: VideoPlaylistsApiVideoPlaylistsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedVideoPlaylistResourceList> {
      return localVarFp
        .videoPlaylistsList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single video playlist
     * @summary Retrieve
     * @param {VideoPlaylistsApiVideoPlaylistsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoPlaylistsRetrieve(
      requestParameters: VideoPlaylistsApiVideoPlaylistsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<VideoPlaylistResource> {
      return localVarFp
        .videoPlaylistsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for videoPlaylistsItemsList operation in VideoPlaylistsApi.
 */
export interface VideoPlaylistsApiVideoPlaylistsItemsListRequest {
  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Which field to use when ordering the results.
   */
  readonly sortby?: string
}

/**
 * Request parameters for videoPlaylistsItemsRetrieve operation in VideoPlaylistsApi.
 */
export interface VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource relationship.
   */
  readonly id: number

  /**
   * id of the parent learning resource
   */
  readonly learning_resource_id: number
}

/**
 * Request parameters for videoPlaylistsList operation in VideoPlaylistsApi.
 */
export interface VideoPlaylistsApiVideoPlaylistsListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<VideoPlaylistsListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<VideoPlaylistsListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<VideoPlaylistsListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<VideoPlaylistsListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<VideoPlaylistsListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<VideoPlaylistsListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<VideoPlaylistsListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<VideoPlaylistsListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: VideoPlaylistsListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for videoPlaylistsRetrieve operation in VideoPlaylistsApi.
 */
export interface VideoPlaylistsApiVideoPlaylistsRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * VideoPlaylistsApi - object-oriented interface
 */
export class VideoPlaylistsApi extends BaseAPI {
  /**
   * Get a list of related learning resources for a learning resource.
   * @summary Nested Learning Resource List
   * @param {VideoPlaylistsApiVideoPlaylistsItemsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videoPlaylistsItemsList(
    requestParameters: VideoPlaylistsApiVideoPlaylistsItemsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return VideoPlaylistsApiFp(this.configuration)
      .videoPlaylistsItemsList(
        requestParameters.learning_resource_id,
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.sortby,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a singe related learning resource for a learning resource.
   * @summary Nested Learning Resource Retrieve
   * @param {VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videoPlaylistsItemsRetrieve(
    requestParameters: VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return VideoPlaylistsApiFp(this.configuration)
      .videoPlaylistsItemsRetrieve(
        requestParameters.id,
        requestParameters.learning_resource_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of video playlists
   * @summary List
   * @param {VideoPlaylistsApiVideoPlaylistsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videoPlaylistsList(
    requestParameters: VideoPlaylistsApiVideoPlaylistsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return VideoPlaylistsApiFp(this.configuration)
      .videoPlaylistsList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single video playlist
   * @summary Retrieve
   * @param {VideoPlaylistsApiVideoPlaylistsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videoPlaylistsRetrieve(
    requestParameters: VideoPlaylistsApiVideoPlaylistsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return VideoPlaylistsApiFp(this.configuration)
      .videoPlaylistsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const VideoPlaylistsListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type VideoPlaylistsListCertificationTypeEnum =
  (typeof VideoPlaylistsListCertificationTypeEnum)[keyof typeof VideoPlaylistsListCertificationTypeEnum]
export const VideoPlaylistsListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type VideoPlaylistsListDeliveryEnum =
  (typeof VideoPlaylistsListDeliveryEnum)[keyof typeof VideoPlaylistsListDeliveryEnum]
export const VideoPlaylistsListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type VideoPlaylistsListDepartmentEnum =
  (typeof VideoPlaylistsListDepartmentEnum)[keyof typeof VideoPlaylistsListDepartmentEnum]
export const VideoPlaylistsListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type VideoPlaylistsListLevelEnum =
  (typeof VideoPlaylistsListLevelEnum)[keyof typeof VideoPlaylistsListLevelEnum]
export const VideoPlaylistsListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type VideoPlaylistsListOfferedByEnum =
  (typeof VideoPlaylistsListOfferedByEnum)[keyof typeof VideoPlaylistsListOfferedByEnum]
export const VideoPlaylistsListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type VideoPlaylistsListPlatformEnum =
  (typeof VideoPlaylistsListPlatformEnum)[keyof typeof VideoPlaylistsListPlatformEnum]
export const VideoPlaylistsListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type VideoPlaylistsListResourceTypeEnum =
  (typeof VideoPlaylistsListResourceTypeEnum)[keyof typeof VideoPlaylistsListResourceTypeEnum]
export const VideoPlaylistsListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type VideoPlaylistsListResourceTypeGroupEnum =
  (typeof VideoPlaylistsListResourceTypeGroupEnum)[keyof typeof VideoPlaylistsListResourceTypeGroupEnum]
export const VideoPlaylistsListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type VideoPlaylistsListSortbyEnum =
  (typeof VideoPlaylistsListSortbyEnum)[keyof typeof VideoPlaylistsListSortbyEnum]

/**
 * VideosApi - axios parameter creator
 */
export const VideosApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of videos
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<VideosListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<VideosListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VideosListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<VideosListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<VideosListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<VideosListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<VideosListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<VideosListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {VideosListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosList: async (
      certification?: boolean,
      certification_type?: Array<VideosListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<VideosListDeliveryEnum>>,
      department?: Array<VideosListDepartmentEnum>,
      free?: boolean,
      level?: Array<VideosListLevelEnum>,
      limit?: number,
      offered_by?: Array<VideosListOfferedByEnum>,
      offset?: number,
      platform?: Array<VideosListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<VideosListResourceTypeEnum>,
      resource_type_group?: Array<VideosListResourceTypeGroupEnum>,
      sortby?: VideosListSortbyEnum,
      topic?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/videos/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (readable_id) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_id) {
        localVarQueryParameter["resource_id"] = resource_id
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single video
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("videosRetrieve", "id", id)
      const localVarPath = `/api/v1/videos/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VideosApi - functional programming interface
 */
export const VideosApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VideosApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of videos
     * @summary List
     * @param {boolean} [certification]
     * @param {Array<VideosListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {Array<string>} [course_feature] Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
     * @param {Array<Array<VideosListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VideosListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean} [free] The course/program is offered for free
     * @param {Array<VideosListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<VideosListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results.
     * @param {Array<VideosListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean} [professional]
     * @param {Array<string>} [readable_id] A unique text identifier for the resources
     * @param {Array<number>} [resource_id] Comma-separated list of learning resource IDs
     * @param {Array<VideosListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
     * @param {Array<VideosListResourceTypeGroupEnum>} [resource_type_group] The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {VideosListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
     * @param {Array<string>} [topic] Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosList(
      certification?: boolean,
      certification_type?: Array<VideosListCertificationTypeEnum>,
      course_feature?: Array<string>,
      delivery?: Array<Array<VideosListDeliveryEnum>>,
      department?: Array<VideosListDepartmentEnum>,
      free?: boolean,
      level?: Array<VideosListLevelEnum>,
      limit?: number,
      offered_by?: Array<VideosListOfferedByEnum>,
      offset?: number,
      platform?: Array<VideosListPlatformEnum>,
      professional?: boolean,
      readable_id?: Array<string>,
      resource_id?: Array<number>,
      resource_type?: Array<VideosListResourceTypeEnum>,
      resource_type_group?: Array<VideosListResourceTypeGroupEnum>,
      sortby?: VideosListSortbyEnum,
      topic?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedVideoResourceList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.videosList(
        certification,
        certification_type,
        course_feature,
        delivery,
        department,
        free,
        level,
        limit,
        offered_by,
        offset,
        platform,
        professional,
        readable_id,
        resource_id,
        resource_type,
        resource_type_group,
        sortby,
        topic,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideosApi.videosList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single video
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this learning resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoResource>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.videosRetrieve(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VideosApi.videosRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * VideosApi - factory interface
 */
export const VideosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VideosApiFp(configuration)
  return {
    /**
     * Get a paginated list of videos
     * @summary List
     * @param {VideosApiVideosListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosList(
      requestParameters: VideosApiVideosListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedVideoResourceList> {
      return localVarFp
        .videosList(
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.readable_id,
          requestParameters.resource_id,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.sortby,
          requestParameters.topic,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single video
     * @summary Retrieve
     * @param {VideosApiVideosRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosRetrieve(
      requestParameters: VideosApiVideosRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<VideoResource> {
      return localVarFp
        .videosRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for videosList operation in VideosApi.
 */
export interface VideosApiVideosListRequest {
  readonly certification?: boolean

  /**
   * The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<VideosListCertificationTypeEnum>

  /**
   * Content feature for the resources. Load the \&#39;api/v1/course_features\&#39; endpoint for a list of course features
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<Array<VideosListDeliveryEnum>>

  /**
   * The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<VideosListDepartmentEnum>

  /**
   * The course/program is offered for free
   */
  readonly free?: boolean

  /**
   * The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
   */
  readonly level?: Array<VideosListLevelEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<VideosListOfferedByEnum>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<VideosListPlatformEnum>

  readonly professional?: boolean

  /**
   * A unique text identifier for the resources
   */
  readonly readable_id?: Array<string>

  /**
   * Comma-separated list of learning resource IDs
   */
  readonly resource_id?: Array<number>

  /**
   * The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist * &#x60;document&#x60; - Document
   */
  readonly resource_type?: Array<VideosListResourceTypeEnum>

  /**
   * The resource type group of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<VideosListResourceTypeGroupEnum>

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
   */
  readonly sortby?: VideosListSortbyEnum

  /**
   * Topics covered by the resources. Load the \&#39;/api/v1/topics\&#39; endpoint for a list of topics
   */
  readonly topic?: Array<string>
}

/**
 * Request parameters for videosRetrieve operation in VideosApi.
 */
export interface VideosApiVideosRetrieveRequest {
  /**
   * A unique integer value identifying this learning resource.
   */
  readonly id: number
}

/**
 * VideosApi - object-oriented interface
 */
export class VideosApi extends BaseAPI {
  /**
   * Get a paginated list of videos
   * @summary List
   * @param {VideosApiVideosListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videosList(
    requestParameters: VideosApiVideosListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return VideosApiFp(this.configuration)
      .videosList(
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.readable_id,
        requestParameters.resource_id,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.sortby,
        requestParameters.topic,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single video
   * @summary Retrieve
   * @param {VideosApiVideosRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public videosRetrieve(
    requestParameters: VideosApiVideosRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return VideosApiFp(this.configuration)
      .videosRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const VideosListCertificationTypeEnum = {
  Completion: "completion",
  Micromasters: "micromasters",
  None: "none",
  Professional: "professional",
} as const
export type VideosListCertificationTypeEnum =
  (typeof VideosListCertificationTypeEnum)[keyof typeof VideosListCertificationTypeEnum]
export const VideosListDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type VideosListDeliveryEnum =
  (typeof VideosListDeliveryEnum)[keyof typeof VideosListDeliveryEnum]
export const VideosListDepartmentEnum = {
  _1: "1",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _2: "2",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type VideosListDepartmentEnum =
  (typeof VideosListDepartmentEnum)[keyof typeof VideosListDepartmentEnum]
export const VideosListLevelEnum = {
  Advanced: "advanced",
  Graduate: "graduate",
  HighSchool: "high_school",
  Intermediate: "intermediate",
  Introductory: "introductory",
  Noncredit: "noncredit",
  Undergraduate: "undergraduate",
} as const
export type VideosListLevelEnum =
  (typeof VideosListLevelEnum)[keyof typeof VideosListLevelEnum]
export const VideosListOfferedByEnum = {
  Bootcamps: "bootcamps",
  Climate: "climate",
  Mitpe: "mitpe",
  Mitx: "mitx",
  Ocw: "ocw",
  See: "see",
  Xpro: "xpro",
} as const
export type VideosListOfferedByEnum =
  (typeof VideosListOfferedByEnum)[keyof typeof VideosListOfferedByEnum]
export const VideosListPlatformEnum = {
  Bootcamps: "bootcamps",
  Canvas: "canvas",
  Climate: "climate",
  Csail: "csail",
  Ctl: "ctl",
  Edx: "edx",
  Emeritus: "emeritus",
  Globalalumni: "globalalumni",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Ocw: "ocw",
  Oll: "oll",
  Ovs: "ovs",
  Podcast: "podcast",
  Scc: "scc",
  See: "see",
  Simplilearn: "simplilearn",
  Susskind: "susskind",
  Whu: "whu",
  Xpro: "xpro",
  Youtube: "youtube",
} as const
export type VideosListPlatformEnum =
  (typeof VideosListPlatformEnum)[keyof typeof VideosListPlatformEnum]
export const VideosListResourceTypeEnum = {
  Course: "course",
  Document: "document",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Program: "program",
  Video: "video",
  VideoPlaylist: "video_playlist",
} as const
export type VideosListResourceTypeEnum =
  (typeof VideosListResourceTypeEnum)[keyof typeof VideosListResourceTypeEnum]
export const VideosListResourceTypeGroupEnum = {
  Course: "course",
  LearningMaterial: "learning_material",
  Program: "program",
} as const
export type VideosListResourceTypeGroupEnum =
  (typeof VideosListResourceTypeGroupEnum)[keyof typeof VideosListResourceTypeGroupEnum]
export const VideosListSortbyEnum = {
  Id: "-id",
  LastModified: "-last_modified",
  Mitcoursenumber: "-mitcoursenumber",
  ReadableId: "-readable_id",
  StartDate: "-start_date",
  Views: "-views",
  Id2: "id",
  LastModified2: "last_modified",
  Mitcoursenumber2: "mitcoursenumber",
  New: "new",
  ReadableId2: "readable_id",
  StartDate2: "start_date",
  Upcoming: "upcoming",
  Views2: "views",
} as const
export type VideosListSortbyEnum =
  (typeof VideosListSortbyEnum)[keyof typeof VideosListSortbyEnum]

/**
 * WebhooksApi - axios parameter creator
 */
export const WebhooksApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Webhook handler for ContentFile updates
     * @param {WebhooksContentFilesCreateSourceEnum} source * &#x60;mit_edx&#x60; - mit_edx * &#x60;mitpe&#x60; - mitpe * &#x60;mitxonline&#x60; - mitxonline * &#x60;oll&#x60; - oll * &#x60;ocw&#x60; - ocw * &#x60;podcast&#x60; - podcast * &#x60;mit_climate&#x60; - mit_climate * &#x60;see&#x60; - see * &#x60;xpro&#x60; - xpro * &#x60;youtube&#x60; - youtube * &#x60;canvas&#x60; - canvas * &#x60;ovs&#x60; - ovs
     * @param {ContentFileWebHookRequestRequest} ContentFileWebHookRequestRequest
     * @param {string} [content_path]
     * @param {string | null} [course_id]
     * @param {string | null} [course_readable_id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksContentFilesCreate: async (
      source: WebhooksContentFilesCreateSourceEnum,
      ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest,
      content_path?: string,
      course_id?: string | null,
      course_readable_id?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists("webhooksContentFilesCreate", "source", source)
      // verify required parameter 'ContentFileWebHookRequestRequest' is not null or undefined
      assertParamExists(
        "webhooksContentFilesCreate",
        "ContentFileWebHookRequestRequest",
        ContentFileWebHookRequestRequest,
      )
      const localVarPath = `/api/v1/webhooks/content_files/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_path !== undefined) {
        localVarQueryParameter["content_path"] = content_path
      }

      if (course_id !== undefined) {
        localVarQueryParameter["course_id"] = course_id
      }

      if (course_readable_id !== undefined) {
        localVarQueryParameter["course_readable_id"] = course_readable_id
      }

      if (source !== undefined) {
        localVarQueryParameter["source"] = source
      }

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        ContentFileWebHookRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Webhook handler for ContentFile DELETE requests
     * @param {ContentFileWebHookRequestRequest} ContentFileWebHookRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksContentFilesDeleteCreate: async (
      ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ContentFileWebHookRequestRequest' is not null or undefined
      assertParamExists(
        "webhooksContentFilesDeleteCreate",
        "ContentFileWebHookRequestRequest",
        ContentFileWebHookRequestRequest,
      )
      const localVarPath = `/api/v1/webhooks/content_files/delete/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        ContentFileWebHookRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Generic webhook handler for pre-computed LearningResource batches delivered by the OL Data Platform (Dagster).  The request body is ``{\"resources\": [ ... ]}`` where each resource is a canonical LearningResource dict carrying at minimum ``readable_id``, ``etl_source`` and ``resource_type``. Resources are grouped by ``(etl_source, resource_type)`` and routed to the matching loader (``load_courses`` / ``load_programs`` / ``load_documents`` / ``load_videos``). Each loader performs a full sync for that source and upserts the OpenSearch index, so a batch must contain the authoritative set of resources for the (etl_source, resource_type) it represents. A pair listed in the optional ``sync`` array with no resources in the batch is pruned, unpublishing all of it. Resource types without a loader are logged and skipped rather than failing the whole batch.  A batch with a group the webhook shadows (ETLSourceOwnership.shadow) is a shadow run as a whole: each group is compared with what is stored (``learning_resources.etl.shadow``), nothing is written, and the response\'s ``shadow`` counts what each group\'s load would have changed. A video group the webhook owns is not compared in a shadow run, and its entry carries an ``error`` in place of the counts. A group the webhook neither owns nor shadows rejects the whole batch with 409.
     * @param {LearningResourceWebhookRequestRequest} LearningResourceWebhookRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksLearningResourcesCreate: async (
      LearningResourceWebhookRequestRequest: LearningResourceWebhookRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'LearningResourceWebhookRequestRequest' is not null or undefined
      assertParamExists(
        "webhooksLearningResourcesCreate",
        "LearningResourceWebhookRequestRequest",
        LearningResourceWebhookRequestRequest,
      )
      const localVarPath = `/api/v1/webhooks/learning_resources/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        LearningResourceWebhookRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Webhook handler for OVS video upserts and deletes from the dagster pipeline
     * @param {OVSVideoWebhookRequestRequest} [OVSVideoWebhookRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksOvsVideosCreate: async (
      OVSVideoWebhookRequestRequest?: OVSVideoWebhookRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/webhooks/ovs_videos/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        OVSVideoWebhookRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WebhooksApi - functional programming interface
 */
export const WebhooksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
  return {
    /**
     * Webhook handler for ContentFile updates
     * @param {WebhooksContentFilesCreateSourceEnum} source * &#x60;mit_edx&#x60; - mit_edx * &#x60;mitpe&#x60; - mitpe * &#x60;mitxonline&#x60; - mitxonline * &#x60;oll&#x60; - oll * &#x60;ocw&#x60; - ocw * &#x60;podcast&#x60; - podcast * &#x60;mit_climate&#x60; - mit_climate * &#x60;see&#x60; - see * &#x60;xpro&#x60; - xpro * &#x60;youtube&#x60; - youtube * &#x60;canvas&#x60; - canvas * &#x60;ovs&#x60; - ovs
     * @param {ContentFileWebHookRequestRequest} ContentFileWebHookRequestRequest
     * @param {string} [content_path]
     * @param {string | null} [course_id]
     * @param {string | null} [course_readable_id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhooksContentFilesCreate(
      source: WebhooksContentFilesCreateSourceEnum,
      ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest,
      content_path?: string,
      course_id?: string | null,
      course_readable_id?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WebhookResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.webhooksContentFilesCreate(
          source,
          ContentFileWebHookRequestRequest,
          content_path,
          course_id,
          course_readable_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebhooksApi.webhooksContentFilesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Webhook handler for ContentFile DELETE requests
     * @param {ContentFileWebHookRequestRequest} ContentFileWebHookRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhooksContentFilesDeleteCreate(
      ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ContentFileWebHookRequest>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.webhooksContentFilesDeleteCreate(
          ContentFileWebHookRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebhooksApi.webhooksContentFilesDeleteCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Generic webhook handler for pre-computed LearningResource batches delivered by the OL Data Platform (Dagster).  The request body is ``{\"resources\": [ ... ]}`` where each resource is a canonical LearningResource dict carrying at minimum ``readable_id``, ``etl_source`` and ``resource_type``. Resources are grouped by ``(etl_source, resource_type)`` and routed to the matching loader (``load_courses`` / ``load_programs`` / ``load_documents`` / ``load_videos``). Each loader performs a full sync for that source and upserts the OpenSearch index, so a batch must contain the authoritative set of resources for the (etl_source, resource_type) it represents. A pair listed in the optional ``sync`` array with no resources in the batch is pruned, unpublishing all of it. Resource types without a loader are logged and skipped rather than failing the whole batch.  A batch with a group the webhook shadows (ETLSourceOwnership.shadow) is a shadow run as a whole: each group is compared with what is stored (``learning_resources.etl.shadow``), nothing is written, and the response\'s ``shadow`` counts what each group\'s load would have changed. A video group the webhook owns is not compared in a shadow run, and its entry carries an ``error`` in place of the counts. A group the webhook neither owns nor shadows rejects the whole batch with 409.
     * @param {LearningResourceWebhookRequestRequest} LearningResourceWebhookRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhooksLearningResourcesCreate(
      LearningResourceWebhookRequestRequest: LearningResourceWebhookRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourceWebhookResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.webhooksLearningResourcesCreate(
          LearningResourceWebhookRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebhooksApi.webhooksLearningResourcesCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Webhook handler for OVS video upserts and deletes from the dagster pipeline
     * @param {OVSVideoWebhookRequestRequest} [OVSVideoWebhookRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhooksOvsVideosCreate(
      OVSVideoWebhookRequestRequest?: OVSVideoWebhookRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WebhookResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.webhooksOvsVideosCreate(
          OVSVideoWebhookRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebhooksApi.webhooksOvsVideosCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WebhooksApi - factory interface
 */
export const WebhooksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WebhooksApiFp(configuration)
  return {
    /**
     * Webhook handler for ContentFile updates
     * @param {WebhooksApiWebhooksContentFilesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksContentFilesCreate(
      requestParameters: WebhooksApiWebhooksContentFilesCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebhookResponse> {
      return localVarFp
        .webhooksContentFilesCreate(
          requestParameters.source,
          requestParameters.ContentFileWebHookRequestRequest,
          requestParameters.content_path,
          requestParameters.course_id,
          requestParameters.course_readable_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Webhook handler for ContentFile DELETE requests
     * @param {WebhooksApiWebhooksContentFilesDeleteCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksContentFilesDeleteCreate(
      requestParameters: WebhooksApiWebhooksContentFilesDeleteCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFileWebHookRequest> {
      return localVarFp
        .webhooksContentFilesDeleteCreate(
          requestParameters.ContentFileWebHookRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Generic webhook handler for pre-computed LearningResource batches delivered by the OL Data Platform (Dagster).  The request body is ``{\"resources\": [ ... ]}`` where each resource is a canonical LearningResource dict carrying at minimum ``readable_id``, ``etl_source`` and ``resource_type``. Resources are grouped by ``(etl_source, resource_type)`` and routed to the matching loader (``load_courses`` / ``load_programs`` / ``load_documents`` / ``load_videos``). Each loader performs a full sync for that source and upserts the OpenSearch index, so a batch must contain the authoritative set of resources for the (etl_source, resource_type) it represents. A pair listed in the optional ``sync`` array with no resources in the batch is pruned, unpublishing all of it. Resource types without a loader are logged and skipped rather than failing the whole batch.  A batch with a group the webhook shadows (ETLSourceOwnership.shadow) is a shadow run as a whole: each group is compared with what is stored (``learning_resources.etl.shadow``), nothing is written, and the response\'s ``shadow`` counts what each group\'s load would have changed. A video group the webhook owns is not compared in a shadow run, and its entry carries an ``error`` in place of the counts. A group the webhook neither owns nor shadows rejects the whole batch with 409.
     * @param {WebhooksApiWebhooksLearningResourcesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksLearningResourcesCreate(
      requestParameters: WebhooksApiWebhooksLearningResourcesCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourceWebhookResponse> {
      return localVarFp
        .webhooksLearningResourcesCreate(
          requestParameters.LearningResourceWebhookRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Webhook handler for OVS video upserts and deletes from the dagster pipeline
     * @param {WebhooksApiWebhooksOvsVideosCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksOvsVideosCreate(
      requestParameters: WebhooksApiWebhooksOvsVideosCreateRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebhookResponse> {
      return localVarFp
        .webhooksOvsVideosCreate(
          requestParameters.OVSVideoWebhookRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for webhooksContentFilesCreate operation in WebhooksApi.
 */
export interface WebhooksApiWebhooksContentFilesCreateRequest {
  /**
   * * &#x60;mit_edx&#x60; - mit_edx * &#x60;mitpe&#x60; - mitpe * &#x60;mitxonline&#x60; - mitxonline * &#x60;oll&#x60; - oll * &#x60;ocw&#x60; - ocw * &#x60;podcast&#x60; - podcast * &#x60;mit_climate&#x60; - mit_climate * &#x60;see&#x60; - see * &#x60;xpro&#x60; - xpro * &#x60;youtube&#x60; - youtube * &#x60;canvas&#x60; - canvas * &#x60;ovs&#x60; - ovs
   */
  readonly source: WebhooksContentFilesCreateSourceEnum

  readonly ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest

  readonly content_path?: string

  readonly course_id?: string | null

  readonly course_readable_id?: string | null
}

/**
 * Request parameters for webhooksContentFilesDeleteCreate operation in WebhooksApi.
 */
export interface WebhooksApiWebhooksContentFilesDeleteCreateRequest {
  readonly ContentFileWebHookRequestRequest: ContentFileWebHookRequestRequest
}

/**
 * Request parameters for webhooksLearningResourcesCreate operation in WebhooksApi.
 */
export interface WebhooksApiWebhooksLearningResourcesCreateRequest {
  readonly LearningResourceWebhookRequestRequest: LearningResourceWebhookRequestRequest
}

/**
 * Request parameters for webhooksOvsVideosCreate operation in WebhooksApi.
 */
export interface WebhooksApiWebhooksOvsVideosCreateRequest {
  readonly OVSVideoWebhookRequestRequest?: OVSVideoWebhookRequestRequest
}

/**
 * WebhooksApi - object-oriented interface
 */
export class WebhooksApi extends BaseAPI {
  /**
   * Webhook handler for ContentFile updates
   * @param {WebhooksApiWebhooksContentFilesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public webhooksContentFilesCreate(
    requestParameters: WebhooksApiWebhooksContentFilesCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebhooksApiFp(this.configuration)
      .webhooksContentFilesCreate(
        requestParameters.source,
        requestParameters.ContentFileWebHookRequestRequest,
        requestParameters.content_path,
        requestParameters.course_id,
        requestParameters.course_readable_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Webhook handler for ContentFile DELETE requests
   * @param {WebhooksApiWebhooksContentFilesDeleteCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public webhooksContentFilesDeleteCreate(
    requestParameters: WebhooksApiWebhooksContentFilesDeleteCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebhooksApiFp(this.configuration)
      .webhooksContentFilesDeleteCreate(
        requestParameters.ContentFileWebHookRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Generic webhook handler for pre-computed LearningResource batches delivered by the OL Data Platform (Dagster).  The request body is ``{\"resources\": [ ... ]}`` where each resource is a canonical LearningResource dict carrying at minimum ``readable_id``, ``etl_source`` and ``resource_type``. Resources are grouped by ``(etl_source, resource_type)`` and routed to the matching loader (``load_courses`` / ``load_programs`` / ``load_documents`` / ``load_videos``). Each loader performs a full sync for that source and upserts the OpenSearch index, so a batch must contain the authoritative set of resources for the (etl_source, resource_type) it represents. A pair listed in the optional ``sync`` array with no resources in the batch is pruned, unpublishing all of it. Resource types without a loader are logged and skipped rather than failing the whole batch.  A batch with a group the webhook shadows (ETLSourceOwnership.shadow) is a shadow run as a whole: each group is compared with what is stored (``learning_resources.etl.shadow``), nothing is written, and the response\'s ``shadow`` counts what each group\'s load would have changed. A video group the webhook owns is not compared in a shadow run, and its entry carries an ``error`` in place of the counts. A group the webhook neither owns nor shadows rejects the whole batch with 409.
   * @param {WebhooksApiWebhooksLearningResourcesCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public webhooksLearningResourcesCreate(
    requestParameters: WebhooksApiWebhooksLearningResourcesCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebhooksApiFp(this.configuration)
      .webhooksLearningResourcesCreate(
        requestParameters.LearningResourceWebhookRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Webhook handler for OVS video upserts and deletes from the dagster pipeline
   * @param {WebhooksApiWebhooksOvsVideosCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public webhooksOvsVideosCreate(
    requestParameters: WebhooksApiWebhooksOvsVideosCreateRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return WebhooksApiFp(this.configuration)
      .webhooksOvsVideosCreate(
        requestParameters.OVSVideoWebhookRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const WebhooksContentFilesCreateSourceEnum = {
  MitEdx: "mit_edx",
  Mitpe: "mitpe",
  Mitxonline: "mitxonline",
  Oll: "oll",
  Ocw: "ocw",
  Podcast: "podcast",
  MitClimate: "mit_climate",
  See: "see",
  Xpro: "xpro",
  Youtube: "youtube",
  Canvas: "canvas",
  Ovs: "ovs",
} as const
export type WebhooksContentFilesCreateSourceEnum =
  (typeof WebhooksContentFilesCreateSourceEnum)[keyof typeof WebhooksContentFilesCreateSourceEnum]

/**
 * WebsiteContentApi - axios parameter creator
 */
export const WebsiteContentApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {WebsiteContentRequest} WebsiteContentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentCreate: async (
      WebsiteContentRequest: WebsiteContentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'WebsiteContentRequest' is not null or undefined
      assertParamExists(
        "websiteContentCreate",
        "WebsiteContentRequest",
        WebsiteContentRequest,
      )
      const localVarPath = `/api/v1/website_content/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        WebsiteContentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentDestroy: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("websiteContentDestroy", "id", id)
      const localVarPath = `/api/v1/website_content/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {string} identifier Numeric ID or slug of the content item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentDetailRetrieve: async (
      identifier: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'identifier' is not null or undefined
      assertParamExists(
        "websiteContentDetailRetrieve",
        "identifier",
        identifier,
      )
      const localVarPath =
        `/api/v1/website_content/detail/{identifier}/`.replace(
          "{identifier}",
          encodeURIComponent(String(identifier)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {WebsiteContentListContentTypeEnum} [content_type] Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
     * @param {boolean} [draft] Filter to show only draft (unpublished) items
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentList: async (
      content_type?: WebsiteContentListContentTypeEnum,
      draft?: boolean,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/website_content/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (content_type !== undefined) {
        localVarQueryParameter["content_type"] = content_type
      }

      if (draft !== undefined) {
        localVarQueryParameter["draft"] = draft
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update a content item
     * @summary Update
     * @param {number} id A unique integer value identifying this website content.
     * @param {PatchedWebsiteContentRequest} [PatchedWebsiteContentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentPartialUpdate: async (
      id: number,
      PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("websiteContentPartialUpdate", "id", id)
      const localVarPath = `/api/v1/website_content/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedWebsiteContentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("websiteContentRetrieve", "id", id)
      const localVarPath = `/api/v1/website_content/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WebsiteContentApi - functional programming interface
 */
export const WebsiteContentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    WebsiteContentApiAxiosParamCreator(configuration)
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {WebsiteContentRequest} WebsiteContentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentCreate(
      WebsiteContentRequest: WebsiteContentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentCreate(
          WebsiteContentRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentDestroy(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentDestroy(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {string} identifier Numeric ID or slug of the content item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentDetailRetrieve(
      identifier: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentDetailRetrieve(
          identifier,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentDetailRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {WebsiteContentListContentTypeEnum} [content_type] Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
     * @param {boolean} [draft] Filter to show only draft (unpublished) items
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentList(
      content_type?: WebsiteContentListContentTypeEnum,
      draft?: boolean,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedWebsiteContentList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentList(
          content_type,
          draft,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Update a content item
     * @summary Update
     * @param {number} id A unique integer value identifying this website content.
     * @param {PatchedWebsiteContentRequest} [PatchedWebsiteContentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentPartialUpdate(
      id: number,
      PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentPartialUpdate(
          id,
          PatchedWebsiteContentRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this website content.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async websiteContentRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebsiteContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.websiteContentRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WebsiteContentApi.websiteContentRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WebsiteContentApi - factory interface
 */
export const WebsiteContentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WebsiteContentApiFp(configuration)
  return {
    /**
     * Create a new content item
     * @summary Create
     * @param {WebsiteContentApiWebsiteContentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentCreate(
      requestParameters: WebsiteContentApiWebsiteContentCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .websiteContentCreate(requestParameters.WebsiteContentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete a content item
     * @summary Destroy
     * @param {WebsiteContentApiWebsiteContentDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentDestroy(
      requestParameters: WebsiteContentApiWebsiteContentDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .websiteContentDestroy(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a content item by numeric ID or slug
     * @summary Retrieve by ID or slug
     * @param {WebsiteContentApiWebsiteContentDetailRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentDetailRetrieve(
      requestParameters: WebsiteContentApiWebsiteContentDetailRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .websiteContentDetailRetrieve(requestParameters.identifier, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a paginated list of website content items
     * @summary List
     * @param {WebsiteContentApiWebsiteContentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentList(
      requestParameters: WebsiteContentApiWebsiteContentListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedWebsiteContentList> {
      return localVarFp
        .websiteContentList(
          requestParameters.content_type,
          requestParameters.draft,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Update a content item
     * @summary Update
     * @param {WebsiteContentApiWebsiteContentPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentPartialUpdate(
      requestParameters: WebsiteContentApiWebsiteContentPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .websiteContentPartialUpdate(
          requestParameters.id,
          requestParameters.PatchedWebsiteContentRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single content item
     * @summary Retrieve
     * @param {WebsiteContentApiWebsiteContentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    websiteContentRetrieve(
      requestParameters: WebsiteContentApiWebsiteContentRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WebsiteContent> {
      return localVarFp
        .websiteContentRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for websiteContentCreate operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentCreateRequest {
  readonly WebsiteContentRequest: WebsiteContentRequest
}

/**
 * Request parameters for websiteContentDestroy operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentDestroyRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number
}

/**
 * Request parameters for websiteContentDetailRetrieve operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentDetailRetrieveRequest {
  /**
   * Numeric ID or slug of the content item
   */
  readonly identifier: string
}

/**
 * Request parameters for websiteContentList operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentListRequest {
  /**
   * Filter by content type  * &#x60;news&#x60; - News * &#x60;article&#x60; - Article
   */
  readonly content_type?: WebsiteContentListContentTypeEnum

  /**
   * Filter to show only draft (unpublished) items
   */
  readonly draft?: boolean

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for websiteContentPartialUpdate operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentPartialUpdateRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number

  readonly PatchedWebsiteContentRequest?: PatchedWebsiteContentRequest
}

/**
 * Request parameters for websiteContentRetrieve operation in WebsiteContentApi.
 */
export interface WebsiteContentApiWebsiteContentRetrieveRequest {
  /**
   * A unique integer value identifying this website content.
   */
  readonly id: number
}

/**
 * WebsiteContentApi - object-oriented interface
 */
export class WebsiteContentApi extends BaseAPI {
  /**
   * Create a new content item
   * @summary Create
   * @param {WebsiteContentApiWebsiteContentCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentCreate(
    requestParameters: WebsiteContentApiWebsiteContentCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentCreate(requestParameters.WebsiteContentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete a content item
   * @summary Destroy
   * @param {WebsiteContentApiWebsiteContentDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentDestroy(
    requestParameters: WebsiteContentApiWebsiteContentDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentDestroy(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a content item by numeric ID or slug
   * @summary Retrieve by ID or slug
   * @param {WebsiteContentApiWebsiteContentDetailRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentDetailRetrieve(
    requestParameters: WebsiteContentApiWebsiteContentDetailRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentDetailRetrieve(requestParameters.identifier, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a paginated list of website content items
   * @summary List
   * @param {WebsiteContentApiWebsiteContentListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentList(
    requestParameters: WebsiteContentApiWebsiteContentListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentList(
        requestParameters.content_type,
        requestParameters.draft,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update a content item
   * @summary Update
   * @param {WebsiteContentApiWebsiteContentPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentPartialUpdate(
    requestParameters: WebsiteContentApiWebsiteContentPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentPartialUpdate(
        requestParameters.id,
        requestParameters.PatchedWebsiteContentRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single content item
   * @summary Retrieve
   * @param {WebsiteContentApiWebsiteContentRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public websiteContentRetrieve(
    requestParameters: WebsiteContentApiWebsiteContentRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WebsiteContentApiFp(this.configuration)
      .websiteContentRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const WebsiteContentListContentTypeEnum = {
  Article: "article",
  News: "news",
} as const
export type WebsiteContentListContentTypeEnum =
  (typeof WebsiteContentListContentTypeEnum)[keyof typeof WebsiteContentListContentTypeEnum]
